import React, { useEffect, useState, useRef, useMemo, useLayoutEffect } from "react";
import { createPortal } from "react-dom";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import axios from 'axios';
import "./Tasks.css";
import EmployeeNavbar from "../Layout/EmployeeNavbar";
import ManagerNavbar from "../Layout/ManagerNavbar";
import AdminNavbar from "../Layout/AdminNavbar";
import API_BASE_URL from "../config";
import { format, formatDistanceToNow } from "date-fns";
import EmojiPicker from "emoji-picker-react";
import NewCommentEditor from "../editors/NewCommentEditor";
import NewDescriptionEditor from "../editors/NewDescriptionEditor";

const Tasks = () => {
    // const [editingStatus, setEditingStatus] = useState(false);
    // const [worklogsCollapsed, setWorklogsCollapsed] = useState(false);

    const [copiedUI, setCopiedUI] = useState(false);
    const [employees, setEmployees] = useState([]);
    const [tasks, setTasks] = useState([]);
    const [loading, setLoading] = useState(true);
    const [taskError, setTaskError] = useState("");
    const [activeTask, setActiveTask] = useState(null);
    const [mentions, setMentions] = useState([]);
    const [mentionableUsers, setMentionableUsers] = useState([]);
    const [attachments, setAttachments] = useState([]);
    const [showSuggestions, setShowSuggestions] = useState(false);
    const [mentionPopupPos, setMentionPopupPos] = useState({ top: 0, left: 0 });
    const [emojiPopupPos, setEmojiPopupPos] = useState({ top: 0, left: 0 });
    const [activeEmojiHandler, setActiveEmojiHandler] = useState(null); // which onEmojiClick to use
    const [showEmojiPortal, setShowEmojiPortal] = useState(false);
    const [filteredUsers, setFilteredUsers] = useState([]);
    const [comments, setComments] = useState([]);
    const [editingCommentId, setEditingCommentId] = useState(null);
    const [editContent, setEditContent] = useState("");
    const [replies, setReplies] = useState([]); // store replies for comments
    const [replyToCommentId, setReplyToCommentId] = useState(null); // which comment is being replied to
    const [replyContent, setReplyContent] = useState(""); // content of the reply
    const [worklogs, setWorklogs] = useState([]);
    const [showLogForm, setShowLogForm] = useState(false);
    const [logDescription, setLogDescription] = useState("");
    const [logHours, setLogHours] = useState("");
    const [logDate, setLogDate] = useState(new Date().toISOString().split("T")[0]);
    const [billingType, setBillingType] = useState("billable");
    const [logAnother, setLogAnother] = useState(false);
    const [editWorklogId, setEditWorklogId] = useState(null);
    const [selectedDate, setSelectedDate] = useState(new Date());
    const [searchQuery, setSearchQuery] = useState("");
    const [showSearchDropdown, setShowSearchDropdown] = useState(false);
    const searchInputRef = useRef(null);
    const searchDropdownRef = useRef(null);
    const [filterType, setFilterType] = useState("all");
    const [selectedProject, setSelectedProject] = useState(() => {
        return localStorage.getItem("selectedProject") || "all";
    });
    const [projects, setProjects] = useState([]);
    const [projectTaskCounts, setProjectTaskCounts] = useState({});
    const [savedRange, setSavedRange] = useState(null);
    const savedRangeRef = useRef(null);
    const selectRef = useRef(null);
    const [newTaskParent, setNewTaskParent] = useState("");
    const [parentTasks, setParentTasks] = useState([]);
    const [commentPage, setCommentPage] = useState(0);
    const [hasMoreComments, setHasMoreComments] = useState(false);
    const [isLoadingMore, setIsLoadingMore] = useState(false);
    const [commentsLoading, setCommentsLoading] = useState(false);
    const COMMENTS_PAGE_SIZE = 3;

    const [showFilter, setShowFilter] = useState(false);
    const [activeFilter, setActiveFilter] = useState("Labels");
    const filterRef = useRef(null);

    const [activeMentionIndex, setActiveMentionIndex] = useState(0);


    const [editingParentId, setEditingParentId] = useState("");

    const [showTablePicker, setShowTablePicker] = useState(false);
    const [showEditTablePicker, setShowEditTablePicker] = useState(false);
    const [showDescTablePicker, setShowDescTablePicker] = useState(false);
    const [showEditDescTablePicker, setShowEditDescTablePicker] = useState(false);
    const [tableHover, setTableHover] = useState({ rows: 0, cols: 0 });
    const tablePickerRef = useRef(null);


    const [logHoursDecimal, setLogHoursDecimal] = useState(0); // numeric hours used when saving
    const [logHoursDisplay, setLogHoursDisplay] = useState(""); //  readable e.g. "1h 30m"
    const [logHoursRaw, setLogHoursRaw] = useState("");



    const [showNotifications, setShowNotifications] = useState(false);
    const [auditList, setAuditList] = useState([]);
    const notificationRef = useRef(null); // dropdown
    const bellRef = useRef(null);         // bell button

    const [activeCommentTab, setActiveCommentTab] = useState("comments");


    const replyEditorRef = useRef(null);
    const [replyAttachments, setReplyAttachments] = useState([]); // files for this inline reply
    const [replyShowSuggestions, setReplyShowSuggestions] = useState(false);
    const [collapsedGroups, setCollapsedGroups] = useState({});

    const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
    const [showMoreAssignees, setShowMoreAssignees] = useState(false);
    const moreAssigneeRef = useRef(null);


    //const [monthFilter, setMonthFilter] = useState("THIS_MONTH");
    const [dateFilters, setDateFilters] = useState(() => {
        const saved = localStorage.getItem("taskDateFilters");
        return saved
            ? JSON.parse(saved)
            : {
                fromDate: "",
                toDate: "",
                monthFilter: "THIS_MONTH",
            };
    });

    const { fromDate, toDate, monthFilter } = dateFilters;


    const [showLinkEditor, setShowLinkEditor] = useState(false);
    const [activeLinkEl, setActiveLinkEl] = useState(null);
    const [linkText, setLinkText] = useState("");
    const [linkHref, setLinkHref] = useState("");
    const [activeEditor, setActiveEditor] = useState("new"); // "new" | "edit"
    const [isCommentSubmitting, setIsCommentSubmitting] = useState(false);
    const [isFetchingComments, setIsFetchingComments] = useState(false);


    // Create Task modal states
    const [showCreateTask, setShowCreateTask] = useState(false);
    const [newTaskTitle, setNewTaskTitle] = useState("");
    const [newTaskDescription, setNewTaskDescription] = useState("");
    const [newTaskProject, setNewTaskProject] = useState("");
    const [newTaskAssignee, setNewTaskAssignee] = useState("");
    const [newTaskReporter, setNewTaskReporter] = useState("");
    const [newTaskDueDate, setNewTaskDueDate] = useState("");
    const [newTaskPriority, setNewTaskPriority] = useState("MEDIUM");
    const [newTaskType, setNewTaskType] = useState("Task");
    const [newTaskEstimatedTime, setNewTaskEstimatedTime] = useState("");
    const [newTaskTotalTime, setNewTaskTotalTime] = useState("");
    const [newTaskTeam, setNewTaskTeam] = useState("");
    const [teams, setTeams] = useState([]);
    const [editField, setEditField] = useState(null);
    const [editedTask, setEditedTask] = useState(activeTask);
    const [taskAttachments, setTaskAttachments] = useState([]);
    const [previewImages, setPreviewImages] = useState([]);
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const [projectEmployees, setProjectEmployees] = useState([]);
    const [collapsedProjects, setCollapsedProjects] = useState({});
    const loggedInEmployeeId = localStorage.getItem("employeeId");
    const loggedInUserId = localStorage.getItem("userId");
    const [showAllAttachments, setShowAllAttachments] = useState(false);
    const [newTaskExternalUrl, setNewTaskExternalUrl] = useState("");
    const [isCreating, setIsCreating] = useState(false);
    const [taskWorklogs, setTaskWorklogs] = useState([]);

    const taskDescEditorRef = useRef(null);
    const [taskDescAttachments, setTaskDescAttachments] = useState([]);
    const [showEmojiPicker, setShowEmojiPicker] = useState(false);
    const [showEmojiPickern, setShowEmojiPickern] = useState(false);
    const [showEmojiPickers, setShowEmojiPickers] = useState(false);
    const [showEmojiPickerss, setShowEmojiPickerss] = useState(false);
    const emojiPickerRef = useRef(null);
    const emojiButtonRef = useRef(null);
    const editDescEditorRef = useRef(null);
    const activeCommentEditorRef = useRef(null);

    const [showProjects, setShowProjects] = useState(false); // default closed


    const [showGroupMenu, setShowGroupMenu] = useState(false);


    const [teamworkConfigs, setTeamworkConfigs] = useState([]);
    const lastComment = comments.length > 0 ? comments[0] : null;


    const [filters, setFilters] = useState(() => {
        const saved = localStorage.getItem("taskFilters");
        return saved
            ? JSON.parse(saved)
            : {
                parent: [],
                taskType: [],
                status: [],
                priority: [],
            };
    });

    const [selectedAssigneeIds, setSelectedAssigneeIds] = useState(() => {
        const saved = localStorage.getItem("taskAssignees");
        return saved ? JSON.parse(saved) : [];
    });


    // 🔹 Equals / Not Equals condition per filter
    const [filterCondition, setFilterCondition] = useState(() => {
        const saved = localStorage.getItem("taskFilterCondition");
        return saved
            ? JSON.parse(saved)
            : {
                Parent: "equals",
                Sprint: "equals",
                Assignee: "equals",
                "Task type": "equals",
                Status: "equals",
                Priority: "equals",
            };
    });

    const saveCursor = () => {
        const sel = window.getSelection();
        if (sel.rangeCount > 0) {
            savedRangeRef.current = sel.getRangeAt(0);
        }
    };





    const loggedEmployeeId = Number(localStorage.getItem("employeeId"));

    const roles = useMemo(
        () => JSON.parse(localStorage.getItem("roles") || "[]"),
        []
    );

    const role = roles[0]; // first role

    const effectiveRole = useMemo(() => {
        if (roles.includes("ROLE_ADMIN")) return "ROLE_ADMIN";
        if (roles.includes("ROLE_MANAGER")) return "ROLE_MANAGER";
        return "ROLE_USER";
    }, [roles]);



    // safe numeric values (in hours)
    const estimatedHrs = Number(activeTask?.estimatedTime ?? 0);

    const loggedHrs = Array.isArray(taskWorklogs)
        ? taskWorklogs
            .filter(w => Number(w.employeeId) === Number(loggedEmployeeId))
            .reduce((sum, w) => sum + Number(w.hours || 0), 0)
        : 0;

    const employeeLogs = useMemo(() => {
        if (!Array.isArray(taskWorklogs)) return [];

        const grouped = {};

        taskWorklogs.forEach(w => {
            if (!w.employeeId) return;

            if (!grouped[w.employeeId]) {
                grouped[w.employeeId] = {
                    id: w.employeeId,
                    name: w.employeeName || "Unknown",
                    photo: w.employeePhotoPath,
                    hours: 0
                };
            }

            grouped[w.employeeId].hours += Number(w.hours || 0);
        });

        return Object.values(grouped);
    }, [taskWorklogs]);

    const remainingHrs = Math.max(0, estimatedHrs - loggedHrs);
    const [timeStackOpen, setTimeStackOpen] = useState(false);
    // Sum of hours logged by all employees on the task
    const [taskTotalHrs, setTaskTotalHrs] = useState(null); // null = unknown / not fetched


    const [selectedAssigneeId, setSelectedAssigneeId] = useState(null);

    const resetCreateTaskForm = () => {
        setNewTaskTitle("");
        setNewTaskProject("");
        setNewTaskTeam("");
        setNewTaskType("Task");
        setNewTaskDescription("");
        setNewTaskAssignee("");
        setNewTaskReporter("");
        setNewTaskParent("");
        setNewTaskDueDate("");
        setNewTaskPriority("MEDIUM");
        setNewTaskEstimatedTime("");
        setNewTaskExternalUrl("");
    };


    const execDesc = (cmd, value = null) => {
        taskDescEditorRef.current?.focus();
        document.execCommand(cmd, false, value);
    };


    const insertEmoji = (emojiData) => {
        const emoji = emojiData.emoji;
        const el =
            editField === "description"
                ? editDescEditorRef.current
                : taskDescEditorRef.current;
        if (!el) return;

        el.focus();

        const sel = window.getSelection();
        sel.removeAllRanges();

        if (savedRange) {
            sel.addRange(savedRange);
        }

        const range = sel.getRangeAt(0);
        range.deleteContents();

        const node = document.createTextNode(emoji);
        range.insertNode(node);

        range.setStartAfter(node);
        range.collapse(true);

        sel.removeAllRanges();
        sel.addRange(range);

        setNewTaskDescription(el.innerHTML);
    };


    const [filterSearch, setFilterSearch] = useState("");

    // Reply editing state
    const [editingReplyId, setEditingReplyId] = useState(null);
    const [replyEditContent, setReplyEditContent] = useState("");
    const [replyEditAttachments, setReplyEditAttachments] = useState([]); // files/base64 for the reply being edited
    const replyEditRef = useRef(null);

    const groupRef = useRef(null);

    //const [fromDate, setFromDate] = useState("");
    //const [toDate, setToDate] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const logsPerPage = 3;

    const editorRef = useRef(null);
    const editRef = useRef(null);
    const navigate = useNavigate();
    const location = useLocation();

    const token = localStorage.getItem("token");
    const employeeId =
        location.state?.employeeId || localStorage.getItem("employeeId");


    const isWithinRange = (taskDate) => {
        if (!taskDate) return false;

        // normalize task date (YYYY-MM-DD only)
        const taskDay = new Date(taskDate);
        taskDay.setHours(0, 0, 0, 0);

        // FROM date
        if (fromDate) {
            const from = new Date(fromDate);
            from.setHours(0, 0, 0, 0);
            if (taskDay < from) return false;
        }

        // TO date (IMPORTANT: end of day)
        if (toDate) {
            const to = new Date(toDate);
            to.setHours(23, 59, 59, 999);
            if (new Date(taskDate) > to) return false;
        }

        // Month filter
        if (monthFilter === "THIS_MONTH") {
            const now = new Date();
            return (
                taskDay.getMonth() === now.getMonth() &&
                taskDay.getFullYear() === now.getFullYear()
            );
        }

        if (monthFilter === "LAST_MONTH") {
            const now = new Date();
            const lastMonth = new Date(now.getFullYear(), now.getMonth() - 1, 1);
            return (
                taskDay.getMonth() === lastMonth.getMonth() &&
                taskDay.getFullYear() === lastMonth.getFullYear()
            );
        }

        return true;
    };


    const openLinkEditor = (linkEl) => {
        if (!linkEl) return;

        const href = linkEl.getAttribute("href") || "";
        const isNew = linkEl.getAttribute("data-new-link") === "true";

        setActiveLinkEl(linkEl);

        // 🔥 KEY CHANGE
        setLinkText(isNew ? "" : (linkEl.textContent || ""));
        setLinkHref(href);

        setShowLinkEditor(true);

        // remove flag so future edits behave normally
        linkEl.removeAttribute("data-new-link");
    };




    const applyLinkEdit = () => {
        if (!activeLinkEl) return;

        activeLinkEl.innerText = linkText || linkHref;
        activeLinkEl.setAttribute("href", linkHref);

        setShowLinkEditor(false);
        setActiveLinkEl(null);

        // keep editor content in sync
        const editor =
            activeEditor === "edit" ? editRef.current : editorRef.current;

        if (editor) {
            setEditContent(editor.innerHTML);
        }
    };


    const moveCaretToEnd = (el) => {
        if (!el) return;
        const range = document.createRange();
        range.selectNodeContents(el);
        range.collapse(false);
        const sel = window.getSelection();
        sel.removeAllRanges();
        sel.addRange(range);
    };


    function handleCommentImageClick(e, comment) {
        // if the click landed on an <img> (or inside an anchor that wraps an <img>), find the actual <img>
        let target = e.target;
        if (!target) return;

        // if link wrapped the image, prefer the <img> child
        if (target.tagName === "A") {
            const imgChild = target.querySelector("img");
            if (imgChild) target = imgChild;
        }

        if (target.tagName !== "IMG") return; // ignore non-image clicks

        // Prevent other click handlers (like collapse toggles) from firing
        e.stopPropagation();

        // current comment DOM node (the container where you set innerHTML)
        const container = e.currentTarget; // safe: this is the comment-body DOM element

        // collect all images inside this comment in document order
        const imgs = Array.from(container.querySelectorAll("img")).map((img) => img.src).filter(Boolean);

        if (!imgs.length) return;

        // determine the index of the clicked image
        const clickedSrc = target.src;
        const idx = imgs.indexOf(clickedSrc);
        const realIndex = idx === -1 ? 0 : idx;

        // open your existing preview state
        setPreviewImages(imgs);
        setCurrentImageIndex(realIndex);
    }


    function handleDescriptionImageClick(e) {
        let target = e.target;
        if (!target) return;

        if (target.tagName !== "IMG") return;

        e.stopPropagation();

        const container = e.currentTarget;

        const imgs = Array.from(container.querySelectorAll("img"))
            .map(img => img.src)
            .filter(Boolean);

        if (!imgs.length) return;

        const idx = imgs.indexOf(target.src);

        setPreviewImages(imgs);
        setCurrentImageIndex(idx === -1 ? 0 : idx);
    }

    // 🔹 Fetch teams for a given project (used in Edit Task → Team)
    const fetchTeamsForProject = async (projectId) => {
        if (!projectId) {
            setTeams([]);
            return;
        }

        try {
            const res = await fetch(
                `${API_BASE_URL}/api/manageteam/project/${projectId}/teams`,
                {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("token"),
                    },
                }
            );

            if (!res.ok) {
                console.error("Failed to fetch teams for project:", projectId);
                setTeams([]);
                return;
            }

            const data = await res.json();
            setTeams(Array.isArray(data) ? data : []);
        } catch (err) {
            console.error("Error fetching teams:", err);
            setTeams([]);
        }
    };



    const applyLocalTaskUpdate = (updates) => {
        setActiveTask(prev => {
            if (!prev) return prev;

            return {
                ...prev,
                ...updates,

                // 🔥 CRITICAL: never lose parent unless explicitly changed
                parent: updates.hasOwnProperty("parent")
                    ? updates.parent
                    : prev.parent,
            };
        });
    };



    const normalize = (v = "") => v.toString().trim().toLowerCase();

    // ── Global task search results (Jira-style dropdown) ──────────
    // searchResults is populated by the API search useEffect below
    const [searchResults, setSearchResults] = useState([]);

    // ── Search highlight helper ──────────────────────────────────
    // Wraps matching text in a yellow highlight span (safe HTML)
    const highlightText = (text, query) => {
        if (!query || !text) return text;
        const escaped = query.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
        const regex = new RegExp(`(${escaped})`, "gi");
        return text.replace(regex, '<mark class="tp-search-highlight">$1</mark>');
    };





    useEffect(() => {
        if (editField === "description" && editDescEditorRef.current) {
            editDescEditorRef.current.innerHTML = editedTask?.description || "";
        }
    }, [editField]);


    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                emojiPickerRef.current &&
                !emojiPickerRef.current.contains(event.target) &&
                emojiButtonRef.current &&
                !emojiButtonRef.current.contains(event.target)
            ) {
                setShowEmojiPicker(false);
                setShowEmojiPickern(false);
                setShowEmojiPickers(false);
                setShowEmojiPickerss(false);
                setShowEmojiPortal(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);


    useEffect(() => {
        setFilterSearch("");
    }, [activeFilter]);

    useEffect(() => {
        if (activeTask) {
            // clone to avoid mutating the original object
            setEditedTask({ ...activeTask });
        } else {
            setEditedTask(null);
        }
    }, [activeTask]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                groupRef.current &&
                !groupRef.current.contains(event.target)
            ) {
                setShowGroupMenu(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);


    useEffect(() => {
        localStorage.setItem("taskFilters", JSON.stringify(filters));
    }, [filters]);

    useEffect(() => {
        localStorage.setItem(
            "taskAssignees",
            JSON.stringify(selectedAssigneeIds)
        );
    }, [selectedAssigneeIds]);

    useEffect(() => {
        localStorage.setItem(
            "taskFilterCondition",
            JSON.stringify(filterCondition)
        );
    }, [filterCondition]);



    useEffect(() => {
        if (!tasks.length) return;

        const params = new URLSearchParams(location.search);
        const taskIdFromQuery = params.get("taskId");

        // If no taskId → clear previous task
        if (!taskIdFromQuery) {
            setActiveTask(null);
            localStorage.removeItem("activeTaskId");
            localStorage.removeItem("activeTaskObj");
            return;
        }

        const taskToOpen = tasks.find(
            t => String(t.id) === String(taskIdFromQuery)
        );

        if (taskToOpen) {
            // Ignore project mismatch — URL should win
            openTask(taskToOpen);

            // Save fresh
            localStorage.setItem("activeTaskId", taskToOpen.id);
            // Strip heavy fields (attachments, base64 images) before storing
            try {
                const slim = { ...taskToOpen };
                delete slim.attachments;
                //delete slim.description; // can contain base64 images
                localStorage.setItem("activeTaskObj", JSON.stringify(slim));
            } catch (_) {
                // If still too large, just store the ID — we can refetch
                localStorage.removeItem("activeTaskObj");
            }

        } else {
            // Task not found → clear old
            setActiveTask(null);
            localStorage.removeItem("activeTaskId");
            localStorage.removeItem("activeTaskObj");

            setTaskError("Task not found or access denied");
        }

    }, [tasks, location.search]);



    const insertCommentEmoji = (emojiData) => {
        const emoji = emojiData.emoji;

        const el = activeCommentEditorRef.current;
        if (!el) return;

        el.focus();

        const sel = window.getSelection();

        if (savedRange) {
            sel.removeAllRanges();
            sel.addRange(savedRange);
        }

        if (!sel.rangeCount) return;

        const range = sel.getRangeAt(0);

        range.deleteContents();

        const node = document.createTextNode(emoji);
        range.insertNode(node);

        range.setStartAfter(node);
        range.collapse(true);

        sel.removeAllRanges();
        sel.addRange(range);

        saveCaret();
    };



    const getDraftKey = (taskId) => `comment_draft_task_${taskId}`;




    useEffect(() => {
        if (showSuggestions) {
            setActiveMentionIndex(0);
        }
    }, [showSuggestions, filteredUsers]);


    useEffect(() => {
        const handleClickOutside = (e) => {
            if (
                moreAssigneeRef.current &&
                !moreAssigneeRef.current.contains(e.target)
            ) {
                setShowMoreAssignees(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);


    useEffect(() => {
        if (showSuggestions) {
            setActiveMentionIndex(0);
        }
    }, [showSuggestions, filteredUsers]);


    // ── Close search dropdown on outside click ──
    useEffect(() => {
        const handler = (e) => {
            if (
                searchDropdownRef.current && !searchDropdownRef.current.contains(e.target) &&
                searchInputRef.current && !searchInputRef.current.contains(e.target)
            ) {
                setShowSearchDropdown(false);
            }
        };
        document.addEventListener("mousedown", handler);
        return () => document.removeEventListener("mousedown", handler);
    }, []);

    // ── API-powered global task search (debounced 250ms) ──
    useEffect(() => {
        if (!searchQuery.trim()) {
            setSearchResults([]);
            return;
        }

        const timeout = setTimeout(async () => {
            try {
                const params = new URLSearchParams({
                    q: searchQuery,
                    limit: 8,
                    projectId: "all" // ✅ always all projects
                });

                // Scope by employee for ROLE_USER
                if (effectiveRole === "ROLE_USER" && employeeId) {
                    params.append("employeeId", employeeId);
                }

                const res = await fetch(
                    `${API_BASE_URL}/api/tasks/search?${params.toString()}`,
                    { headers: { Authorization: "Bearer " + token } }
                );

                if (!res.ok) throw new Error("Search failed");

                const data = await res.json();
                setSearchResults(Array.isArray(data) ? data : []);
            } catch (err) {
                console.error("Search error:", err);
                setSearchResults([]);
            }
        }, 250);

        return () => clearTimeout(timeout);
    }, [searchQuery, effectiveRole, employeeId]); // ❗ removed selectedProject

    // ── Keep emoji picker anchored to its button while user scrolls ──
    useEffect(() => {
        if (!showEmojiPortal) return;

        const updateEmojiPos = () => {
            if (!emojiButtonRef.current) return;
            const rect = emojiButtonRef.current.getBoundingClientRect();
            const left = rect.left + 350 > window.innerWidth
                ? window.innerWidth - 360
                : rect.left;
            setEmojiPopupPos({ top: rect.bottom + 4, left });
        };

        const scrollEl = document.querySelector(".tp-task-main");
        scrollEl && scrollEl.addEventListener("scroll", updateEmojiPos, { passive: true });
        window.addEventListener("resize", updateEmojiPos, { passive: true });

        return () => {
            scrollEl && scrollEl.removeEventListener("scroll", updateEmojiPos);
            window.removeEventListener("resize", updateEmojiPos);
        };
    }, [showEmojiPortal]);


    // ── Keep mention popup anchored to editor while user scrolls ──
    useEffect(() => {
        if (!showSuggestions) return;

        const updatePos = () => {
            if (!editorRef.current) return;
            const er = editorRef.current.getBoundingClientRect();
            // Always below, always left-aligned to editor
            setMentionPopupPos({ top: er.bottom + 6, left: er.left });
        };

        // Attach to every scrollable ancestor + window resize
        const scrollEl = document.querySelector(".tp-task-main");
        scrollEl && scrollEl.addEventListener("scroll", updatePos, { passive: true });
        window.addEventListener("resize", updatePos, { passive: true });

        return () => {
            scrollEl && scrollEl.removeEventListener("scroll", updatePos);
            window.removeEventListener("resize", updatePos);
        };
    }, [showSuggestions]);


    // optional: when entering edit mode, focus the select
    useEffect(() => {
        if (editField === "taskType" && selectRef.current) {
            selectRef.current.focus();
        }
    }, [editField]);

    useEffect(() => {
        setNewTaskParent(""); // reset parent when project changes
    }, [newTaskProject]);



    // at top of component
    const [editAttachments, setEditAttachments] = useState([]); // files selected while editing
    // reuse existing handlers/state where possible: editRef, editContent, setEditContent, editingCommentId, setEditingCommentId

    function getTextBeforeCaret(el) {
        const sel = window.getSelection();
        if (!sel || !sel.rangeCount) return "";

        const range = sel.getRangeAt(0).cloneRange();
        range.selectNodeContents(el);
        range.setEnd(sel.getRangeAt(0).endContainer, sel.getRangeAt(0).endOffset);
        return range.toString();
    }


    const handleEditorClick = (e) => {
        const link = e.target.closest("a[data-link='true']");

        if (link) {
            e.preventDefault();      // stop navigation
            openLinkEditor(link);    //  open rename popup
            return;
        }

        // save caret
        saveCaret();

        //  CLOSE mention popup if caret is before '@'
        const el = editorRef.current;
        if (!el) {
            setShowSuggestions(false);
            return;
        }

        const sel = window.getSelection();
        if (!sel || !sel.rangeCount) {
            setShowSuggestions(false);
            return;
        }

        const range = sel.getRangeAt(0).cloneRange();
        range.selectNodeContents(el);
        range.setEnd(sel.getRangeAt(0).endContainer, sel.getRangeAt(0).endOffset);

        const beforeCursor = range.toString();
        const lastAt = beforeCursor.lastIndexOf("@");

        //  caret moved before '@' → CLOSE
        if (lastAt === -1) {
            setShowSuggestions(false);
            return;
        }

        //  mention broken (space/newline) → CLOSE
        const afterAt = beforeCursor.slice(lastAt + 1);
        if (afterAt.includes(" ") || afterAt.includes("\n")) {
            setShowSuggestions(false);
        }
    };

    const handleEditorKeyDown = (e) => {
        if (!showSuggestions || !filteredUsers.length) return;

        if (e.key === "ArrowDown") {
            e.preventDefault();
            setActiveMentionIndex(i =>
                Math.min(i + 1, filteredUsers.length - 1)
            );
            return;
        }

        if (e.key === "ArrowUp") {
            e.preventDefault();
            setActiveMentionIndex(i => Math.max(i - 1, 0));
            return;
        }

        if (e.key === "Enter") {
            e.preventDefault();
            addMention(filteredUsers[activeMentionIndex]);
            setShowSuggestions(false);
        }

        if (e.key === "Escape") {
            setShowSuggestions(false);
        }
    };










    // handle paste (keeps images & strips bad formatting — adapt to your app)
    async function handleEditPaste(e) {
        if (!e) return;
        e.preventDefault();
        const clipboard = e.clipboardData || window.clipboardData;
        if (!clipboard) return;

        function insertHtmlAtCaret(html) {
            const sel = window.getSelection();
            if (!sel || !sel.rangeCount) {
                if (editRef.current) editRef.current.insertAdjacentHTML("beforeend", html);
                return;
            }
            const range = sel.getRangeAt(0);
            range.deleteContents();

            const el = document.createElement("div");
            el.innerHTML = html;
            const frag = document.createDocumentFragment();
            let node;
            while ((node = el.firstChild)) frag.appendChild(node);

            range.insertNode(frag);
            range.collapse(false);
            sel.removeAllRanges();
            sel.addRange(range);
            if (typeof saveCaret === "function") saveCaret();
        }

        /* 🟢 1. IMAGE PASTE (unchanged) */
        const items = Array.from(clipboard.items || []);
        const fileItems = items.filter(
            (it) => it.kind === "file" && it.type?.startsWith("image/")
        );

        if (fileItems.length) {
            for (const it of fileItems) {
                const file = it.getAsFile();
                if (!file) continue;

                const base64 = await new Promise((resolve, reject) => {
                    const reader = new FileReader();
                    reader.onload = () => resolve(reader.result);
                    reader.onerror = reject;
                    reader.readAsDataURL(file);
                }).catch(() => null);

                if (!base64) continue;

                insertHtmlAtCaret(
                    `<img src="${base64}" alt="${file.name}" style="max-width:50%;height:auto;display:block;margin:6px 0;" />`
                );

                setEditAttachments((prev) => [
                    ...(prev || []),
                    { name: file.name, file, base64 },
                ]);

                await new Promise((r) => setTimeout(r, 10));
            }

            if (editRef.current) {
                setEditContent(editRef.current.innerHTML || "");
                editRef.current.setAttribute("data-filled", "true");
                moveCaretToEnd(editRef.current);
            }
            return;
        }

        /* 🟢 2. RICH HTML PASTE (unchanged) */
        const htmlData = clipboard.getData?.("text/html");
        if (htmlData && htmlData.trim()) {
            insertHtmlAtCaret(htmlData);
            if (editRef.current) {
                setEditContent(editRef.current.innerHTML || "");
                editRef.current.setAttribute("data-filled", "true");
                moveCaretToEnd(editRef.current);
            }
            return;
        }

        /* 🟢 3. PLAIN TEXT + MULTIPLE URL AUTOLINK (FINAL) */
        const text = clipboard.getData("text/plain");
        if (!text) return;

        const urlRegex = /(https?:\/\/[^\s]+)/gi;
        const sel = window.getSelection();
        const range = sel && sel.rangeCount ? sel.getRangeAt(0) : null;

        if (range) range.deleteContents();

        const fragment = document.createDocumentFragment();

        text.split(/\r\n|\r|\n/).forEach((line, lineIndex, arr) => {
            let lastIndex = 0;

            line.replace(urlRegex, (url, index) => {
                if (index > lastIndex) {
                    fragment.appendChild(
                        document.createTextNode(line.slice(lastIndex, index))
                    );
                }

                const a = document.createElement("a");
                a.href = url;
                a.textContent = url;
                a.target = "_blank";
                a.rel = "noopener noreferrer";
                a.setAttribute("data-link", "true");

                fragment.appendChild(a);
                lastIndex = index + url.length;
            });

            if (lastIndex < line.length) {
                fragment.appendChild(
                    document.createTextNode(line.slice(lastIndex))
                );
            }

            if (lineIndex < arr.length - 1) {
                fragment.appendChild(document.createElement("br"));
            }
        });

        if (range) {
            range.insertNode(fragment);
            range.collapse(false);
            sel.removeAllRanges();
            sel.addRange(range);
        } else if (editRef.current) {
            editRef.current.appendChild(fragment);
        }

        if (editRef.current) {
            setEditContent(editRef.current.innerHTML || "");
            editRef.current.setAttribute("data-filled", "true");
            moveCaretToEnd(editRef.current);
        }

        return;

    }


    useEffect(() => {
        if (editField !== "assignee") return;

        if (!activeTask?.project?.id) {
            setProjectEmployees([]);
            return;
        }

        fetch(
            `${API_BASE_URL}/api/manageteam/project/${activeTask.project.id}/employees`,
            { headers: { Authorization: "Bearer " + token } }
        )
            .then(res => res.json())
            .then(data => {
                const sortedEmployees = Array.isArray(data)
                    ? [...data].sort((a, b) =>
                        `${a.firstName} ${a.lastName}`
                            .toLowerCase()
                            .localeCompare(
                                `${b.firstName} ${b.lastName}`.toLowerCase()
                            )
                    )
                    : [];

                setProjectEmployees(sortedEmployees);
            })
            .catch(() => setProjectEmployees([]));
    }, [editField, activeTask?.project?.id, token]);




    // Fetch all worklogs for a task (all employees) and compute total hours.
    // Falls back to using existing `worklogs` if the endpoint is not available.
    const fetchTaskTotalLogs = async (taskId) => {
        if (!taskId) {
            setTaskTotalHrs(null);
            return;
        }

        try {
            const res = await fetch(`${API_BASE_URL}/api/worklogs/task/${taskId}`, {
                headers: { Authorization: "Bearer " + token },
            });

            if (!res.ok) {
                // Endpoint missing or not allowed — fallback to per-employee worklogs sum
                throw new Error(`Failed to fetch all worklogs: ${res.status}`);
            }

            const data = await res.json();
            // Expecting an array of worklog objects with numeric `hours` property
            const total = (data || []).reduce((sum, w) => sum + Number(w.hours || 0), 0);
            setTaskTotalHrs(Number(total.toFixed(2)));
        } catch (err) {
            // fallback: sum whatever we already have in `worklogs` (likely current employee only)
            console.warn("fetchTaskTotalLogs fallback to local worklogs:", err);
            const fallback = (worklogs || []).reduce((s, w) => s + Number(w.hours || 0), 0);
            setTaskTotalHrs(Number(fallback.toFixed(2)));
        }
    };







    // start editing a reply (prefills content + attachments if available)
    const startEditReply = (reply) => {
        setEditingReplyId(reply.id);
        // prefer HTML if available else plain text
        setReplyEditContent(reply.html || reply.text || "");
        // prefill attachments array if reply.attachments exists (parsed)
        try {
            let arr = reply.attachments;
            if (typeof arr === "string") arr = JSON.parse(arr);
            if (!Array.isArray(arr)) arr = [];
            // normalize to { name, base64?, url?, id? } shape for editing UI
            const normalized = arr.map(a => ({
                name: a.name || a.originalName || "attachment",
                base64: a.base64 || a.base64Data || null,
                url: a.path || a.url || null,
                id: a.id || null
            }));
            setReplyEditAttachments(normalized);
        } catch (e) {
            setReplyEditAttachments([]);
        }

        // inject content into editable ref after next tick
        setTimeout(() => {
            if (replyEditRef.current) {
                // if we have HTML use it, otherwise plain text
                replyEditRef.current.innerHTML = reply.html || reply.text || "";
                replyEditRef.current.focus();
                // move caret to end helper from your file
                moveCaretToEnd(replyEditRef.current);
            }
        }, 0);
    };

    const cancelEditReply = () => {
        setEditingReplyId(null);
        setReplyEditContent("");
        setReplyEditAttachments([]);
        if (replyEditRef.current) replyEditRef.current.innerHTML = "";
    };

    // convert file objects -> base64 (you already have fileToBase64 in file)
    const convertFilesToPayload = async (attachmentsArr) => {
        const out = [];
        for (const a of attachmentsArr || []) {
            // if already base64 or url or id keep as-is
            if (a.base64 && typeof a.base64 === "string") {
                out.push({ name: a.name, base64: a.base64 });
                continue;
            }
            if (a.file instanceof File) {
                try {
                    const b64 = await fileToBase64(a.file); // fileToBase64 returns dataURL in your file
                    out.push({ name: a.name || a.file.name, base64: b64 });
                } catch (err) {
                    console.warn("Failed to convert reply edit file to base64", err);
                }
                continue;
            }
            // keep url/id as metadata so server can keep reference
            if (a.url || a.id) out.push({ name: a.name, url: a.url, id: a.id });
        }
        return out;
    };

    const saveReplyEdit = async (replyId, parentCommentId) => {
        // read plain text and html
        const html = replyEditRef.current?.innerHTML || replyEditContent || "";
        const text = (replyEditRef.current?.innerText || replyEditContent || "").trim();

        // if both empty and no attachments, ignore
        if (!text && (!replyEditAttachments || replyEditAttachments.length === 0)) return;

        const token = localStorage.getItem("token");

        // prepare attachments payload
        const newAttachments = await convertFilesToPayload(replyEditAttachments);

        const body = {
            text,
            html,
            // For compatibility: server expects attachments array or attachments JSON string.
            attachments: newAttachments,
        };

        try {
            // try reasonable endpoint — adjust if your backend uses different route
            const res = await fetch(`${API_BASE_URL}/api/tasks/comments/replies/${replyId}`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + token,
                },
                body: JSON.stringify(body),
            });

            if (!res.ok) {
                // fallback: try alternate endpoint
                const alt = await fetch(`${API_BASE_URL}/api/tasks/comments/${parentCommentId}/replies/${replyId}`, {
                    method: "PUT",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + token,
                    },
                    body: JSON.stringify(body),
                });
                if (!alt.ok) {
                    console.error("Failed to save reply edit:", await alt.text());
                    return;
                }
                const updatedAlt = await alt.json();
                // update UI below with updatedAlt
                updateReplyInComments(updatedAlt, parentCommentId);
            } else {
                const updated = await res.json();
                updateReplyInComments(updated, parentCommentId);
            }

            // cleanup
            cancelEditReply();
        } catch (err) {
            console.error("saveReplyEdit error:", err);
        }
    };

    const updateReplyInComments = (updatedReply, parentCommentId) => {
        setComments(prevComments =>
            prevComments.map(c => {
                if (c.id !== parentCommentId) return c;
                const newReplies = (c.replies || []).map(r => (r.id === updatedReply.id ? updatedReply : r));
                return { ...c, replies: newReplies };
            })
        );
    };

    const deleteReply = async (replyId, parentCommentId) => {
        if (!window.confirm("Are you sure you want to delete this reply?")) return;
        const token = localStorage.getItem("token");
        try {
            // try endpoint 1
            let res = await fetch(`${API_BASE_URL}/api/tasks/comments/replies/${replyId}`, {
                method: "DELETE",
                headers: { Authorization: "Bearer " + token },
            });

            if (!res.ok) {
                // try alternate
                res = await fetch(`${API_BASE_URL}/api/tasks/comments/${parentCommentId}/replies/${replyId}`, {
                    method: "DELETE",
                    headers: { Authorization: "Bearer " + token },
                });
            }

            if (!res.ok) {
                console.error("Failed to delete reply:", await res.text());
                return;
            }

            // remove from comments state
            setComments(prev => prev.map(c => c.id === parentCommentId ? { ...c, replies: (c.replies || []).filter(r => r.id !== replyId) } : c));
        } catch (err) {
            console.error("deleteReply error:", err);
        }
    };


    // insert mention helper (places mention at caret inside editRef)
    function insertMentionAtCaretInEdit(user) {
        const el = editRef.current;
        if (!el) return;

        const sel = window.getSelection();
        if (!sel || sel.rangeCount === 0) return;
        const range = sel.getRangeAt(0);

        function nodeForOffset(root, offset) {
            const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
            let node;
            let idx = 0;
            while ((node = walker.nextNode())) {
                const len = node.textContent.length;
                if (offset <= idx + len) {
                    return { node, offsetInNode: Math.max(0, offset - idx) };
                }
                idx += len;
            }
            return { node: root, offsetInNode: root.textContent.length };
        }

        const beforeRange = range.cloneRange();
        beforeRange.selectNodeContents(el);
        beforeRange.setEnd(range.endContainer, range.endOffset);
        const beforeText = beforeRange.toString();
        const atIndex = beforeText.lastIndexOf("@");

        const mentionLabel = `${user.firstName}${user.lastName ? " " + user.lastName : ""}`;

        if (atIndex === -1) {
            document.execCommand("insertText", false, mentionLabel + " ");
            setReplyShowSuggestions(false);
            return;
        }

        // 🔥 CHANGE #1: start from '@' (not after it)
        const startInfo = nodeForOffset(el, atIndex);
        const endInfo = nodeForOffset(el, beforeText.length);

        if (!startInfo.node || !endInfo.node) {
            document.execCommand("insertText", false, mentionLabel + " ");
            setReplyShowSuggestions(false);
            return;
        }

        const replaceRange = document.createRange();
        replaceRange.setStart(startInfo.node, startInfo.offsetInNode);
        replaceRange.setEnd(endInfo.node, endInfo.offsetInNode);

        // 🔥 CHANGE #2: delete "@typedText"
        replaceRange.deleteContents();

        const mentionSpan = document.createElement("span");
        mentionSpan.setAttribute("data-mention-id", String(user.id || ""));
        mentionSpan.setAttribute("contenteditable", "false");
        mentionSpan.className = "mention-chip";
        mentionSpan.textContent = mentionLabel;

        replaceRange.insertNode(mentionSpan);

        // add ONE space after mention
        const spaceNode = document.createTextNode(" ");
        mentionSpan.after(spaceNode);

        // move caret
        const afterRange = document.createRange();
        afterRange.setStartAfter(spaceNode);
        afterRange.collapse(true);
        sel.removeAllRanges();
        sel.addRange(afterRange);

        setEditContent(el.innerHTML || "");
        setReplyShowSuggestions(false);
        el.focus();
    }



    // ensure placeholder visibility by toggling data-filled
    useEffect(() => {
        if (!editRef.current) return;

        const el = editRef.current;

        // Set placeholder visibility
        const filled = (el.innerText || "").trim().length > 0;
        el.setAttribute("data-filled", filled ? "true" : "false");

        // When switching into edit mode, inject content
        if (editingCommentId !== null) {
            // Insert editContent into editor
            if (editContent && el.innerHTML.trim() === "") {
                el.innerText = editContent;

                // Move caret to end
                const range = document.createRange();
                range.selectNodeContents(el);
                range.collapse(false);
                const sel = window.getSelection();
                sel.removeAllRanges();
                sel.addRange(range);

                el.focus();
            }
        }
    }, [editingCommentId, editContent]);





    const saveCaret = () => {
        const sel = window.getSelection();
        if (sel && sel.rangeCount > 0) {
            setSavedRange(sel.getRangeAt(0));
        }
    };

    // Call-site: paste this inside your component (ViewTasks) near other useEffect hooks
    useEffect(() => {
        const el = editorRef.current;
        if (!el) return;

        // Helper to remove attachment by src/name/url
        const removeAttachmentBySrc = (src) => {
            setAttachments(prev => {
                if (!prev || !prev.length) return [];
                return prev.filter(att => {
                    // att may have base64, url, path, name — consider matches robustly
                    const href = att.base64 || att.url || att.path || "";
                    if (!href) {
                        // if only name present, we won't match here
                        return true;
                    }

                    // Exact match for data URLs or urls
                    if (href === src) return false;

                    // Some systems store base64 *without* data:* prefix — handle that
                    if (href.startsWith("data:") && src.startsWith("data:")) {
                        return href !== src;
                    }
                    // If href is data:... and src may be a normalized URL (or vice-versa),
                    // do a substring match as fallback (safe-ish)
                    if (href && src && (href.indexOf(src) !== -1 || src.indexOf(href) !== -1)) {
                        return false;
                    }

                    return true; // keep if no match
                });
            });
        };

        function onBeforeInput(e) {
            // Only interested in deletion/backspace/cut-like inputTypes
            if (!["deleteContentBackward", "deleteContentForward", "deleteByCut", "deleteByDrag"].includes(e.inputType)) {
                return;
            }

            const sel = window.getSelection();
            if (!sel || !sel.rangeCount) return;
            const range = sel.getRangeAt(0);

            // If there's a selection (non-collapsed), let default happen and then sync (we rely on sync at input)
            if (!range.collapsed) {
                // small async sync to update attachments after deletion
                setTimeout(() => {
                    // parse DOM and sync attachments by checking existing img srcs/hrefs
                    const temp = document.createElement("div");
                    temp.innerHTML = el.innerHTML;
                    const imgSrcs = Array.from(temp.querySelectorAll("img")).map(i => i.src).filter(Boolean);
                    const anchorHrefs = Array.from(temp.querySelectorAll("a[href]")).map(a => a.href).filter(Boolean);
                    setAttachments(prev => {
                        if (!prev || !prev.length) return [];
                        return prev.filter(att => {
                            const href = att.base64 || att.url || att.path || "";
                            if (!href) return true;
                            if (imgSrcs.includes(href) || anchorHrefs.includes(href)) return true;
                            // If att has name and the name still appears in the text keep it
                            if (att.name && (temp.textContent || "").includes(att.name)) return true;
                            return false;
                        });
                    });
                }, 0);
                return;
            }

            // collapsed caret: check immediate node before caret for element nodes (img, badge, etc.)
            const { startContainer, startOffset } = range;

            // If caret inside text node and offset > 0, normal char deletion — nothing to do
            if (startContainer.nodeType === Node.TEXT_NODE && startOffset > 0) {
                return;
            }

            // Find candidate node to the left of caret
            let candidate = null;

            if (startContainer.nodeType === Node.TEXT_NODE) {
                // caret at beginning of a text node (offset === 0)
                const parent = startContainer.parentNode;
                // find previous sibling of this text node
                candidate = parent && parent.childNodes ? parent.childNodes[startOffset - 1] : null;
                if (!candidate) {
                    // fallback: previous sibling of the parent
                    candidate = parent ? parent.previousSibling : null;
                }
            } else if (startContainer.nodeType === Node.ELEMENT_NODE) {
                // caret is at element; startOffset is index in childNodes
                candidate = startContainer.childNodes[startOffset - 1] || null;
                if (!candidate) {
                    // try previousSibling of container
                    candidate = startContainer.previousSibling;
                }
            }

            if (!candidate) return;

            // If candidate is an <img>, intercept deletion and remove attachment
            if (candidate.nodeType === Node.ELEMENT_NODE && candidate.tagName === "IMG") {
                e.preventDefault();

                const src = candidate.getAttribute("src");
                // remove node from DOM
                candidate.remove();

                // remove from attachments state if matches base64/url
                removeAttachmentBySrc(src);

                // place caret at previous position (end of previous node or beginning of container)
                try {
                    const sel2 = window.getSelection();
                    const r2 = document.createRange();

                    // prefer to place caret at the container where the image was removed
                    const container = el;
                    // move caret to end of container (safe fallback)
                    r2.selectNodeContents(container);
                    r2.collapse(false);
                    sel2.removeAllRanges();
                    sel2.addRange(r2);
                    saveCaret && saveCaret();
                } catch (err) {
                    // ignore caret errors
                }
                return;
            }

            // If candidate is an element that looks like a file badge (a span/a with filename), try to match by text
            if (candidate.nodeType === Node.ELEMENT_NODE) {
                const text = (candidate.textContent || "").trim();
                if (text) {
                    // try to find matching attachment by name
                    const match = attachments.find(att => att.name && text.includes(att.name));
                    if (match) {
                        e.preventDefault();
                        candidate.remove();
                        setAttachments(prev => (prev || []).filter(a => a !== match));
                        saveCaret && saveCaret();
                        return;
                    }
                }
            }

            // otherwise do nothing special — fallback to default browser behavior
        }

        el.addEventListener("beforeinput", onBeforeInput);
        return () => el.removeEventListener("beforeinput", onBeforeInput);
    }, [editorRef, attachments, setAttachments, saveCaret]);


    useEffect(() => {
        const close = (e) => {
            if (filterRef.current && !filterRef.current.contains(e.target)) {
                setShowFilter(false);
            }
        };
        document.addEventListener("mousedown", close);
        return () => document.removeEventListener("mousedown", close);
    }, []);


    // mirror of the main-editor beforeinput handler but for the reply editor
    useEffect(() => {
        const el = replyEditorRef.current;
        if (!el) return;

        // helper: remove reply attachment by matching src/name/url
        const removeReplyAttachmentBySrc = (src) => {
            setReplyAttachments(prev => {
                if (!prev || !prev.length) return [];
                return prev.filter(att => {
                    const href = att.base64 || att.url || att.path || "";
                    if (!href) return true;
                    if (href === src) return false;
                    if (href.startsWith("data:") && src.startsWith("data:")) return href !== src;
                    if (href && src && (href.indexOf(src) !== -1 || src.indexOf(href) !== -1)) return false;
                    return true;
                });
            });
        };

        function onBeforeInput(e) {
            if (!["deleteContentBackward", "deleteContentForward", "deleteByCut", "deleteByDrag"].includes(e.inputType)) {
                return;
            }

            const sel = window.getSelection();
            if (!sel || !sel.rangeCount) return;
            const range = sel.getRangeAt(0);

            // If a selection is being deleted, do a post-delete sync (async)
            if (!range.collapsed) {
                setTimeout(() => {
                    const temp = document.createElement("div");
                    temp.innerHTML = el.innerHTML;
                    const imgSrcs = Array.from(temp.querySelectorAll("img")).map(i => i.src).filter(Boolean);
                    const anchorHrefs = Array.from(temp.querySelectorAll("a[href]")).map(a => a.href).filter(Boolean);
                    setReplyAttachments(prev => {
                        if (!prev || !prev.length) return [];
                        return prev.filter(att => {
                            const href = att.base64 || att.url || att.path || "";
                            if (!href) return true;
                            if (imgSrcs.includes(href) || anchorHrefs.includes(href)) return true;
                            if (att.name && (temp.textContent || "").includes(att.name)) return true;
                            return false;
                        });
                    });
                }, 0);
                return;
            }

            // collapsed caret: inspect node left of caret
            const { startContainer, startOffset } = range;

            if (startContainer.nodeType === Node.TEXT_NODE && startOffset > 0) {
                return;
            }

            let candidate = null;
            if (startContainer.nodeType === Node.TEXT_NODE) {
                const parent = startContainer.parentNode;
                candidate = parent && parent.childNodes ? parent.childNodes[startOffset - 1] : null;
                if (!candidate) candidate = parent ? parent.previousSibling : null;
            } else if (startContainer.nodeType === Node.ELEMENT_NODE) {
                candidate = startContainer.childNodes[startOffset - 1] || startContainer.previousSibling;
            }

            if (!candidate) return;

            // If it's an <img>, intercept deletion and remove both DOM node and reply attachment
            if (candidate.nodeType === Node.ELEMENT_NODE && candidate.tagName === "IMG") {
                e.preventDefault();
                const src = candidate.getAttribute("src");
                candidate.remove();
                removeReplyAttachmentBySrc(src);

                try {
                    const sel2 = window.getSelection();
                    const r2 = document.createRange();
                    r2.selectNodeContents(el);
                    r2.collapse(false);
                    sel2.removeAllRanges();
                    sel2.addRange(r2);
                    saveCaret && saveCaret();
                } catch (err) { }

                return;
            }

            // If candidate looks like a badge (span/a), try to match by filename/text
            if (candidate.nodeType === Node.ELEMENT_NODE) {
                const text = (candidate.textContent || "").trim();
                if (text) {
                    const match = (replyAttachments || []).find(att => att.name && text.includes(att.name));
                    if (match) {
                        e.preventDefault();
                        candidate.remove();
                        setReplyAttachments(prev => (prev || []).filter(a => a !== match));
                        saveCaret && saveCaret();
                        return;
                    }
                }
            }
        }

        el.addEventListener("beforeinput", onBeforeInput);
        return () => el.removeEventListener("beforeinput", onBeforeInput);
    }, [replyEditorRef, replyAttachments, setReplyAttachments, saveCaret]);






    {/* Helper to check if base64 has data: prefix */ }
    const getDataUrl = (file) => {
        if (!file.base64) return "";
        return file.base64.startsWith("data:")
            ? file.base64
            : `data:${getMimeType(file.name)};base64,${file.base64}`;
    };

    /* Helper to get MIME type from file name */
    const getMimeType = (filename) => {
        const ext = filename?.split(".").pop()?.toLowerCase();
        switch (ext) {
            case "jpg":
            case "jpeg":
                return "image/jpeg";
            case "png":
                return "image/png";
            case "gif":
                return "image/gif";
            case "bmp":
                return "image/bmp";
            case "webp":
                return "image/webp";
            default:
                return "application/octet-stream";
        }
    };




    useEffect(() => {
        const el = replyEditorRef.current;
        if (!el) return;
        function onFocus() {
            el.setAttribute("data-filled", el.innerText.trim().length > 0 ? "true" : "true");
        }
        function onBlur() {
            el.setAttribute("data-filled", el.innerText.trim().length > 0 ? "true" : "false");
        }
        el.addEventListener("focus", onFocus);
        el.addEventListener("blur", onBlur);
        return () => {
            el.removeEventListener("focus", onFocus);
            el.removeEventListener("blur", onBlur);
        };
    }, []);

    // 🔐 Authentication check
    useEffect(() => {
        const token = localStorage.getItem("token"); // or localStorage
        if (!token) {
            toast.error("You must be logged in to access this page.");
            navigate("/");
        }
    }, [navigate]);


    useEffect(() => {
        // Reset when no project selected
        if (!newTaskProject) {
            setTeams([]);
            setNewTaskTeam("");
            return;
        }

        const fetchProjectTeams = async () => {
            try {
                const res = await fetch(
                    `${API_BASE_URL}/api/manageteam/project/${newTaskProject}/teams`,
                    {
                        headers: {
                            Authorization: "Bearer " + localStorage.getItem("token"),
                        },
                    }
                );

                if (!res.ok) {
                    console.error("Failed to fetch project teams");
                    setTeams([]);
                    return;
                }

                const data = await res.json();
                setTeams(data || []);
                setNewTaskTeam(""); // reset team selection on project change
            } catch (err) {
                console.error("Error fetching project teams", err);
                setTeams([]);
            }
        };

        fetchProjectTeams();
    }, [newTaskProject]);


    useEffect(() => {
        // If no project selected, clear dropdown options
        if (!newTaskProject) {
            setProjectEmployees([]);
            setNewTaskAssignee("");
            setNewTaskReporter("");
            return;
        }

        const fetchProjectEmployees = async () => {
            try {
                const res = await fetch(
                    `${API_BASE_URL}/api/manageteam/project/${newTaskProject}/employees`,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            "Content-Type": "application/json",
                        },
                    }
                );
                if (!res.ok) {
                    console.error("Failed to load project employees");
                    setProjectEmployees([]);
                    return;
                }
                const data = await res.json();
                setProjectEmployees(data);

                // Reset assignee (but don't forcibly clear reporter — we'll set it if logged-in user exists)
                setNewTaskAssignee("");

                // Normalize types to string and auto-select reporter if present
                const loggedIdStr = String(loggedInEmployeeId);
                const found = data.some(emp => String(emp.id) === loggedIdStr);
                if (found) {
                    setNewTaskReporter(loggedIdStr);
                } else {
                    setNewTaskReporter(""); // optional: ensure cleared if not part of project
                }
            } catch (err) {
                console.error("Error fetching project employees", err);
                setProjectEmployees([]);
            }
        };

        fetchProjectEmployees();
    }, [newTaskProject, loggedInEmployeeId]); // include loggedInEmployeeId just in case



    // find name from employees array
    const employeeIdFromSession = Number(localStorage.getItem("employeeId"));
    const currentEmp = employees.find(e => Number(e.id) === employeeIdFromSession);
    const loggedUserName = currentEmp ? `${currentEmp.firstName} ${currentEmp.lastName}`.trim() : "";
    // then same compare as above


    function handleReplyEditorInput(e) {
        try {
            const el = replyEditorRef.current;
            if (!el) return;

            const text = el.innerText || "";
            const trimmed = text.trim();

            // placeholder hide
            el.setAttribute("data-filled", trimmed.length > 0 ? "true" : "false");

            // update reply content
            setReplyContent(text);

            // --- MENTION TRIGGER LOGIC ---
            // find last "@"
            const cursorText = text;
            const lastAt = cursorText.lastIndexOf("@");

            // No @ → hide
            if (lastAt === -1) {
                setReplyShowSuggestions(false);
                return;
            }

            // Get text typed after the '@'
            const after = cursorText.slice(lastAt + 1);

            // If user typed a space or pressed enter → hide
            if (after.includes(" ") || after.includes("\n")) {
                setReplyShowSuggestions(false);
                return;
            }

            // Now show suggestions (user is typing after '@')
            setReplyShowSuggestions(true);

            // Filter users
            const lower = after.toLowerCase();
            const list = mentionableUsers.filter(u =>
                (`${u.firstName} ${u.lastName}`).toLowerCase().includes(lower)
            );
            setFilteredUsers(list);

        } catch (err) {
            console.error("handleReplyEditorInput error:", err);
        }
    }


    // paste handler (keep linebreaks/plain text)
    // const handleReplyPaste = (e) => {
    //   e.preventDefault();
    //   const text = (e.clipboardData || window.clipboardData).getData("text");
    //   document.execCommand("insertText", false, text);
    //   setTimeout(() => handleReplyEditorInput(), 10);
    // };

    async function handleReplyPaste(e) {
        try {
            if (!e.clipboardData) return;
            const items = Array.from(e.clipboardData.items || []);
            // look for image items first
            const imageItem = items.find(it => it.type && it.type.startsWith("image/"));

            if (!imageItem) {
                // no image — allow default paste (text/HTML)
                return;
            }

            // prevent default so the browser doesn't insert a raw image blob URL
            e.preventDefault();

            // get blob
            const blob = imageItem.getAsFile();
            if (!blob) return;

            // optional: give it a filename
            const filename = `pasted-${Date.now()}.png`;

            // convert to base64 data URL (so you can preview inline)
            const toBase64 = (b) =>
                new Promise((res, rej) => {
                    const reader = new FileReader();
                    reader.onload = () => res(reader.result);
                    reader.onerror = rej;
                    reader.readAsDataURL(b);
                });

            const dataUrl = await toBase64(blob); // "data:image/png;base64,...."

            // 1) insert an <img> at caret position inside the contentEditable
            insertImageAtCaret(dataUrl);

            // 2) add to replyAttachments state so it can be uploaded with the reply
            // store both the original blob (file) and a preview base64 so UI can show it
            const fileObj = { name: filename, file: blob, base64: dataUrl };
            if (typeof setReplyAttachments === "function") {
                setReplyAttachments((prev) => [...(prev || []), fileObj]);
            }

            // update UI state / placeholder / suggestion logic
            if (typeof handleReplyEditorInput === "function") handleReplyEditorInput();

        } catch (err) {
            console.error("handleReplyPaste error:", err);
        }
    }

    function insertImageAtCaret(dataUrl) {
        const el = replyEditorRef.current;
        if (!el) return;

        // create image node
        const img = document.createElement("img");
        img.src = dataUrl;
        img.alt = "pasted-image";
        img.style.maxWidth = "180px";
        img.style.maxHeight = "120px";
        img.style.borderRadius = "8px";
        img.style.display = "block";
        img.style.margin = "6px 0";

        // insert at caret / selection
        const sel = window.getSelection();
        if (!sel || !sel.rangeCount) {
            el.appendChild(img);
        } else {
            const range = sel.getRangeAt(0);
            // place the image at the caret, replacing any selected range
            range.deleteContents();
            range.insertNode(img);

            // move caret after the inserted image
            range.setStartAfter(img);
            range.collapse(true);
            sel.removeAllRanges();
            sel.addRange(range);
        }

        // focus editor
        el.focus();
    }

    function insertTextAtCaret(text) {
        insertHtmlAtCaret(document.createTextNode(text).textContent);
    }

    // insert image element at caret (base64 or url)
    function insertImageAtCaret(src, alt = "image") {
        const imgHtml = `<img src="${src}" alt="${alt}" style="max-width:50%;height:auto;display:block;margin:6px 0;" />`;
        insertHtmlAtCaret(imgHtml);
    }

    // file upload for reply
    const handleReplyFileUpload = (e) => {
        const files = Array.from(e.target.files || []);
        if (!files.length) return;
        // simple file preview objects (adjust if you need base64)
        const list = files.map((f) => ({ file: f, name: f.name, size: f.size }));
        setReplyAttachments((prev) => [...prev, ...list]);
        e.target.value = null;
    };

    // remove reply attachment
    const removeReplyAttachment = (index) => {
        setReplyAttachments((prev) => prev.filter((_, i) => i !== index));
    };


    // --- helpers (add to component) ---
    const formatDecimalToReadable = (decimal) => {
        if (!decimal || isNaN(decimal) || decimal <= 0) return "";
        const hours = Math.floor(decimal);
        const minutes = Math.round((decimal - hours) * 60);
        const parts = [];
        if (hours > 0) parts.push(`${hours}h`);
        if (minutes > 0) parts.push(`${minutes}m`);
        return parts.join(" ") || "0m";
    };

    // Convert various stored values into decimal hours
    const ensureDecimalHours = (value) => {
        if (value == null) return 0;
        // If it's an object or string like "1.5" or "90" or "90m" or "1:30"
        if (typeof value === "string") {
            const s = value.trim().toLowerCase();
            if (s.endsWith("m")) {
                // "90m" -> minutes
                const n = Number(s.replace("m", ""));
                return Number((n / 60).toFixed(2));
            }
            if (s.includes("h") || s.includes("m")) {
                // parse "1h 30m"
                const hourMatch = s.match(/(\d+(?:\.\d+)?)\s*h/);
                const minuteMatch = s.match(/(\d+(?:\.\d+)?)\s*m/);
                const hours = hourMatch ? parseFloat(hourMatch[1]) : 0;
                const minutes = minuteMatch ? parseFloat(minuteMatch[1]) : 0;
                return Number((hours + minutes / 60).toFixed(2));
            }
            if (s.includes(":")) {
                // "1:30" -> hours:minutes
                const [hStr, mStr] = s.split(":");
                const h = Number(hStr || 0);
                const m = Number(mStr || 0);
                return Number((h + m / 60).toFixed(2));
            }
            // otherwise numeric string
            const n = Number(s.replace(",", "."));
            if (!Number.isNaN(n)) {
                // Heuristic: if n > 24 treat as minutes
                if (n > 24) return Number((n / 60).toFixed(2));
                return Number(n.toFixed(2));
            }
            return 0;
        }

        // numeric input
        if (typeof value === "number") {
            // heuristic: if value > 24 -> minutes stored, convert
            if (value > 24) return Number((value / 60).toFixed(2));
            return Number(value.toFixed(2));
        }

        return 0;
    };


    // Ensure we produce a usable href for attachments
    const ensureDataUrl = (att) => {
        if (!att) return null;
        if (att.base64 && typeof att.base64 === "string") {
            // if base64 is already a full data: URL, return as-is
            if (att.base64.startsWith("data:")) return att.base64;
            // otherwise build one using provided type or guessed mime
            const mime = att.type || getMimeType(att.name || "");
            return `data:${mime};base64,${att.base64}`;
        }
        // server might return path/url fields
        if (att.path || att.url) return att.path || att.url;
        return null;
    };

    // Parse attachments field from reply (handles JSON-string or array)
    const parseAttachmentsField = (reply) => {
        try {
            let arr = reply.attachments;
            if (!arr) return [];
            if (typeof arr === "string") {
                try {
                    arr = JSON.parse(arr);
                } catch (e) {
                    // sometimes server wraps JSON with extra quotes; try to salvage
                    const trimmed = arr.trim();
                    if (trimmed.startsWith('"[') && trimmed.endsWith(']"')) {
                        try { arr = JSON.parse(JSON.parse(trimmed)); } catch (ee) { return []; }
                    } else return [];
                }
            }
            if (!Array.isArray(arr)) return [];

            return arr.map((a) => {
                const name = a.name || a.originalName || "attachment";
                const href = ensureDataUrl(a) || a.path || a.url || null;
                const isImage =
                    (a.type && typeof a.type === "string" && a.type.startsWith("image")) ||
                    (href && typeof href === "string" && href.startsWith("data:image")) ||
                    /\.(jpe?g|png|gif|bmp|webp|svg)$/i.test(name);
                return { name, href, isImage };
            });
        } catch (err) {
            console.error("parseAttachmentsField error:", err);
            return [];
        }
    };


    // helper: parse input (supports "1.5", "0.5", "1h 30m", "45m", "90m")
    const parseDurationToDecimal = (input) => {
        if (!input) return 0;
        const s = String(input).trim().toLowerCase();

        // human format with h/m
        if (/[hm]/.test(s)) {
            const hourMatch = s.match(/(\d+(?:\.\d+)?)\s*h/);
            const minuteMatch = s.match(/(\d+(?:\.\d+)?)\s*m/);

            const hours = hourMatch ? parseFloat(hourMatch[1]) : 0;
            const minutes = minuteMatch ? parseFloat(minuteMatch[1]) : 0;

            // If user entered only minutes like "90m" that yields hours + minutes/60
            return Number((hours + minutes / 60).toFixed(2));
        }

        // treat as decimal number (accept comma as decimal separator)
        const normalized = s.replace(",", ".");
        const num = Number(normalized);
        return !isNaN(num) ? Number(num.toFixed(2)) : 0;
    };

    // When user changes input: update raw and decimal (so we can show live decimal somewhere if needed)
    const handleDurationChange = (raw) => {
        setLogHoursRaw(raw);

        // parse full duration into hours
        const dec = parseDurationToDecimal(raw);

        // allow minutes-only inputs like "50m"
        // allow any text UNTIL it becomes > 24h
        if (dec > 24) {
            return;  // block further typing
        }

        setLogHoursDecimal(dec);
    };



    // On blur: convert typed value into readable and set display value in the input
    const handleDurationBlur = () => {
        const dec = parseDurationToDecimal(logHoursRaw);

        if (dec > 24) {
            return; // do nothing; keep user text so they correct it
        }

        setLogHoursDecimal(dec);

        const readable = formatDecimalToReadable(dec);
        setLogHoursDisplay(readable);
        setLogHoursRaw(readable);
    };



    // Optional: when focusing back into the input, show the raw decimal or allow editing
    const handleDurationFocus = () => {
        // Let user edit the previous raw value. If display contains readable like "1h 30m",
        // we'll set raw to decimal string to make editing easier (optional).
        // Here we set raw to decimal string to allow quick edits like 1.5 -> back to 1.5
        if (logHoursDisplay) {
            // keep decimal with up to 2 decimals
            setLogHoursRaw(logHoursDecimal > 0 ? String(logHoursDecimal) : "");
        }
    };


    function insertMentionAtCaret(user) {
        const el = replyEditorRef.current;
        if (!el) return;

        const text = el.innerText || "";
        const lastAt = text.lastIndexOf("@");
        const mention = `@${user.firstName} ${user.lastName} `;

        // find caret position
        let caretPos = text.length;
        const sel = window.getSelection();
        if (sel && sel.rangeCount) {
            const range = sel.getRangeAt(0).cloneRange();
            range.selectNodeContents(el);
            range.setEnd(sel.getRangeAt(0).endContainer, sel.getRangeAt(0).endOffset);
            caretPos = range.toString().length;
        }

        // if there's no '@' before the caret, just insert at caret
        if (lastAt === -1 || lastAt > caretPos) {
            document.execCommand("insertText", false, mention);
            handleReplyEditorInput();
            if (typeof setReplyShowSuggestions === "function") setReplyShowSuggestions(false);
            return;
        }

        // replace from lastAt up to caretPos with mention
        const before = text.slice(0, lastAt);
        const after = text.slice(caretPos);
        const newText = before + mention + after;

        // set plain text and move caret after inserted mention
        el.innerText = newText;

        // position caret right after the inserted mention
        const node = el.firstChild || el;
        const pos = (before + mention).length;
        const newRange = document.createRange();
        try {
            newRange.setStart(node, Math.min(pos, node.length || pos));
            newRange.collapse(true);
            const s = window.getSelection();
            s.removeAllRanges();
            s.addRange(newRange);
        } catch (err) {
            // fallback: focus at end
            el.focus();
            document.execCommand("selectAll");
            document.getSelection().collapseToEnd();
        }

        // update UI / hide suggestions
        handleReplyEditorInput();
        if (typeof setReplyShowSuggestions === "function") setReplyShowSuggestions(false);
    }


    function getTextBeforeCaret(el) {
        const sel = window.getSelection();
        if (!sel || !sel.rangeCount) return "";

        const range = sel.getRangeAt(0).cloneRange();
        range.selectNodeContents(el);
        range.setEnd(sel.getRangeAt(0).endContainer, sel.getRangeAt(0).endOffset);
        return range.toString();
    }



    const updateTaskField = async (taskId, field, value) => {
        try {

            const task =
                activeTask?.id === taskId
                    ? activeTask
                    : tasks.find(t => t.id === taskId);

            if (!task) {
                console.error("❌ Task not found for update:", taskId);
                return;
            }

            if (
                field === "status" &&
                value === "COMPLETED" &&
                task.taskType === "Parent"
            ) {
                const hasIncompleteChild = tasks.some(
                    t =>
                        t.parent?.id === taskId &&
                        !["COMPLETED", "CANCELLED"].includes(
                            (t.status || "").toUpperCase()
                        )
                );

                if (hasIncompleteChild) {
                    alert(
                        "You cannot mark this parent task as COMPLETED while it has incomplete child tasks."
                    );
                    return false; // ⛔ stop update
                }
            }

            const formData = new FormData();

            // 🟢 mandatory fields
            formData.append("title", task.title || "");
            const descriptionToSend =
                field === "description" ? value : task.description;

            formData.append("description", descriptionToSend || "");
            formData.append(
                "dueDate",
                task.dueDate
                    ? new Date(task.dueDate).toISOString().split("T")[0]
                    : ""
            );
            formData.append("projectId", task.project?.id || "");

            // 🟡 optional fields
            formData.append("priority", task.priority || "");
            // ✅ ALWAYS send parentId
            if (task.parent?.id) {
                formData.set("parentId", task.parent.id);
            } else {
                formData.set("parentId", ""); // explicit "no parent"
            }

            formData.append("taskType", task.taskType || "");
            formData.append("teamId", task.team?.id || "");
            formData.append("estimatedTime", task.estimatedTime || "");
            formData.append("totalTime", task.totalTime || "");
            formData.append("reporterId", task.reporter?.id || "");
            formData.append("status", task.status || "");

            // ✅ ALWAYS send employeeId
            if (task.assignedTo?.id) {
                formData.set("employeeId", task.assignedTo.id);
            } else {
                formData.set("employeeId", ""); // explicit unassigned
            }



            // employeeId — special handling (SAFE)
            if (field === "employeeId") {
                if (value) {
                    formData.set("employeeId", value);
                } else {
                    formData.set("employeeId", ""); //  explicit unassign
                }
            }


            // 🔹 override edited field (except employeeId)
            if (field && value !== undefined) {
                if (field === "parentId") {
                    if (value == null) {
                        formData.set("parentId", "");
                    } else {
                        formData.set("parentId", value);
                    }
                } else if (field !== "employeeId") {
                    formData.set(field, value);
                }
            }


            const response = await axios.put(
                `${API_BASE_URL}/api/tasks/${taskId}`,
                formData,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );


            const updated = response.data;

            // parent fix
            if (field === "parentId") {
                const fullParent =
                    value == null
                        ? null
                        : parentTasks.find(p => p.id === value);

                updated.parent = fullParent
                    ? {
                        id: fullParent.id,
                        title: fullParent.title,
                        taskCode: fullParent.taskCode
                    }
                    : value == null
                        ? null
                        : { id: value };
            }

            // ✅ single state update
            setActiveTask(prev => {
                if (!prev) return updated;

                return {
                    ...prev,
                    ...updated,

                    // 🔥 KEEP FULL PARENT OBJECT
                    parent:
                        field === "parentId"
                            ? updated.parent
                            : prev.parent,
                };
            });

            setTasks(prev =>
                (prev || []).map(t => {
                    if (t.id !== updated.id) return t;

                    return {
                        ...t,
                        ...updated,
                        parent:
                            field === "parentId"
                                ? updated.parent
                                : t.parent,
                    };
                })
            );


            // console.log("✅ Task updated successfully:", updated);
        } catch (error) {
            console.error("❌ Failed to update task:", error);
        }
    };




    useEffect(() => {
        if (!activeTask?.id) return;

        const fetchAttachments = async () => {
            try {
                const res = await fetch(
                    `${API_BASE_URL}/api/tasks/${activeTask.id}/comment-attachments`,
                    {
                        headers: {
                            Authorization: "Bearer " + token,
                        },
                    }
                );

                if (res.ok) {
                    const data = await res.json();
                    setTaskAttachments(data);
                } else {
                    console.error("Failed to fetch attachments:", res.status);
                }
            } catch (err) {
                console.error("Error fetching attachments:", err);
            }
        };

        fetchAttachments();
    }, [activeTask]);



    useEffect(() => {
        if (!token) navigate("/");
    }, [token, navigate]);



    const [allTasks, setAllTasks] = useState([]);

    // useEffect(() => {
    //     if (!token) return;

    //     const roles = JSON.parse(localStorage.getItem("roles") || []);

    //     const url = roles.includes("ROLE_ADMIN")
    //         ? `${API_BASE_URL}/api/tasks`
    //         : `${API_BASE_URL}/api/tasks/projects-of-employee/${employeeId}`;

    //     setLoading(true);

    //     fetch(url, {
    //         headers: { Authorization: "Bearer " + token },
    //     })
    //         .then(res => res.json())
    //         .then(data => {
    //             if (!Array.isArray(data)) {
    //                 setAllTasks([]);
    //                 setLoading(false);
    //                 return;
    //             }

    //             const mappedTasks = data.map(t => ({
    //                 id: t.id,
    //                 title: t.title,
    //                 status: t.status,
    //                 taskCode: t.taskCode,
    //                 taskType: t.taskType,
    //                 priority: t.priority,
    //                 description: t.description,
    //                 externalUrl: t.externalUrl,
    //                 estimatedTime: t.estimatedTime,
    //                 totalTime: t.totalTime,
    //                 dueDate: t.dueDate ? new Date(t.dueDate) : null,
    //                 createdAt: t.createdAt ? new Date(t.createdAt) : null,

    //                 project: { id: t.projectId, name: t.projectName },

    //                 assignedTo: t.assigneeId
    //                     ? {
    //                         id: t.assigneeId,
    //                         firstName: t.assigneeFirstName,
    //                         lastName: t.assigneeLastName,
    //                         photoPath: t.assigneePhotoPath,
    //                     }
    //                     : null,

    //                 reporter: t.reporterId
    //                     ? {
    //                         id: t.reporterId,
    //                         firstName: t.reporterFirstName,
    //                         lastName: t.reporterLastName,
    //                         photoPath: t.reporterPhotoPath,
    //                     }
    //                     : null,

    //                 team: t.teamId ? { id: t.teamId, name: t.teamName } : null,

    //                 parent: t.parentId
    //                     ? {
    //                         id: t.parentId,
    //                         taskCode: t.parentTaskCode,
    //                         title: t.parentTitle,
    //                         status: t.parentStatus,
    //                         priority: t.parentPriority,
    //                         taskType: t.parentTaskType,
    //                     }
    //                     : null,
    //             }));

    //             setAllTasks(mappedTasks);
    //             setLoading(false);
    //         })
    //         .catch(() => setLoading(false));

    // }, [token, employeeId]);

    //     useEffect(() => {
    //     if (!token) return;

    //     const roles = JSON.parse(localStorage.getItem("roles") || "[]");

    //     // ✅ Get taskId from URL
    //     const params = new URLSearchParams(window.location.search);
    //     const taskId = params.get("taskId");

    //     let url;

    //     if (roles.includes("ROLE_ADMIN")) {
    //         url = taskId
    //             ? `${API_BASE_URL}/api/tasks/${taskId}`
    //             : `${API_BASE_URL}/api/tasks`;
    //     } else {
    //         url = taskId
    //             ? `${API_BASE_URL}/api/tasks/projects-of-employee/${employeeId}/task/${taskId}`
    //             : `${API_BASE_URL}/api/tasks/projects-of-employee/${employeeId}`;
    //     }

    //     setLoading(true);

    //     fetch(url, {
    //         headers: { Authorization: "Bearer " + token },
    //     })
    //         .then(res => res.json())
    //         .then(data => {

    //             // ✅ API may return single object OR array
    //             const taskArray = Array.isArray(data) ? data : [data];

    //             if (!taskArray.length) {
    //                 setAllTasks([]);
    //                 setLoading(false);
    //                 return;
    //             }

    //             const mappedTasks = taskArray.map(t => ({
    //                 id: t.id,
    //                 title: t.title,
    //                 status: t.status,
    //                 taskCode: t.taskCode,
    //                 taskType: t.taskType,
    //                 priority: t.priority,
    //                 description: t.description,
    //                 externalUrl: t.externalUrl,
    //                 estimatedTime: t.estimatedTime,
    //                 totalTime: t.totalTime,
    //                 dueDate: t.dueDate ? new Date(t.dueDate) : null,
    //                 createdAt: t.createdAt ? new Date(t.createdAt) : null,

    //                 project: {
    //                     id: t.projectId,
    //                     name: t.projectName,
    //                 },

    //                 assignedTo: t.assigneeId
    //                     ? {
    //                           id: t.assigneeId,
    //                           firstName: t.assigneeFirstName,
    //                           lastName: t.assigneeLastName,
    //                           photoPath: t.assigneePhotoPath,
    //                       }
    //                     : null,

    //                 reporter: t.reporterId
    //                     ? {
    //                           id: t.reporterId,
    //                           firstName: t.reporterFirstName,
    //                           lastName: t.reporterLastName,
    //                           photoPath: t.reporterPhotoPath,
    //                       }
    //                     : null,

    //                 team: t.teamId
    //                     ? { id: t.teamId, name: t.teamName }
    //                     : null,

    //                 parent: t.parentId
    //                     ? {
    //                           id: t.parentId,
    //                           taskCode: t.parentTaskCode,
    //                           title: t.parentTitle,
    //                           status: t.parentStatus,
    //                           priority: t.parentPriority,
    //                           taskType: t.parentTaskType,
    //                       }
    //                     : null,
    //             }));

    //             setAllTasks(mappedTasks);
    //             setLoading(false);
    //         })
    //         .catch(() => setLoading(false));

    // }, [token, employeeId, window.location.search]);

    useEffect(() => {
        if (!token) return;

        const roles = JSON.parse(localStorage.getItem("roles") || "[]");

        // ✅ Get taskId from query param
        const params = new URLSearchParams(window.location.search);
        const taskId = params.get("taskId");

        let url = null;

        // ✅ ADMIN → always all tasks
        if (roles.includes("ROLE_ADMIN")) {
            url = `${API_BASE_URL}/api/tasks/${taskId}`;
        }
        // ✅ EMPLOYEE → must have taskId
        else if (taskId) {
            url = `${API_BASE_URL}/api/tasks/projects-of-employee/${employeeId}/task/${taskId}`;
        } else {
            // No taskId → clear task
            setAllTasks([]);
            setActiveTask(null);
            return;
        }

        setLoading(true);

        fetch(url, {
            headers: {
                Authorization: "Bearer " + token,
            },
        })
            .then(res => {

                // ✅ ACCESS DENIED (Employee not in project)
                if (res.status === 403) {
                    setAllTasks([]);
                    setActiveTask(null);

                    localStorage.removeItem("activeTaskId");
                    localStorage.removeItem("activeTaskObj");

                    setTaskError("You do not have access to this task");
                    setLoading(false);
                    return null;
                }

                if (!res.ok) {
                    throw new Error("Failed to fetch tasks");
                }

                return res.json();
            })
            .then(data => {
                if (!data) return;

                // ✅ normalize response
                const taskArray = Array.isArray(data)
                    ? data
                    : [data];

                const mappedTasks = taskArray.map(t => ({
                    id: t.id,
                    title: t.title,
                    status: t.status,
                    taskCode: t.taskCode,
                    taskType: t.taskType,
                    priority: t.priority,
                    description: t.description,
                    externalUrl: t.externalUrl,
                    estimatedTime: t.estimatedTime,
                    totalTime: t.totalTime,
                    dueDate: t.dueDate ? new Date(t.dueDate) : null,
                    createdAt: t.createdAt ? new Date(t.createdAt) : null,

                    project: {
                        id: t.projectId,
                        name: t.projectName,
                    },

                    assignedTo: t.assigneeId
                        ? {
                            id: t.assigneeId,
                            firstName: t.assigneeFirstName,
                            lastName: t.assigneeLastName,
                            photoPath: t.assigneePhotoPath,
                        }
                        : null,

                    reporter: t.reporterId
                        ? {
                            id: t.reporterId,
                            firstName: t.reporterFirstName,
                            lastName: t.reporterLastName,
                            photoPath: t.reporterPhotoPath,
                        }
                        : null,

                    team: t.teamId
                        ? { id: t.teamId, name: t.teamName }
                        : null,

                    parent: t.parentId
                        ? {
                            id: t.parentId,
                            taskCode: t.parentTaskCode,
                            title: t.parentTitle,
                            status: t.parentStatus,
                            priority: t.parentPriority,
                            taskType: t.parentTaskType,
                        }
                        : null,
                }));

                setAllTasks(mappedTasks);
                setTaskError("");
                setLoading(false);
            })
            .catch(() => {
                setLoading(false);
                setTaskError("Task not found or access denied");
            });

    }, [token, employeeId, window.location.search]);


    useEffect(() => {
        // no filtering by view anymore
        const parents = allTasks.filter(
            t => t.taskType === "Parent"
        );

        setParentTasks(parents);
        setTasks(allTasks);

    }, [allTasks]);





    // useEffect(() => {
    //     if (!employeeId || !token) return;
    //     fetch(
    //         `${API_BASE_URL}/api/tasks/mentionable-users?employeeId=${employeeId}`,
    //         { headers: { Authorization: "Bearer " + token } }
    //     )
    //         .then((res) => res.json())
    //         .then((data) => setMentionableUsers(data))
    //         .catch(() => setMentionableUsers([]));
    // }, [employeeId, token]);

    useEffect(() => {
        const fetchProjects = async () => {
            try {
                const token = localStorage.getItem("token");
                const employeeId = localStorage.getItem("employeeId");

                if (!token) return;

                let url = "";

                // 👉 ADMIN — fetch all projects
                if (roles.includes("ROLE_ADMIN")) {
                    url = `${API_BASE_URL}/api/projects`;
                }

                // 👉 MANAGER or USER — fetch employee projects
                else if (
                    roles.includes("ROLE_MANAGER") ||
                    roles.includes("ROLE_USER")
                ) {
                    if (!employeeId) {
                        console.error("Employee ID missing");
                        return;
                    }
                    url = `${API_BASE_URL}/api/manageteam/employee/${employeeId}/projects`;
                }

                const res = await fetch(url, {
                    headers: { Authorization: "Bearer " + token },
                });

                if (!res.ok) throw new Error("Failed to fetch projects");

                const data = await res.json();
                setProjects(prev => {
                    const next = Array.isArray(data) ? data : [];
                    return JSON.stringify(prev) === JSON.stringify(next) ? prev : next;
                });
            } catch (err) {
                console.error("Error loading projects:", err);
                setProjects([]);
            }
        };

        fetchProjects();
    }, []);


    useEffect(() => {
        const fetchEmployees = async () => {
            try {
                const token = localStorage.getItem("token"); // ⬅️ get token

                const response = await fetch(`${API_BASE_URL}/api/employees/active`, {
                    headers: {
                        Authorization: `Bearer ${token}`, // ⬅️ add token
                        "Content-Type": "application/json",
                    },
                });

                if (response.ok) {
                    const data = await response.json();
                    setEmployees(data);
                } else {
                    console.error("Failed to fetch employees");
                }
            } catch (error) {
                console.error("Error fetching employees:", error);
            }
        };

        fetchEmployees();
    }, []);



    useEffect(() => {
        // Need an active task AND its project
        if (!activeTask || !activeTask.project || !activeTask.project.id) {
            setMentionableUsers([]);
            return;
        }

        const projectId = activeTask.project.id;

        const fetchMentionableUsers = async () => {
            try {
                const token = localStorage.getItem("token");

                const response = await fetch(
                    `${API_BASE_URL}/api/manageteam/project/${projectId}/employees`,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            "Content-Type": "application/json",
                        },
                    }
                );

                if (response.ok) {
                    const data = await response.json();
                    setMentionableUsers(Array.isArray(data) ? data : []);
                } else {
                    console.error("Failed to fetch project employees for mentions");
                    setMentionableUsers([]);
                }
            } catch (error) {
                console.error("Error fetching mention users:", error);
                setMentionableUsers([]);
            }
        };

        fetchMentionableUsers();
    }, [activeTask]);



    useEffect(() => {
        const token = localStorage.getItem("token");

        axios.get(
            `${API_BASE_URL}/api/teams`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        )
            .then((res) => setTeams(res.data))
            .catch((err) => console.error("Error fetching teams:", err));
    }, []);



    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const taskIdFromUrl = params.get("taskId");

        // 🔴 FIRST: URL param (new tab case)
        if (taskIdFromUrl && tasks.length > 0) {
            const found = tasks.find(t => String(t.id) === taskIdFromUrl);
            if (found) {
                openTask(found);
                localStorage.setItem("activeTaskId", String(found.id));
            }
            return;
        }

        // 🟢 SECOND: localStorage (same tab refresh)
        const sessionTaskId = localStorage.getItem("activeTaskId");
        if (sessionTaskId && tasks.length > 0) {
            const found = tasks.find(t => String(t.id) === sessionTaskId);
            if (found) {
                openTask(found);
            }
        }
    }, [tasks]);



    const handleTaskDescPaste = async (e) => {
        if (!e.clipboardData) return;

        const items = Array.from(e.clipboardData.items || []);
        const imageItem = items.find(it => it.type?.startsWith("image/"));

        if (!imageItem) return;

        e.preventDefault();

        const blob = imageItem.getAsFile();
        const reader = new FileReader();

        reader.onload = () => {
            const base64 = reader.result;

            // ⭐ detect which editor is active
            const editor =
                document.activeElement === editDescEditorRef.current
                    ? editDescEditorRef.current
                    : taskDescEditorRef.current;

            if (!editor) return;

            // insert image
            insertTaskDescImage(base64, editor);

            // save attachment
            setTaskDescAttachments(prev => [
                ...prev,
                { name: blob.name || "pasted-image.png", base64 }
            ]);

            // ⭐ sync state
            setTimeout(() => {
                if (editor === editDescEditorRef.current) {
                    setEditedTask(prev => ({
                        ...prev,
                        description: editor.innerHTML
                    }));
                } else {
                    setNewTaskDescription(editor.innerHTML);
                }
            }, 0);
        };

        reader.readAsDataURL(blob);
    };


    const insertTaskDescImage = (src) => {
        // ⭐ detect active editor
        const el =
            document.activeElement === editDescEditorRef.current
                ? editDescEditorRef.current
                : taskDescEditorRef.current;

        if (!el) return;

        const img = document.createElement("img");
        img.src = src;
        img.style.maxWidth = "50%";
        img.style.display = "block";
        img.style.margin = "6px 0";

        el.focus();

        const sel = window.getSelection();

        if (!sel.rangeCount) {
            el.appendChild(img);
        } else {
            const range = sel.getRangeAt(0);
            range.deleteContents();
            range.insertNode(img);

            range.setStartAfter(img);
            range.collapse(true);

            sel.removeAllRanges();
            sel.addRange(range);
        }

        // ⭐ sync state after insert
        setTimeout(() => {
            if (el === editDescEditorRef.current) {
                setEditedTask(prev => ({
                    ...prev,
                    description: el.innerHTML
                }));
            } else {
                setNewTaskDescription(el.innerHTML);
            }
        }, 0);
    };


    // Call when opening a task
    const openTask = (task) => {
        // persist before anything else
        persistActiveTask(task);

        setActiveTask(task);

        // Clear global search when navigating to a task
        setSearchQuery("");
        setShowSearchDropdown(false);

        setComments([]);
        setCommentPage(0);
        setHasMoreComments(false);
        fetchComments(task.id, 0, false);

        fetchWorklogs(task.id);
        fetchTaskTotalLogs(task.id);
        if (editorRef.current) editorRef.current.innerHTML = "";
        setMentions([]);
        setAttachments([]);
        setEditingCommentId(null);
        setEditContent("");
        if (editRef.current) editRef.current.innerHTML = "";
    };



    const ACTIVE_TASK_KEY = "activeTaskId";
    const ACTIVE_TASK_DATA_KEY = "activeTaskObj";

    // Save active task to localStorage — strip heavy fields to avoid QuotaExceededError
    function persistActiveTask(task) {
        try {
            localStorage.setItem(ACTIVE_TASK_KEY, String(task.id));
            // Remove description (may contain base64 images) and attachments before storing
            const slim = { ...task };
            delete slim.attachments;
            //delete slim.description;
            localStorage.setItem(ACTIVE_TASK_DATA_KEY, JSON.stringify(slim));
        } catch (err) {
            // Still too large — store ID only so we can refetch on reload
            try { localStorage.removeItem(ACTIVE_TASK_DATA_KEY); } catch (_) { }
        }
    }

    // Remove stored active task
    function clearPersistedTask() {
        try {
            localStorage.removeItem(ACTIVE_TASK_KEY);
            localStorage.removeItem(ACTIVE_TASK_DATA_KEY);
        } catch (err) { }
    }


    function restoreActiveTask() {
        try {
            const id = localStorage.getItem(ACTIVE_TASK_KEY);
            const payload = localStorage.getItem(ACTIVE_TASK_DATA_KEY);

            if (!id) return; // nothing to restore

            if (payload) {
                const task = JSON.parse(payload);

                // OPEN using your existing function
                openTask(task);
            }
            else {
                // fallback: fetch task by id if you want fresh load
                fetch(`${API_BASE_URL}/api/tasks/${id}`, {
                    headers: { Authorization: "Bearer " + token },
                })
                    .then((r) => r.json())
                    .then((task) => openTask(task))
                    .catch(() => { });
            }
        } catch (err) { }
    }


    useEffect(() => {
        if (!tasks.length) return;

        const storedTask = localStorage.getItem("activeTaskObj");
        if (!storedTask) return;

        try {
            const parsedTask = JSON.parse(storedTask);

            // Find full task from current tasks list
            const fullTask = tasks.find(t => t.id === parsedTask.id);

            if (fullTask) {
                openTask(fullTask);   //opens modal
            }
        } catch (e) {
            console.error("Failed to restore active task", e);
        }
    }, [tasks]);


    useEffect(() => {

        if (!token || !projects.length) return;

        const projectIds = projects.map(p => p.id).join(",");

        fetch(
            `${API_BASE_URL}/api/tasks/count?projectIds=${projectIds}`,
            {
                headers: {
                    Authorization: "Bearer " + token,
                },
            }
        )
            .then(res => res.json())
            .then(data => {

                /*
                  Expected backend response:
                  [
                    { projectId: 1, totalTasks: 12 },
                    { projectId: 2, totalTasks: 8 }
                  ]
                */

                const countMap = {};

                data.forEach(item => {
                    countMap[item.projectId] = item.totalTasks;
                });

                setProjectTaskCounts(countMap);
            })
            .catch(err => {
                console.error("Project count error", err);
            });

    }, [projects, token]);


    useEffect(() => {
        const id = setTimeout(() => {
            restoreActiveTask();
        }, 1200); // wait until UI is visible

        return () => clearTimeout(id);
    }, []);






    const getStatusBadge = (status) => {
        switch (status) {
            case "PENDING":
                return { backgroundColor: "#64748b", color: "#fff" };

            case "IN_PROGRESS":
                return { backgroundColor: "#2563eb", color: "#fff" };

            case "READY TO REVIEW":
                return { backgroundColor: "#facc15", color: "#000" };

            case "READY TO TEST":
                return { backgroundColor: "#0ea5e9", color: "#fff" };

            case "IN TESTING":
                return { backgroundColor: "#f59e0b", color: "#000" };

            case "READY TO UPDATE":
                return { backgroundColor: "#7c3aed", color: "#fff" };

            case "WAITING FOR CUSTOMER":
                return { backgroundColor: "#6366f1", color: "#fff" };

            case "COMPLETED":
                return { backgroundColor: "#16a34a", color: "#fff" };

            case "CANCELLED":
                return { backgroundColor: "#dc2626", color: "#fff" };

            default:
                return { backgroundColor: "#6b7280", color: "#fff" };
        }
    };



    const formatH = (hours) => {
        if (!hours || isNaN(hours)) return "0m";

        const h = Math.floor(hours);
        const m = Math.round((hours - h) * 60);

        if (h > 0 && m > 0) return `${h}h ${m}m`;
        if (h > 0) return `${h}h`;
        if (m > 0) return `${m}m`;
        return "0m";
    };



    useEffect(() => {
        if (!showCreateTask) return;

        // If user opened create modal and a sidebar project is active, prefill it
        if (selectedProject && selectedProject !== "all") {
            setNewTaskProject(String(selectedProject));
        } else {
            setNewTaskProject(""); // keeps modal blank if no project selected
        }
        // focus or additional initialization can go here
    }, [showCreateTask, selectedProject]);

    useEffect(() => {
        if (newTaskProject && projectEmployees.length > 0) {
            // if logged in employee exists inside this project employee list, auto-select it
            const exists = projectEmployees.some(emp => emp.id === loggedInEmployeeId);

            if (exists) {
                setNewTaskReporter(loggedInEmployeeId);
            }
        }
    }, [newTaskProject, projectEmployees]);


    // Function to create the task
    const createTask = async () => {
        // 🔒 HARD STOP if already submitting
        if (isCreating) return;

        if (!newTaskTitle || !newTaskTitle.trim()) {
            toast.error("Task Title is required");
            return;
        }
        setIsCreating(true);

        const payload = {
            title: newTaskTitle.trim(),
            description: newTaskDescription || "",
            dueDate: newTaskDueDate || null,
            employeeId: newTaskAssignee ? Number(newTaskAssignee) : null,
            projectId: newTaskProject ? Number(newTaskProject) : null,
            reporterId: newTaskReporter ? Number(newTaskReporter) : null,
            estimatedTime: newTaskEstimatedTime ? Number(newTaskEstimatedTime) : 0,
            totalTime: newTaskTotalTime ? Number(newTaskTotalTime) : 0,
            priority: newTaskPriority || "MEDIUM",
            taskType: newTaskType || "Task",
            teamId: newTaskTeam ? Number(newTaskTeam) : null,
            parentId: newTaskParent ? Number(newTaskParent) : null,
            externalUrl: newTaskExternalUrl || null,
        };

        try {
            const token = localStorage.getItem("token");

            const response = await fetch(`${API_BASE_URL}/api/tasks/assign`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    ...(token && { Authorization: `Bearer ${token}` }),
                },
                body: JSON.stringify(payload),
            });

            if (response.ok) {
                toast.success("✅ Task created successfully!", {
                    position: "bottom-right",
                });

                setShowCreateTask(false);

                // 🚫 NO reload spam risk anymore
                setTimeout(() => {
                    window.location.reload();
                }, 500);
            } else {
                const errorText = await response.text();
                console.error("❌ Failed to create task:", errorText);
                toast.error(errorText || "Failed to create task");
            }
        } catch (error) {
            console.error("⚠️ Error creating task:", error);
            toast.error("Something went wrong");
        } finally {
            // 🔓 unlock button
            setIsCreating(false);
        }
    };



    const fetchComments = async (taskId, page = 0, append = false) => {
        if (!taskId) return;

        if (!append) {
            setCommentsLoading(true);
        } else {
            setIsLoadingMore(true);
        }

        try {
            const res = await fetch(
                `${API_BASE_URL}/api/tasks/${taskId}/comments?page=${page}&size=${COMMENTS_PAGE_SIZE}`,
                {
                    headers: { Authorization: "Bearer " + token },
                }
            );

            if (!res.ok) throw new Error("Failed to fetch comments");

            const data = await res.json();

            // data is a Page object: { content, totalElements, last, number }
            const newComments = data.content || [];
            const isLast = data.last ?? true;

            if (append) {
                setComments(prev => [...(prev || []), ...newComments]);
            } else {
                setComments(newComments);
            }

            setHasMoreComments(!isLast);
            setCommentPage(data.number ?? page);

        } catch (err) {
            console.error("Error fetching comments:", err);
            setComments([]);
        } finally {
            setCommentsLoading(false);
            setIsLoadingMore(false);
        }
    };


    // Fetch worklogs for active task
    const fetchWorklogs = (taskId) => {
        fetch(`${API_BASE_URL}/api/worklogs/employee/${employeeId}/task/${taskId}`, {
            headers: { Authorization: "Bearer " + token },
        })
            .then((res) => res.json())
            .then((data) => {
                const sorted = [...data].sort(
                    (a, b) => new Date(b.date) - new Date(a.date) // DESC
                );
                setWorklogs(sorted);
            })
            .catch(() => setWorklogs([]));
    };


    // Save a new worklog
    const saveWorklog = async () => {
        try {
            // console.log("saveWorklog() called", {
            //   activeTask,
            //   logDescription,
            //   // include all possible duration vars so we can see what's present
            //   logHours,         // if you used older name
            //   logHoursRaw,      // if you used raw editing name
            //   logHoursDisplay,  // readable shown after blur
            //   logHoursDecimal,  // numeric value used for backend
            //   billingType,
            //   logDate,
            //   editWorklogId,
            // });

            // Ensure we have a task
            if (!activeTask?.id) {
                alert("No task selected.");
                return;
            }

            // Use numeric decimal hours (fall back to parsing other fields if needed)
            const hours = typeof logHoursDecimal === "number" && logHoursDecimal > 0
                ? logHoursDecimal
                : // fallback: if you still have logHours (a numeric-like string)
                (logHours ? Number(String(logHours).replace(",", ".")) : 0);

            if (!hours || Number.isNaN(hours) || hours <= 0) {
                alert("Please enter a valid duration (e.g. 0.5 or 30m).");
                return;
            }

            // Validate description
            if (!logDescription || !String(logDescription).trim()) {
                alert("Please enter a description.");
                return;
            }

            // Ensure date
            if (!logDate) {
                alert("Please select a date.");
                return;
            }

            // Ensure token and employeeId exist (try localStorage fallback)
            const tokenLocal = typeof token !== "undefined" && token ? token : localStorage.getItem("token");
            const employeeIdLocal = typeof employeeId !== "undefined" && employeeId ? employeeId : localStorage.getItem("employeeId");

            if (!employeeIdLocal) {
                console.warn("employeeId not available in scope; using localStorage fallback", employeeIdLocal);
            }

            const payload = {
                employeeId: Number(employeeIdLocal || 0),
                taskId: Number(activeTask.id),
                description: String(logDescription).trim(),
                hours: Number(hours),
                billingType: billingType || "non-billable",
                date: logDate, // expected YYYY-MM-DD
                taskCode: activeTask.taskCode,
            };

            // console.log("Worklog payload:", payload);

            // Call API
            let res;
            const headers = {
                "Content-Type": "application/json",
                ...(tokenLocal && { Authorization: "Bearer " + tokenLocal }),
            };

            if (editWorklogId) {
                res = await fetch(`${API_BASE_URL}/api/worklogs/${editWorklogId}`, {
                    method: "PUT",
                    headers,
                    body: JSON.stringify(payload),
                });
            } else {
                res = await fetch(`${API_BASE_URL}/api/worklogs`, {
                    method: "POST",
                    headers,
                    body: JSON.stringify(payload),
                });
            }

            if (!res.ok) {
                const txt = await res.text();
                console.error("saveWorklog failed:", txt);
                alert("Failed to save worklog: " + txt);
                return;
            }

            const updatedLog = await res.json();
            // console.log("saveWorklog success:", updatedLog);
            fetchTaskTotalLogs(activeTask.id);
            fetchWorklogs(activeTask.id);

            setWorklogs(prev => {
                const safePrev = Array.isArray(prev) ? prev : [];

                if (editWorklogId) {
                    return safePrev.map(w =>
                        w.id === editWorklogId ? updatedLog : w
                    );
                }

                return [updatedLog, ...safePrev];
            });


            // Reset form: clear whichever duration fields you use in your component
            setEditWorklogId(null);
            setLogDescription("");
            // If you used the raw/display split:
            if (typeof setLogHoursRaw === "function") {
                setLogHoursRaw("");
            }
            if (typeof setLogHoursDisplay === "function") {
                setLogHoursDisplay("");
            }
            // If you used single logHours state:
            if (typeof setLogHours === "function") {
                setLogHours("");
            }
            if (typeof setLogHoursDecimal === "function") {
                setLogHoursDecimal(0);
            }

            setBillingType("billable");
            // Set default date to today if you prefer:
            setLogDate(new Date().toISOString().split("T")[0]);

            if (!logAnother) {
                setShowLogForm(false);
            } else {
                // keep modal open, but clear for next entry
                // leave date as-is (or keep today's date)
            }
        } catch (err) {
            console.error("Error saving worklog:", err);
            alert("Error saving worklog — see console for details.");
        }
    };



    const editWorklog = (log) => {
        setShowLogForm(true);
        setEditWorklogId(log.id);

        // description
        setLogDescription(log.description ?? log.notes ?? "");

        // billing type
        setBillingType(log.billingType ?? "billable");

        // date normalization: accept "YYYY-MM-DD" or ISO timestamp
        let normalizedDate = "";
        if (log.date) {
            normalizedDate = String(log.date).includes("T") ? String(log.date).split("T")[0] : String(log.date);
        } else if (log.loggedAt) {
            normalizedDate = String(log.loggedAt).includes("T") ? String(log.loggedAt).split("T")[0] : String(log.loggedAt);
        }
        setLogDate(normalizedDate || new Date().toISOString().split("T")[0]);

        // Hours: convert whatever the API returns into decimal + readable + raw states
        const decimal = ensureDecimalHours(log.hours ?? log.duration ?? log.minutes ?? log.time ?? log.loggedHours ?? 0);
        const readable = formatDecimalToReadable(decimal);

        // Set numeric hours for backend
        if (typeof setLogHoursDecimal === "function") setLogHoursDecimal(decimal);

        // Set what the input shows (we use readable as requested)
        if (typeof setLogHoursRaw === "function") setLogHoursRaw(readable);
        if (typeof setLogHoursDisplay === "function") setLogHoursDisplay(readable);

        // Backwards compatibility: if you still use `logHours` state anywhere, set it too
        if (typeof setLogHours === "function") setLogHours(readable);
    };

    const deleteWorklog = async (worklogId) => {
        if (!window.confirm("Are you sure you want to delete this worklog?")) return;
        try {
            const res = await fetch(`${API_BASE_URL}/api/worklogs/${worklogId}`, {
                method: "DELETE",
                headers: { Authorization: "Bearer " + token },
            });
            if (res.ok) {
                setWorklogs((prev) => prev.filter((w) => w.id !== worklogId));
            } else {
                console.error("Failed to delete worklog");
            }
        } catch (err) {
            console.error("Error deleting worklog:", err);
        }
    };

    const filteredLogs = Array.isArray(worklogs)
        ? worklogs.filter(log => {
            if (filterType === "date") {
                if (!fromDate || !toDate) return false;

                const logDate = new Date(log.date);
                const start = new Date(fromDate);
                const end = new Date(toDate);

                return logDate >= start && logDate <= end;
            }
            return true;
        })
        : [];

    const filteredTaskLogs = Array.isArray(taskWorklogs)
        ? taskWorklogs
            .filter(log => {
                if (filterType === "date") {
                    if (!fromDate || !toDate) return false;

                    const logDate = new Date(log.date);
                    const start = new Date(fromDate);
                    const end = new Date(toDate);

                    return logDate >= start && logDate <= end;
                }
                return true;
            })
            .sort((a, b) => new Date(b.date) - new Date(a.date))
        : [];


    const filteredTasksLogs = Array.isArray(taskWorklogs)
        ? taskWorklogs
            .filter(log => {
                if (filterType === "date") {
                    if (!fromDate || !toDate) return false;

                    const logDate = new Date(log.date);
                    const start = new Date(fromDate);
                    const end = new Date(toDate);

                    return logDate >= start && logDate <= end;
                }
                return true;
            })
            .sort((a, b) => new Date(b.date) - new Date(a.date))
        : [];



    const fetchTaskWorklogs = async (taskId) => {
        if (!taskId) {
            setTaskWorklogs([]);
            return;
        }

        try {
            const res = await fetch(
                `${API_BASE_URL}/api/worklogs/task/${taskId}`,
                {
                    headers: { Authorization: "Bearer " + token },
                }
            );

            if (!res.ok) {
                throw new Error(`Failed: ${res.status}`);
            }

            const data = await res.json();

            // ✅ data already contains ALL employees
            setTaskWorklogs(Array.isArray(data) ? data : []);
        } catch (err) {
            console.error("Failed to fetch task worklogs", err);
            setTaskWorklogs([]);
        }
    };

    useEffect(() => {
        if (activeTask?.id) {
            fetchTaskWorklogs(activeTask.id);
            fetchTaskTotalLogs(activeTask.id); // keep total logic
        }
    }, [activeTask?.id]);



    function insertHtmlAtCaret(html) {
        const sel = window.getSelection();
        if (!sel || !sel.getRangeAt || sel.rangeCount === 0) {
            // fallback: append
            if (editRef.current) editRef.current.insertAdjacentHTML("beforeend", html);
            return;
        }
        const range = sel.getRangeAt(0);
        range.deleteContents();

        // create fragment from HTML string
        const el = document.createElement("div");
        el.innerHTML = html;
        const frag = document.createDocumentFragment();
        let node;
        while ((node = el.firstChild)) {
            frag.appendChild(node);
        }
        range.insertNode(frag);

        // move caret after inserted content
        range.collapse(false);
        sel.removeAllRanges();
        sel.addRange(range);
        saveCaret(); // keep your caret state in sync
    }


    // Convert file to Base64
    const fileToBase64 = (file) =>
        new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => resolve(reader.result);
            reader.onerror = (err) => reject(err);
            reader.readAsDataURL(file);
        });

    const addBase64Attachment = async (file, opts = { widthPercent: 50 }) => {
        try {
            const { widthPercent = 50 } = opts;
            const base64 = await fileToBase64(file);

            // store attachment (include chosen percent for later upload/UI)
            setAttachments(prev => [
                ...prev,
                { name: file.name, base64, widthPercent }
            ]);

            if (!file.type.startsWith("image/") || !editorRef?.current) return;

            // create an <img> element (no need to measure natural size for percent)
            const img = document.createElement("img");
            img.src = base64;
            img.alt = file.name || "pasted-image";

            // set responsive percentage width while preventing overflow:
            img.style.width = `${widthPercent}%`;   // e.g. "50%"
            img.style.maxWidth = "100%";            // never overflow container
            img.style.height = "auto";              // preserve aspect ratio
            img.style.display = "block";
            img.style.margin = "6px 0";
            img.style.borderRadius = "6px";

            // Insert at savedRange (clone to avoid mutation) or append as fallback
            const el = editorRef.current;
            const range = savedRange ? savedRange.cloneRange() : null;
            const sel = window.getSelection();

            if (range) {
                try {
                    range.deleteContents();
                    range.insertNode(img);

                    // move caret after inserted image
                    const newRange = document.createRange();
                    newRange.setStartAfter(img);
                    newRange.collapse(true);

                    sel.removeAllRanges();
                    sel.addRange(newRange);
                    setSavedRange(newRange);
                } catch (err) {
                    // fallback: append
                    el.appendChild(img);
                    moveCaretToEnd(el);
                }
            } else {
                el.appendChild(img);
                moveCaretToEnd(el);
            }
        } catch (err) {
            console.error("addBase64Attachment (percent) error:", err);
        }
    };


    // call saveCaret() BEFORE paste (you already do this in prior examples)
    // e: ClipboardEvent
    //   const handlePaste = (e) => {
    //     const clipboard = e.clipboardData;
    //     if (!clipboard) return;

    //     /*  1. IMAGE PASTE (keep your existing logic) */
    //     if (clipboard.files && clipboard.files.length > 0) {
    //       e.preventDefault();
    //       saveCaret(); // keep caret position

    //       const file = clipboard.files[0];
    //       addBase64Attachment(file, { widthPercent: 50 });
    //       return;
    //     }

    //     /* 1.5 HTML IMAGE PASTE (Word / Docs / Outlook) */
    // const htmlData = clipboard.getData("text/html");

    // if (htmlData && htmlData.includes("<img")) {
    //   e.preventDefault();
    //   saveCaret();

    //   const temp = document.createElement("div");
    //   temp.innerHTML = htmlData;

    //   const images = temp.querySelectorAll("img");

    //   images.forEach((img) => {
    //     const src = img.getAttribute("src");
    //     if (!src) return;

    //     // insert image into editor
    //     document.execCommand(
    //       "insertHTML",
    //       false,
    //       `<img src="${src}" style="max-width:50%;height:auto;display:block;margin:6px 0;" />`
    //     );

    //     // OPTIONAL: store as attachment if needed
    //     addBase64Attachment(
    //       {
    //         name: "pasted-image.png",
    //         base64: src,
    //       },
    //       { widthPercent: 50 }
    //     );
    //   });

    //   return;
    // }


    //     /* 2. TEXT / LINK PASTE */
    //     const text = clipboard.getData("text/plain");
    //     if (!text) return;

    //     e.preventDefault(); // ⛔ VERY IMPORTANT: stop browser paste

    //     const singleUrlRegex = /^(https?:\/\/[^\s]+)$/i;
    //     const multiUrlRegex = /(https?:\/\/[^\s]+)/gi;

    //     // remove selection
    //     const sel = window.getSelection();
    //     const range = sel && sel.rangeCount ? sel.getRangeAt(0) : null;
    //     if (range) range.deleteContents();

    //     // ---- CASE 1: ONLY ONE URL (keep your existing behavior)
    //     if (singleUrlRegex.test(text.trim())) {
    //       const url = text.trim();

    //       document.execCommand(
    //         "insertHTML",
    //         false,
    //         `<a href="${url}"
    //         target="_blank"
    //         rel="noopener noreferrer"
    //         data-link="true"
    //         data-new-link="true">${url}</a>`
    //       );

    //       setTimeout(() => {
    //         const sel = window.getSelection();
    //         let node = sel?.anchorNode;
    //         if (node?.nodeType === 3) node = node.parentElement;
    //         if (node?.tagName === "A") openLinkEditor(node);
    //       }, 0);

    //       return;
    //     }

    //     // ---- CASE 2: MULTIPLE URLs / MIXED TEXT
    //     const fragment = document.createDocumentFragment();

    //     text.split(/\r\n|\r|\n/).forEach((line, i, arr) => {
    //       let lastIndex = 0;

    //       line.replace(multiUrlRegex, (url, index) => {
    //         if (index > lastIndex) {
    //           fragment.appendChild(
    //             document.createTextNode(line.slice(lastIndex, index))
    //           );
    //         }

    //         const a = document.createElement("a");
    //         a.href = url;
    //         a.textContent = url;
    //         a.target = "_blank";
    //         a.rel = "noopener noreferrer";
    //         a.setAttribute("data-link", "true");

    //         fragment.appendChild(a);
    //         lastIndex = index + url.length;
    //       });

    //       if (lastIndex < line.length) {
    //         fragment.appendChild(
    //           document.createTextNode(line.slice(lastIndex))
    //         );
    //       }

    //       if (i < arr.length - 1) {
    //         fragment.appendChild(document.createElement("br"));
    //       }
    //     });

    //     // insert fragment at caret
    //     if (range) {
    //       range.insertNode(fragment);
    //       range.collapse(false);
    //       sel.removeAllRanges();
    //       sel.addRange(range);
    //     }


    //     //  3. Normal text → let browser handle it
    //   };

    const handlePaste = (e) => {
        const clipboard = e.clipboardData;
        if (!clipboard) return;

        /*  1. IMAGE PASTE (keep your existing logic) */
        if (clipboard.files && clipboard.files.length > 0) {
            e.preventDefault();
            saveCaret(); // keep caret position

            const file = clipboard.files[0];
            addBase64Attachment(file, { widthPercent: 50 });
            return;
        }

        /*2. TEXT / LINK PASTE */
        const text = clipboard.getData("text/plain");
        if (!text) return;

        // Detect if pasted content is ONLY a URL
        const urlRegex = /^(https?:\/\/[^\s]+)$/i;

        if (urlRegex.test(text.trim())) {
            e.preventDefault();

            const url = text.trim();

            // remove any selection first
            const sel = window.getSelection();
            if (sel && sel.rangeCount) {
                sel.getRangeAt(0).deleteContents();
            }

            document.execCommand(
                "insertHTML",
                false,
                `<a
     href="${url}"
     target="_blank"
     rel="noopener noreferrer"
     data-link="true"
     data-new-link="true"
   >${url}</a>`
            );


            // setTimeout(() => {
            //   const sel = window.getSelection();
            //   let node = sel?.anchorNode;
            //   if (node?.nodeType === 3) node = node.parentElement;
            //   if (node?.tagName === "A") 
            //     openLinkEditor(node);
            // }, 0);

            return; // ⛔ VERY IMPORTANT
        }


        //  3. Normal text → let browser handle it
    };



    const handleFileUpload = (e) => {
        const files = Array.from(e.target.files);
        files.forEach(addBase64Attachment);
    };

    const removeAttachment = (index) => {
        setAttachments((prev) => prev.filter((_, i) => i !== index));
    };

    const addComment = async ({ html, text, attachments: editorAttachments }) => {
        if (isCommentSubmitting) return;
        if (!text || !activeTask) return;

        setIsCommentSubmitting(true);

        const payload = {
            text,
            html,
            mentions: mentions.map((m) => m.id),
            attachments: editorAttachments,
        };

        try {
            const res = await fetch(
                `${API_BASE_URL}/api/tasks/${activeTask.id}/comments`,
                {
                    method: "POST",
                    headers: {
                        Authorization: "Bearer " + token,
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(payload),
                }
            );

            if (!res.ok) return;

            const newComment = await res.json();
            setComments((prev) => [newComment, ...(prev || [])]);

            const draftKey = `comment_draft_task_${activeTask.id}`;
            localStorage.removeItem(draftKey);
        } catch (err) {
            console.error("Error saving comment:", err);
        } finally {
            setIsCommentSubmitting(false);
        }
    };







    const saveEdit = async (commentId) => {
        const plainTextEdit = editRef.current?.innerText?.trim() || "";

        // If there's no text and no attachments to keep/send, do nothing
        if (!plainTextEdit && (!editAttachments || editAttachments.length === 0)) return;

        const fileToBase64 = (file) =>
            new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = () => resolve(reader.result);
                reader.onerror = (e) => reject(e);
                reader.readAsDataURL(file);
            });

        // Build three things:
        // 1) keepAttachmentIds -> existing attachments the user kept (with id)
        // 2) keepAttachmentUrls -> existing attachments the user kept (with url but no id)
        // 3) newAttachments -> new files/base64 that need uploading
        const keepAttachmentIds = [];
        const keepAttachmentUrls = [];
        const newAttachments = [];
        const compatibilityAttachments = []; // old format for backwards compatibility

        // --- SYNC ATTACHMENTS AGAINST EDITOR HTML (replacement block) ---
        // read current editor html (what will be saved)
        const currentHtml = (editRef.current && editRef.current.innerHTML) || "";
        // helper: parse HTML to find image srcs and anchor hrefs and text tokens
        const temp = document.createElement("div");
        temp.innerHTML = currentHtml;

        // collect img srcs (full strings)
        const imgSrcs = Array.from(temp.querySelectorAll("img"))
            .map((img) => img.getAttribute("src"))
            .filter(Boolean);

        // collect anchor hrefs (could be file URLs)
        const anchorHrefs = Array.from(temp.querySelectorAll("a"))
            .map((a) => a.getAttribute("href"))
            .filter(Boolean);

        // collect text content tokens (useful when non-image attachments are rendered as badges with filename text)
        const textContent = temp.textContent || "";

        // helpers to check presence
        const htmlIncludes = (needle) => {
            if (!needle) return false;
            // direct equality check for src/href entries
            if (imgSrcs.includes(needle) || anchorHrefs.includes(needle)) return true;
            // fallback: substring search (useful for long data: URIs that may be slightly altered)
            return currentHtml.indexOf(needle) !== -1 || textContent.indexOf(needle) !== -1;
        };

        // reset arrays
        keepAttachmentIds.length = 0;
        keepAttachmentUrls.length = 0;
        newAttachments.length = 0;
        compatibilityAttachments.length = 0;

        for (const a of editAttachments || []) {
            if (!a) continue;

            // CASE: server-returned existing attachment with id (best-case)
            if (a.id) {
                // If the server attachment has a url, prefer to check that; else check base64
                if (a.url && htmlIncludes(a.url)) {
                    keepAttachmentIds.push(a.id);
                    compatibilityAttachments.push({ id: a.id, name: a.name, url: a.url });
                    continue;
                }
                if (a.base64 && htmlIncludes(a.base64)) {
                    keepAttachmentIds.push(a.id);
                    compatibilityAttachments.push({ id: a.id, name: a.name, base64: a.base64 });
                    continue;
                }
                // If id exists but not present in HTML, treat as removed (do not push keep)
                continue;
            }

            // CASE: attachment referenced only by url (no id)
            if (a.url) {
                if (htmlIncludes(a.url)) {
                    keepAttachmentUrls.push(a.url);
                    compatibilityAttachments.push({ url: a.url, name: a.name });
                } else {
                    // removed — skip
                }
                continue;
            }

            // CASE: base64 already present (pasted inline) -> check if it's still in HTML
            if (a.base64) {
                if (htmlIncludes(a.base64)) {
                    newAttachments.push({ name: a.name || "attachment", base64: a.base64 });
                    compatibilityAttachments.push({ name: a.name || "attachment", base64: a.base64 });
                } else {
                    // removed — skip
                }
                continue;
            }

            // CASE: File object - convert to base64 then decide if present
            if (a.file instanceof File) {
                try {
                    const base64 = await fileToBase64(a.file);
                    // If base64 is present (editor shows the pasted image) -> include as newAttachment
                    if (htmlIncludes(base64)) {
                        newAttachments.push({ name: a.name || a.file.name || "attachment", base64 });
                        compatibilityAttachments.push({ name: a.name || a.file.name || "attachment", base64 });
                    } else {
                        // Not present in HTML -> maybe user removed it -> skip
                    }
                } catch (e) {
                    console.warn("Failed to convert file to base64", a, e);
                    // fallback: if name appears in the editor text, keep a name-only compatibility entry
                    if (a.name && textContent.indexOf(a.name) !== -1) {
                        compatibilityAttachments.push({ name: a.name });
                    }
                }
                continue;
            }

            // fallback minimal: if name appears in UI text, keep it as compatibility, else skip
            if (a.name && textContent.indexOf(a.name) !== -1) {
                compatibilityAttachments.push({ name: a.name });
            }
        }



        const base = {
            text: plainTextEdit,
            html: editRef.current?.innerHTML || ""    // <-- include formatted HTML
        };

        // Build the "new" payload
        const bodyObj = {
            ...base,
            // explicit keep lists:
            ...(keepAttachmentIds.length ? { keepAttachmentIds } : {}),
            ...(keepAttachmentUrls.length ? { keepAttachmentUrls } : {}),
            ...(newAttachments.length ? { newAttachments } : {}),
            // include compatibility attachments array (so older server behavior still works)
            attachments: compatibilityAttachments,
            // optional: include mentions (if your server expects list of ids)
            ...(mentions && mentions.length ? { mentions: mentions.map(m => m.id ? m.id : (m)) } : {}),
        };

        const doFetch = async (body) =>
            fetch(`${API_BASE_URL}/api/tasks/comments/${commentId}`, {
                method: "PUT",
                headers: {
                    Authorization: "Bearer " + token,
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(body),
            });

        try {
            console.log("saveEdit payload:", JSON.stringify(bodyObj, null, 2));
            let res = await doFetch(bodyObj);

            // OPTIONAL: if your server still expects attachments as a string and returns the
            // Jackson array->String error, keep your existing retry logic here.
            if (!res.ok) {
                const errText = await res.text();
                const needsStringFallback =
                    /Cannot deserialize value of type .*java\.lang\.String.*from Array value|JsonToken\.START_ARRAY/.test(errText);

                if (needsStringFallback) {
                    // For backwards compatibility, retry with attachments as JSON-string
                    const fallback = { ...base, attachments: JSON.stringify(compatibilityAttachments) };
                    console.log("Retrying saveEdit with attachments string fallback:", JSON.stringify(fallback, null, 2));
                    res = await doFetch(fallback);
                }
            }

            if (res.ok) {
                const updated = await res.json();
                setComments((prev) => prev.map((c) => (c.id === commentId ? updated : c)));

                // cleanup
                setEditingCommentId(null);
                setEditContent("");
                if (editRef.current) editRef.current.innerHTML = "";
                setEditAttachments([]);
            } else {
                const finalErr = await res.text();
                console.error("Failed to save edit after retries:", res.status, finalErr);
            }
        } catch (err) {
            console.error("Error editing comment:", err);
        }
    };





    const submitReply = async (commentId) => {
        const token = localStorage.getItem("token");

        // Read editor HTML for inline images
        const htmlContent = replyEditorRef.current?.innerHTML || "";
        const plainText = replyEditorRef.current?.innerText?.trim() || "";

        // Nothing to send?
        if (!plainText && (!replyAttachments || replyAttachments.length === 0)) return;

        // Convert files -> base64
        const fileToBase64 = (file) =>
            new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = () => resolve(reader.result); // full dataURL
                reader.onerror = (err) => reject(err);
                reader.readAsDataURL(file);
            });

        let finalAttachments = [];

        // Convert replyAttachments to base64 JSON
        if (replyAttachments && replyAttachments.length > 0) {
            for (const att of replyAttachments) {
                if (att.base64) {
                    // already base64 (pasted image)
                    finalAttachments.push({
                        name: att.name || "image",
                        base64: att.base64,
                    });
                } else if (att.file) {
                    // convert normal uploaded file
                    const base64 = await fileToBase64(att.file);
                    finalAttachments.push({
                        name: att.name || att.file.name,
                        base64,
                    });
                }
            }
        }

        const body = {
            author: loggedUserName,
            text: plainText,
            html: htmlContent, // OPTIONAL — backend can save formatted HTML
            attachments: finalAttachments,
        };

        try {
            const res = await fetch(
                `${API_BASE_URL}/api/tasks/comments/${commentId}/replies`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + token,
                    },
                    body: JSON.stringify(body),
                }
            );

            if (!res.ok) {
                console.error("Failed to add reply:", await res.text());
                return;
            }

            const newReply = await res.json();

            // attach reply to the parent comment immediately (instant UI update)
            setComments(prev =>
                (prev || []).map(c =>
                    c.id === commentId
                        ? { ...c, replies: [...(c.replies || []), newReply] }
                        : c
                )
            );

            // cleanup UI
            setReplyContent("");
            setReplyAttachments([]);
            setReplyToCommentId(null);
            if (replyEditorRef.current) {
                replyEditorRef.current.innerHTML = "";
                replyEditorRef.current.setAttribute("data-filled", "false");
            }

        } catch (err) {
            console.error("submitReply error:", err);
        }
    };


    const deleteComment = async (commentId) => {
        if (!window.confirm("Are you sure you want to delete this comment?")) {
            return;
        }

        try {
            const res = await fetch(`${API_BASE_URL}/api/tasks/comments/${commentId}`, {
                method: "DELETE",
                headers: {
                    Authorization: "Bearer " + token,
                },
            });

            if (!res.ok) {
                const msg = await res.text();
                toast.error(`Failed to delete comment: ${msg || "Unknown error"}`);
                return;
            }

            setComments((prev) => prev.filter((c) => c.id !== commentId));
            toast.success("Comment deleted");
        } catch (err) {
            toast.error("Error deleting comment");
        }
    };


    const cancelComment = () => {
        // clear editor UI
        if (editorRef.current) {
            editorRef.current.innerHTML = "";
            editorRef.current.setAttribute("data-filled", "false");
        }

        setAttachments([]);
        setMentions([]);
        setShowSuggestions(false);

        // DELETE DRAFT
        if (activeTask?.id) {
            const draftKey = `comment_draft_task_${activeTask.id}`;
            localStorage.removeItem(draftKey);
        }
    };



    const handleEditorInput = (e) => {
        const el = e.currentTarget;
        const text = el.innerText || "";
        const html = el.innerHTML || "";

        // 🔥 FIX: get text only BEFORE cursor
        const caretText = getTextBeforeCaret(el);
        const atIndex = caretText.lastIndexOf("@");

        if (atIndex !== -1) {
            const afterAt = caretText.slice(atIndex + 1);

            // stop if space or newline typed
            if (!afterAt.includes(" ") && !afterAt.includes("\n")) {
                const query = afterAt.toLowerCase();

                const filtered = mentionableUsers.filter((u) =>
                    `${u.firstName} ${u.lastName}`.toLowerCase().includes(query)
                );

                setFilteredUsers(filtered);
                setShowSuggestions(true);
                // Always anchor to the editor element — range.getBoundingClientRect()
                // returns {0,0} for collapsed ranges in contentEditable on most browsers.
                if (editorRef.current) {
                    const er = editorRef.current.getBoundingClientRect();
                    // Always open below the editor, aligned to its left edge
                    setMentionPopupPos({ top: er.bottom + 6, left: er.left });
                }
                return;
            }
        }

        setShowSuggestions(false);

        // ✅ AUTO-SAVE DRAFT (unchanged)
        if (activeTask?.id) {
            const draftKey = getDraftKey(activeTask.id);

            if (text.trim()) {
                localStorage.setItem(
                    draftKey,
                    JSON.stringify({
                        html,
                        attachments,
                        updatedAt: Date.now(),
                    })
                );
            } else {
                localStorage.removeItem(draftKey);
            }
        }

        //  AUTO-SAVE DRAFT — SAFE VERSION (no images stored)
        // if (activeTask?.id) {
        //     const draftKey = getDraftKey(activeTask.id);

        //     if (text.trim()) {
        //         try {
        //             // remove images from html
        //             const cleanedHtml = html.replace(/<img[^>]*>/g, "");

        //             // store text only (no attachments)
        //             localStorage.setItem(
        //                 draftKey,
        //                 JSON.stringify({
        //                     html: cleanedHtml,
        //                     updatedAt: Date.now(),
        //                 })
        //             );
        //         } catch (err) {
        //             console.warn("Draft too large — skipping save");
        //         }
        //     } else {
        //         localStorage.removeItem(draftKey);
        //     }
        // }

    };


    useEffect(() => {
        if (!activeTask?.id || !editorRef.current) return;

        const draftKey = getDraftKey(activeTask.id);
        const saved = localStorage.getItem(draftKey);

        if (!saved) return;

        try {
            const { html, attachments: savedAttachments } = JSON.parse(saved);

            // restore editor content
            editorRef.current.innerHTML = html || "";
            editorRef.current.setAttribute(
                "data-filled",
                (editorRef.current.innerText || "").trim() ? "true" : "false"
            );

            // restore attachments
            if (Array.isArray(savedAttachments)) {
                setAttachments(savedAttachments);
            }

            // move caret to end
            setTimeout(() => {
                const range = document.createRange();
                range.selectNodeContents(editorRef.current);
                range.collapse(false);
                const sel = window.getSelection();
                sel.removeAllRanges();
                sel.addRange(range);
            }, 0);
        } catch (err) {
            console.error("Failed to restore comment draft", err);
        }
    }, [activeTask?.id]);



    const addMention = (user) => {
        const fullName = `${user.firstName} ${user.lastName}`;
        const editor = editorRef.current;
        if (!editor) return;

        const sel = window.getSelection();
        if (!sel) return;

        sel.removeAllRanges();
        if (savedRange) sel.addRange(savedRange);
        if (!sel.rangeCount) return;

        const range = sel.getRangeAt(0);
        const node = range.startContainer;
        let offset = range.startOffset;

        // 🔹 Remove text after the last "@"
        if (node.nodeType === Node.TEXT_NODE) {
            const textBeforeCaret = node.textContent.slice(0, offset);
            const atIndex = textBeforeCaret.lastIndexOf("@");

            if (atIndex !== -1) {
                node.textContent =
                    node.textContent.slice(0, atIndex) +
                    node.textContent.slice(offset);
                offset = atIndex;
            }
        }

        // 🔹 Create mention span
        const span = document.createElement("span");
        span.className = "mention-chip text-dark";
        span.contentEditable = "false";
        span.innerText = fullName;

        // 🔹 Insert mention
        range.setStart(node, offset);
        range.setEnd(node, offset);
        range.deleteContents();
        range.insertNode(span);

        // 🔹 Add ONE space only if needed
        const nextChar =
            node.textContent?.[offset] ||
            span.nextSibling?.textContent?.[0] ||
            "";

        let spaceNode = null;
        if (nextChar !== " ") {
            spaceNode = document.createTextNode(" ");
            span.after(spaceNode);
        }

        // 🔹 Move caret
        const newRange = document.createRange();
        newRange.setStartAfter(spaceNode || span);
        newRange.collapse(true);
        sel.removeAllRanges();
        sel.addRange(newRange);

        // 🔹 Update state
        setMentions((prev) => [...prev, user]);
        setShowSuggestions(false);
        setSavedRange(null);

        editor.focus();
    };



    const projectAssignees = (() => {
        // ALL PROJECTS view
        if (selectedProject === "all") {
            const map = new Map();

            tasks.forEach((t) => {
                if (t.assignedTo) {
                    map.set(t.assignedTo.id, t.assignedTo);
                }
            });

            return Array.from(map.values());
        }

        // SINGLE PROJECT view
        const map = new Map();

        tasks
            .filter((t) => t.project?.id.toString() === selectedProject)
            .forEach((t) => {
                if (t.assignedTo) {
                    map.set(t.assignedTo.id, t.assignedTo);
                }
            });

        return Array.from(map.values());

    })();


    function handleEditInput(e) {
        // update plain-text content state
        const text = editRef.current ? editRef.current.innerText : "";
        setEditContent(text);

        // find the token before caret that starts with '@'
        const sel = window.getSelection();
        if (!sel || sel.rangeCount === 0) {
            setReplyShowSuggestions(false);
            return;
        }

        const range = sel.getRangeAt(0);
        // create a collapsed range to the caret to get the text up to caret inside the editable
        const preRange = range.cloneRange();
        preRange.selectNodeContents(editRef.current);
        preRange.setEnd(range.endContainer, range.endOffset);
        const upToCaret = preRange.toString();

        // find last '@' that isn't followed by a space/newline between it and caret
        const atIndex = upToCaret.lastIndexOf("@");
        if (atIndex === -1) {
            setReplyShowSuggestions(false);
            return;
        }

        const token = upToCaret.slice(atIndex + 1); // text after '@' up to caret

        // if token contains space or newline, cancel
        if (/\s/.test(token)) {
            setReplyShowSuggestions(false);
            return;
        }

        // now we have a mention token e.g. "jo" — filter your users
        const q = token.toLowerCase();
        const matches = (mentionableUsers || []).filter(u => {
            const full = `${u.firstName} ${u.lastName}`.toLowerCase();
            return full.includes(q) || u.firstName.toLowerCase().startsWith(q) || u.lastName.toLowerCase().startsWith(q);
        });

        setFilteredUsers(matches.slice(0, 8)); // show top 8
        setReplyShowSuggestions(matches.length > 0);

    }

    // const fetchAuditNotifications = async () => {
    //   try {
    //     const accessibleProjectIds =
    //       selectedProject === "all"
    //         ? projects.map(p => p.id)
    //         : [Number(selectedProject)];

    //     if (!accessibleProjectIds.length) {
    //       setAuditList([]);
    //       return;
    //     }

    //     const params = new URLSearchParams();
    //     accessibleProjectIds.forEach(id => {
    //       params.append("projectIds", id);
    //     });

    //     //  FETCH BOTH
    //     const [auditRes, mentionRes] = await Promise.all([
    //       axios.get(`${API_BASE_URL}/api/tasks/project/audit`, {
    //         params,
    //         headers: { Authorization: `Bearer ${token}` }
    //       }),
    //       axios.get(`${API_BASE_URL}/api/tasks/comments/mentions`, {
    //         headers: { Authorization: `Bearer ${token}` }
    //       })
    //     ]);

    //     // console.log("AUDITS:", auditRes.data);
    //     // console.log("MENTIONS:", mentionRes.data);

    //     //  NORMALIZE
    //     const audits = (auditRes.data || []).map(a => ({
    //       ...a,
    //       type: "AUDIT",
    //       timestamp: a.changedAt
    //     }));

    //     const mentions = (mentionRes.data || []).map(m => ({
    //       auditId: `mention-${m.commentId}`,
    //       commentId: m.commentId,
    //       taskId: m.taskId,
    //       changedBy: m.author,
    //       type: "MENTION",
    //       text: m.text,
    //       isRead: m.isRead,
    //       timestamp: m.createdAt
    //     }));


    //     //  MERGE + SORT
    //     const merged = [...audits, ...mentions].sort(
    //       (a, b) => new Date(b.timestamp) - new Date(a.timestamp)
    //     );

    //     setAuditList(merged);
    //   } catch (err) {
    //     console.error("Failed to load notifications", err);
    //     setAuditList([]);
    //   }
    // };

    const loggedInUserName = localStorage.getItem("name"); // or from auth context


    //   const fetchAuditNotifications = async () => {
    //   try {
    //     const accessibleProjectIds =
    //       selectedProject === "all"
    //         ? projects.map(p => p.id)
    //         : [Number(selectedProject)];

    //     if (!accessibleProjectIds.length) {
    //       setAuditList([]);
    //       return;
    //     }

    //     const params = new URLSearchParams();
    //     accessibleProjectIds.forEach(id => {
    //       params.append("projectIds", id);
    //     });

    //     const [auditRes, mentionRes] = await Promise.all([
    //       axios.get(`${API_BASE_URL}/api/tasks/project/audit`, {
    //         params,
    //         headers: { Authorization: `Bearer ${token}` }
    //       }),
    //       axios.get(`${API_BASE_URL}/api/tasks/comments/mentions`, {
    //         headers: { Authorization: `Bearer ${token}` }
    //       })
    //     ]);

    //     const audits = (auditRes.data || []).map(a => ({
    //       ...a,
    //       type: "AUDIT",
    //       timestamp: a.changedAt
    //     }));

    //     const mentions = (mentionRes.data || []).map(m => ({
    //       auditId: `mention-${m.commentId}`,
    //       commentId: m.commentId,
    //       taskId: m.taskId,
    //       changedBy: m.author,
    //       type: "MENTION",
    //       text: m.text,
    //       isRead: m.isRead,
    //       timestamp: m.createdAt
    //     }));

    //     //  MERGE
    //     const merged = [...audits, ...mentions].sort(
    //       (a, b) => new Date(b.timestamp) - new Date(a.timestamp)
    //     );

    //     //  FRONTEND-ONLY UNREAD FILTER
    //     const unreadOnly = merged.filter(isUnread);

    //     setAuditList(unreadOnly);
    //   } catch (err) {
    //     console.error("Failed to load notifications", err);
    //     setAuditList([]);
    //   }
    // };

    const fetchAuditNotifications = async () => {
        try {
            const accessibleProjectIds =
                selectedProject === "all"
                    ? projects.map(p => p.id)
                    : [Number(selectedProject)];

            if (!accessibleProjectIds.length) {
                setAuditList([]);
                return;
            }

            const params = new URLSearchParams();
            accessibleProjectIds.forEach(id => {
                params.append("projectIds", id);
            });

            const [auditRes, mentionRes] = await Promise.all([
                axios.get(`${API_BASE_URL}/api/tasks/project/audit`, {
                    params,
                    headers: { Authorization: `Bearer ${token}` }
                }),
                axios.get(`${API_BASE_URL}/api/tasks/comments/mentions`, {
                    headers: { Authorization: `Bearer ${token}` }
                })
            ]);

            // ---------- AUDITS ----------
            const audits = (auditRes.data || [])
                // ❌ REMOVE self-generated audits
                .filter(a => a.changedBy !== loggedInUserName)
                .map(a => ({
                    ...a,
                    type: "AUDIT",
                    timestamp: a.changedAt
                }));

            // ---------- MENTIONS ----------
            const mentions = (mentionRes.data || [])
                // ❌ REMOVE self mentions
                .filter(m => m.author !== loggedInUserName)
                .map(m => ({
                    auditId: `mention-${m.commentId}`,
                    commentId: m.commentId,
                    taskId: m.taskId,
                    changedBy: m.author,
                    type: "MENTION",
                    text: m.text,
                    isRead: m.isRead,
                    timestamp: m.createdAt
                }));

            // ---------- MERGE + SORT ----------
            const merged = [...audits, ...mentions].sort(
                (a, b) => new Date(b.timestamp) - new Date(a.timestamp)
            );

            // ---------- UNREAD ONLY ----------
            const unreadOnly = merged.filter(isUnread);

            setAuditList(unreadOnly);
        } catch (err) {
            console.error("Failed to load notifications", err);
            setAuditList([]);
        }
    };




    // helper: generate consistent color from name
    const getAvatarColor = (name = "") => {
        const colors = [
            "#09d0f3", // sky blue
            "#0d6efd", // primary blue
            "#6f42c1", // purple
            "#6610f2", // deep purple
            "#198754", // green
            "#20c997", // teal
            "#0dcaf0", // cyan
            "#28a745", // emerald
            "#ffc107", // yellow
            "#fd7e14", // orange
            "#dc3545", // red
            "#e5533d", // coral
            "#d63384", // pink
            "#adb5bd", // light gray
            "#6c757d", // gray
            "#495057", // dark gray
            "#343a40", // charcoal
            "#8b5cf6", // violet
            "#22c55e", // lime green
            "#14b8a6", // aqua
            "#f97316", // deep orange
            "#ef4444", // strong red
            "#3b82f6", // modern blue
            "#6366f1", // indigo
        ];


        let hash = 5381;
        for (let i = 0; i < name.length; i++) {
            hash = ((hash << 5) + hash) + name.charCodeAt(i); // hash * 33 + c
        }

        return colors[Math.abs(hash) % colors.length];
    };


    useEffect(() => {
        if (!showNotifications) return;

        fetchAuditNotifications();

        const interval = setInterval(fetchAuditNotifications, 10000);

        return () => clearInterval(interval);
    }, [showNotifications, selectedProject]);


    const SERVER_TZ_CUTOFF = new Date("2025-07-01T00:00:00Z"); // ← same cutoff date

    const safeRelativeTime = (dateStr) => {
        if (!dateStr) return "";

        const d = new Date(dateStr);
        if (isNaN(d.getTime())) return "";

        // Old data stored in UTC → convert to IST
        // New data already in IST → use as-is
        if (d < SERVER_TZ_CUTOFF) {
            const IST_OFFSET = 5.5 * 60 * 60 * 1000;
            const istDate = new Date(d.getTime() + IST_OFFSET);
            return formatDistanceToNow(istDate, { addSuffix: true });
        }

        return formatDistanceToNow(d, { addSuffix: true });
    };



    const formatAuditMessage = (a) => {
        const fieldMap = {
            status: "Status",
            priority: "Priority",
            assignedTo: "Assignee",
            reporter: "Reporter",
            team: "Team",
            parent: "Parent Task",
            project: "Project",
            description: "Description"
        };

        const field =
            fieldMap[a.fieldName] ||
            a.fieldName.charAt(0).toUpperCase() + a.fieldName.slice(1);

        // ⭐ Special handling for description
        if (a.fieldName === "description") {
            const preview = stripHtml(a.newValue).slice(0, 60);

            return `${a.changedBy} updated ${field}${preview ? ` — "${preview}${preview.length >= 60 ? "…" : ""}"` : ""
                }`;
        }

        const oldVal = a.oldValue ?? "—";
        const newVal = a.newValue ?? "—";

        return `${a.changedBy} changed ${field} from ${oldVal} → ${newVal}`;
    };

    const groupByDate = (audits) => {
        const today = new Date();
        const yesterday = new Date();
        yesterday.setDate(today.getDate() - 1);

        return audits.reduce(
            (groups, a) => {
                const d = new Date(a.timestamp || a.changedAt)
                    ;
                if (isNaN(d.getTime())) return groups;

                if (d.toDateString() === today.toDateString()) {
                    groups.today.push(a);
                } else if (d.toDateString() === yesterday.toDateString()) {
                    groups.yesterday.push(a);
                } else {
                    groups.earlier.push(a);
                }

                return groups;
            },
            { today: [], yesterday: [], earlier: [] }
        );
    };


    const grouped = groupByDate(auditList);

    const isUnread = (a) => {
        //  MENTION notification
        if (a.type === "MENTION") {
            // if backend sends isRead flag (boolean)
            if (typeof a.isRead === "boolean") {
                return !a.isRead;
            }

            // OR if backend sends readByEmployeeIds (CSV or array)
            if (a.readByEmployeeIds) {
                const ids = Array.isArray(a.readByEmployeeIds)
                    ? a.readByEmployeeIds.map(String)
                    : a.readByEmployeeIds.split(",").map(id => id.trim());

                return !ids.includes(String(loggedInEmployeeId));
            }

            // default → unread
            return true;
        }

        //  AUDIT notification (USER based)
        if (!a.readBy || a.readBy.trim() === "") return true;

        return !a.readBy
            .split(",")
            .map(id => id.trim())
            .includes(String(loggedInUserId));
    };





    const markNotificationAsRead = async (n) => {
        try {
            // already read → do nothing
            if (!isUnread(n)) return;

            //  AUDIT (USER-based)
            if (n.type === "AUDIT") {
                await axios.put(
                    `${API_BASE_URL}/api/tasks/audit/${n.auditId}/read`,
                    {},
                    { headers: { Authorization: `Bearer ${token}` } }
                );

                //  update local state
                setAuditList(prev =>
                    prev.map(item =>
                        item.auditId === n.auditId
                            ? { ...item, readBy: `${item.readBy || ""},${loggedInUserId}` }
                            : item
                    )
                );
            }

            //  MENTION (EMPLOYEE-based)
            if (n.type === "MENTION") {
                await axios.put(
                    `${API_BASE_URL}/api/tasks/comments/${n.commentId}/mention-read`,
                    {},
                    { headers: { Authorization: `Bearer ${token}` } }
                );

                //  update local state
                setAuditList(prev =>
                    prev.map(item =>
                        item.auditId === n.auditId
                            ? { ...item, isRead: true }
                            : item
                    )
                );
            }

        } catch (err) {
            console.error("Failed to mark notification as read", err);
        }
    };




    const unreadCount = useMemo(
        () => auditList.filter(isUnread).length,
        [auditList]
    );

    const getAuditInitials = (name = "") => {
        if (!name) return "?";
        return name
            .trim()
            .split(/\s+/)
            .slice(0, 2)
            .map(n => n[0].toUpperCase())
            .join("");
    };




    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                notificationRef.current &&
                !notificationRef.current.contains(event.target) &&
                bellRef.current &&
                !bellRef.current.contains(event.target)
            ) {
                setShowNotifications(false);
            }
        };

        if (showNotifications) {
            document.addEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [showNotifications]);


    const getTaskById = (taskId) => {
        return tasks.find(t => t.id === taskId);
    };



    // fetch once when project changes
    useEffect(() => {
        if (token && projects.length > 0) {
            fetchAuditNotifications();
        }
    }, [selectedProject]); // NOT projects

    useEffect(() => {
        if (activeCommentTab === "history" && activeTask?.id) {
            fetchTaskAudit(activeTask.id);
        }
    }, [activeCommentTab, activeTask?.id]);

    const fetchTaskAudit = async (taskId) => {
        try {
            const res = await axios.get(
                `${API_BASE_URL}/api/tasks/${taskId}/audit`,
                { headers: { Authorization: `Bearer ${token}` } }
            );
            setAuditList(res.data || []);
        } catch (err) {
            console.error("Failed to load audit history", err);
            setAuditList([]);
        }
    };




    const FIELD_LABELS = {
        status: "Status",
        description: "Description",
        priority: "Priority",
        assignedTo: "Assignee",
        dueDate: "Due Date",
        startDate: "Start Date",
        endDate: "End Date",
        parent: "Parent",
        taskType: "Task Type",
        title: "Title",
        team: "Team",
        estimatedTime: "Estimated Time",
        externalUrl: "External Task Url",
    };



    const resetLogForm = () => {
        setLogDescription("");
        setLogHours("");
        setLogHoursRaw("");
        setLogHoursDecimal(0);
        setLogDate(new Date().toISOString().split("T")[0]);
        setSelectedDate(new Date());
        setBillingType("billable");
        setLogAnother(false);
        setEditWorklogId(null); // safe if used for edit mode
    };


    //   const markAllNotificationsAsRead = async () => {
    //   const unread = auditList.filter(isUnread);

    //   // 🔥 Optimistic UI update
    //   setAuditList(prev =>
    //     prev.map(n => {
    //       if (!isUnread(n)) return n;

    //       if (n.type === "MENTION") {
    //         return { ...n, isRead: true };
    //       }

    //       return {
    //         ...n,
    //         readBy: n.readBy
    //           ? `${n.readBy},${loggedInUserId}`
    //           : String(loggedInUserId)
    //       };
    //     })
    //   );

    //   // 🔄 Backend sync
    //   for (const n of unread) {
    //     await markNotificationAsRead(n);
    //   }
    // };


    const downloadFileAsBlob = (file) => {
        if (!file?.base64) return;

        try {
            const base64Data = file.base64.includes(",")
                ? file.base64.split(",")[1]
                : file.base64;

            const mime = "application/pdf"; // or use getMimeType(file.name)

            const byteCharacters = atob(base64Data);
            const byteNumbers = new Array(byteCharacters.length);

            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }

            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: mime });

            const blobUrl = URL.createObjectURL(blob);

            const link = document.createElement("a");
            link.href = blobUrl;
            link.download = file.name || "file.pdf";
            document.body.appendChild(link);
            link.click();
            link.remove();

            setTimeout(() => URL.revokeObjectURL(blobUrl), 60000);

        } catch (err) {
            console.error("Download failed:", err);
        }
    };


    const stripHtml = (html) => {
        if (!html) return "";
        const div = document.createElement("div");
        div.innerHTML = html;
        return div.textContent || div.innerText || "";
    };


    const rolePriority = [
        { role: "ROLE_ADMIN", component: <AdminNavbar /> },
        { role: "ROLE_MANAGER", component: <ManagerNavbar /> },
        { role: "ROLE_USER", component: <EmployeeNavbar /> },
    ];

    const navbar = rolePriority.find(r => roles.includes(r.role))?.component;

    const handleTimesheetNavigation = () => {
        switch (effectiveRole) {
            case "ROLE_ADMIN":
                navigate("/admintimesheetgrid", { state: { employeeId } });
                break;

            case "ROLE_MANAGER":
                navigate("/managertimesheet", { state: { employeeId } });
                break;

            case "ROLE_USER":
                navigate("/timesheetgrid", { state: { employeeId } });
                break;

            default:
                navigate("/");
        }
    };

    const getViewTasksPathByRole = () => {
        switch (effectiveRole) {
            case "ROLE_ADMIN":
                return "/adminviewtasks";

            case "ROLE_MANAGER":
                return "/viewtaskss";

            case "ROLE_USER":
                return "/viewtasks";

            default:
                navigate("/");
        }
    };

    const handleBoardNavigation = () => {
        switch (effectiveRole) {
            case "ROLE_ADMIN":
                navigate("/adminviewtasks");
                break;

            case "ROLE_MANAGER":
                navigate("/viewtaskss");
                break;

            case "ROLE_USER":
                navigate("/viewtasks");
                break;

            default:
                navigate("/");
        }
    };

    const handleDescriptionClick = (e) => {
        // If user clicked an image → preview only
        if (e.target.tagName === "IMG") {
            handleDescriptionImageClick(e);
            return;
        }

        // Otherwise → open edit mode
        setEditedTask({ ...activeTask });
        setEditField("description");
    };

    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === "Escape") {
                // close preview
                setPreviewImages([]);
                setCurrentImageIndex(0);
            }
        };

        document.addEventListener("keydown", handleKeyDown);

        return () => document.removeEventListener("keydown", handleKeyDown);
    }, []);


    const ctLabelStyle = { display: "block", marginBottom: 6, fontSize: 11, fontWeight: 700, color: "#5E6C84", textTransform: "uppercase", letterSpacing: ".07em", };
    const ctInputStyle = { height: 38, borderRadius: 8, border: "1.5px solid #DFE1E6", fontSize: 13.5, color: "#172B4D", background: "#fff", width: "100%" };
    const ctIconStyle = { position: "absolute", top: "50%", left: 10, transform: "translateY(-50%)", fontSize: 13, color: "#8993A4", pointerEvents: "none", zIndex: 2 };
    const ctToolStyle = { width: 28, height: 28, borderRadius: 6, border: "1px solid transparent", background: "transparent", display: "inline-flex", alignItems: "center", justifyContent: "center", cursor: "pointer", color: "#42526E", fontSize: 13 };
    const dropdownStyle = {
        display: "none",
        position: "absolute",
        top: "calc(100% + 4px)",
        left: 0,
        right: 0,
        background: "#fff",
        border: "1.5px solid #DFE1E6",
        borderRadius: 10,
        boxShadow: "0 8px 28px rgba(0,0,0,.13)",
        zIndex: 1200,
    };


    useEffect(() => {
        const handler = (e) => {
            const dropdowns = [
                { panel: "ct-project-panel", trigger: "ct-project-trigger" },
                { panel: "ct-team-panel", trigger: "ct-team-trigger" },
                { panel: "ct-parent-panel", trigger: "ct-parent-trigger" },
                { panel: "ct-asgn-panel", trigger: "ct-asgn-trigger" },
            ];

            dropdowns.forEach(d => {
                const panel = document.getElementById(d.panel);
                if (!panel) return;

                if (
                    !panel.contains(e.target) &&
                    !e.target.closest(`#${d.trigger}`)
                ) {
                    panel.style.display = "none";
                }
            });
        };

        document.addEventListener("mousedown", handler);
        return () => document.removeEventListener("mousedown", handler);
    }, []);


    useEffect(() => {
        if (!newTaskProject) return;

        fetch(`${API_BASE_URL}/api/tasks/project/${newTaskProject}/parent-tasks`, {
            headers: {
                Authorization: "Bearer " + localStorage.getItem("token"),
            },
        })
            .then(res => res.json())
            .then(data => {
                setParentTasks(data || []);
            })
            .catch(() => setParentTasks([]));
    }, [newTaskProject]);


    useEffect(() => {
        if (!activeTask?.project?.id) return;

        fetch(`${API_BASE_URL}/api/tasks/project/${activeTask.project.id}/parent-tasks`, {
            headers: {
                Authorization: "Bearer " + localStorage.getItem("token"),
            },
        })
            .then(res => res.json())
            .then(data => {
                setParentTasks(data || []);
            })
            .catch(err => {
                console.error("Failed to load parent tasks:", err);
                setParentTasks([]);
            });

    }, [activeTask?.project?.id]);


    const insertTable = (rows, cols) => {
        const el = editorRef.current;
        if (!el) return;

        el.focus();

        let tableHtml = `<table style="border-collapse:collapse;width:100%;margin:8px 0;">`;
        for (let r = 0; r < rows; r++) {
            tableHtml += `<tr>`;
            for (let c = 0; c < cols; c++) {
                tableHtml += `<td style="border:1px solid #ccc;padding:6px 10px;min-width:60px;">&nbsp;</td>`;
            }
            tableHtml += `</tr>`;
        }
        tableHtml += `</table><p><br></p>`;

        const sel = window.getSelection();
        if (sel && sel.rangeCount > 0) {
            const range = sel.getRangeAt(0);
            range.deleteContents();
            const div = document.createElement("div");
            div.innerHTML = tableHtml;
            const frag = document.createDocumentFragment();
            let node;
            while ((node = div.firstChild)) frag.appendChild(node);
            range.insertNode(frag);
            range.collapse(false);
            sel.removeAllRanges();
            sel.addRange(range);
        } else {
            el.innerHTML += tableHtml;
        }

        setShowTablePicker(false);
        saveCaret();
    };


    const insertEditTable = (rows, cols) => {
        const el = editRef.current;
        if (!el) return;

        el.focus();

        let tableHtml = `<table style="border-collapse:collapse;width:100%;margin:8px 0;">`;
        for (let r = 0; r < rows; r++) {
            tableHtml += `<tr>`;
            for (let c = 0; c < cols; c++) {
                tableHtml += `<td style="border:1px solid #ccc;padding:6px 10px;min-width:60px;">&nbsp;</td>`;
            }
            tableHtml += `</tr>`;
        }
        tableHtml += `</table><p><br></p>`;

        const sel = window.getSelection();
        if (sel && sel.rangeCount > 0) {
            const range = sel.getRangeAt(0);
            range.deleteContents();
            const div = document.createElement("div");
            div.innerHTML = tableHtml;
            const frag = document.createDocumentFragment();
            let node;
            while ((node = div.firstChild)) frag.appendChild(node);
            range.insertNode(frag);
            range.collapse(false);
            sel.removeAllRanges();
            sel.addRange(range);
        } else {
            el.innerHTML += tableHtml;
        }

        setShowEditTablePicker(false);
        saveCaret();
    };

    const insertEditDescTable = (rows, cols) => {
        const el = editDescEditorRef.current;
        if (!el) return;

        el.focus();

        let tableHtml = `<table style="border-collapse:collapse;width:100%;margin:8px 0;">`;
        for (let r = 0; r < rows; r++) {
            tableHtml += `<tr>`;
            for (let c = 0; c < cols; c++) {
                tableHtml += `<td style="border:1px solid #ccc;padding:6px 10px;min-width:60px;">&nbsp;</td>`;
            }
            tableHtml += `</tr>`;
        }
        tableHtml += `</table><p><br></p>`;

        const sel = window.getSelection();
        if (sel && sel.rangeCount > 0) {
            const range = sel.getRangeAt(0);
            range.deleteContents();
            const div = document.createElement("div");
            div.innerHTML = tableHtml;
            const frag = document.createDocumentFragment();
            let node;
            while ((node = div.firstChild)) frag.appendChild(node);
            range.insertNode(frag);
            range.collapse(false);
            sel.removeAllRanges();
            sel.addRange(range);
        } else {
            el.innerHTML += tableHtml;
        }

        setShowEditDescTablePicker(false);
        saveCaret();
    };

    const insertDescTable = (rows, cols) => {
        const el = taskDescEditorRef.current;
        if (!el) return;

        el.focus();

        let tableHtml = `<table style="border-collapse:collapse;width:100%;margin:8px 0;">`;
        for (let r = 0; r < rows; r++) {
            tableHtml += `<tr>`;
            for (let c = 0; c < cols; c++) {
                tableHtml += `<td style="border:1px solid #ccc;padding:6px 10px;min-width:60px;">&nbsp;</td>`;
            }
            tableHtml += `</tr>`;
        }
        tableHtml += `</table><p><br></p>`;

        const sel = window.getSelection();
        if (sel && sel.rangeCount > 0) {
            const range = sel.getRangeAt(0);
            range.deleteContents();
            const div = document.createElement("div");
            div.innerHTML = tableHtml;
            const frag = document.createDocumentFragment();
            let node;
            while ((node = div.firstChild)) frag.appendChild(node);
            range.insertNode(frag);
            range.collapse(false);
            sel.removeAllRanges();
            sel.addRange(range);
        } else {
            el.innerHTML += tableHtml;
        }

        setShowDescTablePicker(false);
        saveCaret();
    };

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (tablePickerRef.current && !tablePickerRef.current.contains(e.target)) {
                setShowTablePicker(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (tablePickerRef.current && !tablePickerRef.current.contains(e.target)) {
                setShowEditTablePicker(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (tablePickerRef.current && !tablePickerRef.current.contains(e.target)) {
                setShowEditDescTablePicker(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (tablePickerRef.current && !tablePickerRef.current.contains(e.target)) {
                setShowDescTablePicker(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);


    const externalUrl = activeTask?.externalUrl;

    const etaskId = externalUrl?.split("/tasks/")[1]?.split("/")[0];

    const saveExternalComments = async (comments) => {
        let savedCount = 0;

        for (const comment of comments) {
            try {
                const payload = {
                    text: comment.text,
                    html: comment.html || comment.text,
                    externalId: comment.id,
                    mentions: [],
                    attachments: [],
                };

                const res = await fetch(
                    `${API_BASE_URL}/api/tasks/${activeTask.id}/comments`,
                    {
                        method: "POST",
                        headers: {
                            Authorization: "Bearer " + token,
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify(payload),
                    }
                );

                if (!res.ok) continue;

                const result = await res.text();

                if (result !== "Duplicate skipped") {
                    const newComment = JSON.parse(result);

                    setComments(prev => [newComment, ...(prev || [])]);

                    savedCount++;
                }

            } catch (err) {
                console.error(err);
            }
        }


        return savedCount;
    };

    const handleGetComments = async () => {
        if (isFetchingComments) return; // prevent double click

        setIsFetchingComments(true);

        try {
            const configRes = await axios.get(
                `${API_BASE_URL}/api/teamwork/project/${activeTask.project?.id}/employee/${employeeId}`,
                {
                    headers: {
                        Authorization: "Bearer " + token,
                    },
                }
            );

            const config = configRes.data;

            if (!config) {
                toast.info("Integration not enabled for this project");
                return;
            }

            const baseUrl = config.apiBaseUrl;
            const accessToken = config.accessToken;

            const res = await axios.get(
                `${baseUrl}/tasks/${etaskId}/comments.json`,
                {
                    headers: {
                        Authorization: accessToken,
                        "Content-Type": "application/json",
                    },
                }
            );

            const commentsData = (res.data.comments || [])
                .filter(c => {
                    if (String(c.author_id) === "413023") return false;

                    const commentDate = new Date(c["last-changed-on"]);

                    const today = new Date();
                    const yesterday = new Date();
                    yesterday.setDate(today.getDate() - 1);

                    // normalize (remove time)
                    const formatDate = (d) =>
                        new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();

                    const commentDay = formatDate(commentDate);
                    const todayDay = formatDate(today);
                    const yesterdayDay = formatDate(yesterday);

                    return commentDay === todayDay || commentDay === yesterdayDay;
                })
                .map(c => ({
                    id: c.id,
                    text: c.body,
                    html: c["html-body"],
                }))
                .filter(c => c.text);



            const savedCount = await saveExternalComments(commentsData);

            // show only ONE message
            toast.dismiss();

            if (savedCount === 0) {
                toast.info("No new comments available");
            } else {
                toast.success(`${savedCount} comments saved successfully`);
            }

        } catch (error) {
            console.error(error);
            toast.error("Failed to fetch/save comments");
        } finally {
            setIsFetchingComments(false); // always stop loading
        }
    };


    useEffect(() => {
        const fetchConfigs = async () => {
            try {
                const res = await axios.get(
                    `${API_BASE_URL}/api/teamwork/employee/${employeeId}`,
                    {
                        headers: {
                            Authorization: "Bearer " + token,
                        },
                    }
                );

                setTeamworkConfigs(res.data || []);

            } catch (err) {
                console.error("Error fetching teamwork config", err);
            }
        };

        fetchConfigs();
    }, [employeeId]);


    const hasTeamworkAccess = () => {
        if (!activeTask) return false;

        return teamworkConfigs.some(
            c => String(c.projectId) === String(activeTask.project?.id)
        );
    };


    const lastCommentDate = (() => {
        if (!lastComment?.createdAt) return null;
        const d = new Date(lastComment.createdAt);
        if (isNaN(d.getTime())) return null;

        if (d < SERVER_TZ_CUTOFF) {
            const IST_OFFSET = 330 * 60 * 1000;
            return format(new Date(d.getTime() + IST_OFFSET), "dd MMM yyyy, hh:mm a");
        }
        return format(d, "dd MMM yyyy, hh:mm a");
    })();


    if (loading) return <div className="text-center mt-5">Loading...</div>;

    return (

        <>
            {/* Navbar fixed on top */}
            <div className="fixed-top">
                {navbar}
            </div>

            {/* ══ JIRA-STYLE SHELL (below fixed navbar) ══ */}
            <div className="tp-root">
                <div className="tp-shell">

                    {/* ══ LEFT SIDEBAR ══ */}
                    <aside className={`tp-lsidebar${isSidebarCollapsed ? " collapsed" : ""}`}>
                        <div className="tp-ls__header">
                            <span className="tp-ls__title">Projects</span>
                            <button
                                className="tp-ls__toggle"
                                onClick={() => setIsSidebarCollapsed(prev => !prev)}
                                title={isSidebarCollapsed ? "Expand sidebar" : "Collapse sidebar"}
                            >
                                <i className={`bi ${isSidebarCollapsed ? "bi-chevron-right" : "bi-chevron-left"}`}></i>
                            </button>
                        </div>
                        {/* 
                        <button
                            className="tp-ls__new-btn"
                            onClick={() => setShowCreateTask(true)}
                        >
                            <i className="bi bi-plus-lg"></i>
                            <span>Create Task</span>
                        </button> */}

                        <div className="tp-ls__section">
                            {/* <div className="tp-ls__section-label">Projects</div> */}

                            {/* All Projects */}
                            <div
                                className={`tp-ls__item${selectedProject === "all" ? " active" : ""}`}
                                onClick={() => {
                                    setShowProjects(prev => !prev); // toggle open/close

                                    // Optional: also select all
                                    setSelectedProject("all");
                                    localStorage.setItem("selectedProject", "all");
                                }}
                                title="Dashboard"
                            >
                                <div className="tp-ls__item-icon" style={{ background: "#DEEBFF", color: "#0052CC" }}>
                                    <i className={`bi ${showProjects ? "bi-chevron-down" : "bi-chevron-right"}`}></i>
                                </div>
                                <span className="tp-ls__item-text">All Projects</span>
                            </div>

                            {/* Project items */}
                            {showProjects && projects.map((p) => (
                                <div
                                    key={p.id}
                                    className={`tp-ls__item${String(selectedProject) === String(p.id) ? " active" : ""}`}
                                    onClick={() => {
                                        const projectId = String(p.id);
                                        setSelectedProject(projectId);
                                        localStorage.setItem("selectedProject", projectId);
                                        setActiveTask(null);
                                        localStorage.removeItem("activeTaskId");
                                        localStorage.removeItem("activeTaskObj");
                                        navigate({
                                            pathname: getViewTasksPathByRole(),
                                            search: `?projectId=${projectId}`
                                        }, { replace: true, state: null });
                                    }}
                                    title={p.name}
                                >
                                    <div className="tp-ls__item-icon" style={{ background: "#EAE6FF", color: "#403294" }}>
                                        {/* <i className="bi bi-briefcase-fill"></i> */}
                                        <i className="bi bi-kanban-fill"></i>
                                    </div>
                                    <span className="tp-ls__item-text">{p.name}</span>
                                    <span className="tp-ls__item-count">{projectTaskCounts[p.id] || 0}</span>
                                </div>
                            ))}

                            <div className="tp-ls__section-label" style={{ marginTop: 8 }}>Quick Links</div>
                            <div
                                className="tp-ls__item"
                                onClick={handleTimesheetNavigation}
                            >
                                <div className="tp-ls__item-icon" style={{ background: "#E3FCEF", color: "#006644" }}>
                                    <i className="bi bi-clock"></i>
                                </div>
                                <span className="tp-ls__item-text">Timesheet</span>
                            </div>
                        </div>
                    </aside>

                    {/* ══ MAIN CONTENT ══ */}
                    <main className="tp-main-content">

                        {/* ── Top bar: left placeholder | search+create center | bell right ── */}
                        <div className="tp-topbar">
                            {/* Left — empty spacer so grid works */}
                            <div className="tp-topbar__left"></div>

                            {/* Center — search + create */}
                            <div className="tp-topbar__center">
                                <div className="tp-topbar__search" style={{ position: "relative" }}>
                                    <i className="bi bi-search"></i>
                                    <input
                                        ref={searchInputRef}
                                        type="text"
                                        placeholder="Search tasks by title, code, description…"
                                        value={searchQuery}
                                        onChange={e => {
                                            setSearchQuery(e.target.value);
                                            setShowSearchDropdown(true);
                                        }}
                                        onFocus={() => setShowSearchDropdown(true)}
                                        onKeyDown={e => {
                                            if (e.key === "Escape") {
                                                setSearchQuery("");
                                                setShowSearchDropdown(false);
                                                searchInputRef.current?.blur();
                                            }
                                        }}
                                        autoComplete="off"
                                    />
                                    {searchQuery && (
                                        <button
                                            className="tp-search-clear"
                                            onClick={() => { setSearchQuery(""); setShowSearchDropdown(false); }}
                                            title="Clear (Esc)"
                                        >
                                            ×
                                        </button>
                                    )}

                                    {/* ── Search dropdown ── */}
                                    {showSearchDropdown && searchQuery.trim().length >= 1 && (
                                        <div
                                            ref={searchDropdownRef}
                                            className="tp-search-dropdown"
                                            style={{
                                                position: "absolute",
                                                top: "calc(100% + 8px)",
                                                left: 0,
                                                right: 0,
                                                width: "auto",
                                                background: "#fff",
                                                border: "1px solid #E4E8EF",
                                                borderRadius: 12,
                                                boxShadow: "0 16px 48px rgba(9,30,66,0.22), 0 0 0 1px rgba(9,30,66,0.04)",
                                                zIndex: 9999,
                                                overflow: "hidden",
                                                animation: "tpFadeIn 0.15s ease",
                                            }}
                                        >
                                            {/* ── Header ── */}
                                            {/* Inject style AFTER Bootstrap Icons so our font-family wins */}
                                            <style dangerouslySetInnerHTML={{
                                                __html: `
                                        .tp-search-header-txt {
                                            font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Arial, sans-serif !important;
                                            font-size: 12px !important;
                                            color: #5E6C84 !important;
                                            margin: 0 !important; padding: 0 !important;
                                        }
                                    ` }} />
                                            <div style={{
                                                padding: "9px 14px",
                                                background: "#F8FAFF",
                                                borderBottom: "1px solid #E8ECF4",
                                                display: "flex", justifyContent: "space-between", alignItems: "center",
                                            }}>
                                                <p className="tp-search-header-txt">
                                                    {searchResults.length > 0
                                                        ? `${searchResults.length} task${searchResults.length !== 1 ? "s" : ""} found`
                                                        : `No results for "${searchQuery}"`
                                                    }
                                                </p>
                                                <span style={{
                                                    fontSize: 11, color: "#0052CC",
                                                    background: "#DEEBFF", padding: "2px 9px",
                                                    borderRadius: 999, fontWeight: 600,
                                                }}>
                                                    {selectedProject === "all"
                                                        ? "All projects"
                                                        : projects.find(p => String(p.id) === String(selectedProject))?.name || ""}
                                                </span>
                                            </div>

                                            {/* ── Empty state ── */}
                                            {searchResults.length === 0 && (
                                                <div style={{ padding: "32px 16px", textAlign: "center" }}>
                                                    <div style={{
                                                        width: 48, height: 48, borderRadius: "50%",
                                                        background: "#F4F5F7", margin: "0 auto 12px",
                                                        display: "flex", alignItems: "center", justifyContent: "center",
                                                    }}>
                                                        {/* <i className="bi bi-search" style={{ fontSize: 20, color: "#8993A4" }}></i> */}
                                                    </div>
                                                    <div style={{ fontSize: 14, fontWeight: 600, color: "#172B4D", marginBottom: 4 }}>
                                                        No tasks found
                                                    </div>
                                                    <div style={{ fontSize: 12, color: "#8993A4" }}>
                                                        Try searching by task title, code (e.g. BALIN-001), or description
                                                    </div>
                                                </div>
                                            )}

                                            {/* ── Results ── */}
                                            <div style={{ maxHeight: 420, overflowY: "auto" }}>
                                                {searchResults.map((task, idx) => {
                                                    const q = searchQuery.toLowerCase();
                                                    const titleMatch = (task.title || "").toLowerCase().includes(q);
                                                    const codeMatch = (task.taskCode || "").toLowerCase().includes(q);
                                                    const descRaw = (task.description || "").replace(/<[^>]*>/g, "");
                                                    const descIdx = descRaw.toLowerCase().indexOf(q);
                                                    const descSnippet = descIdx >= 0
                                                        ? "…" + descRaw.slice(Math.max(0, descIdx - 25), descIdx + 55) + "…"
                                                        : null;

                                                    const statusMap = {
                                                        "IN_PROGRESS": { bg: "#DEEBFF", color: "#0747A6", label: "In Progress" },
                                                        "PENDING": { bg: "#EBECF0", color: "#5E6C84", label: "To Do" },
                                                        "COMPLETED": { bg: "#E3FCEF", color: "#006644", label: "Completed" },
                                                        "CANCELLED": { bg: "#FFEBE6", color: "#BF2600", label: "Cancelled" },
                                                        "READY TO REVIEW": { bg: "#FFFAE6", color: "#974F0C", label: "Ready to Review" },
                                                        "IN TESTING": { bg: "#FFF0B3", color: "#974F0C", label: "In Testing" },
                                                        "READY TO TEST": { bg: "#E6FCFF", color: "#006680", label: "Ready to Test" },
                                                        "READY TO UPDATE": { bg: "#EAE6FF", color: "#403294", label: "Ready to Update" },
                                                        "WAITING FOR CUSTOMER": { bg: "#EAE6FF", color: "#403294", label: "Waiting" },
                                                    };
                                                    const sc = statusMap[task.status] || { bg: "#EBECF0", color: "#5E6C84", label: task.status };

                                                    const typeIconMap = {
                                                        "Bug": {
                                                            bg: "#FFEBE6",
                                                            icon: "bi-bug-fill",
                                                            color: "#dc2626", // red
                                                        },
                                                        "Feature": {
                                                            icon: "bi-lightning-charge-fill",
                                                            color: "#7c3aed", // purple
                                                            bg: "#E3FCEF",

                                                        },
                                                        "Improvement": {
                                                            icon: "bi-arrow-up-right-circle",
                                                            color: "#0d9488", // teal
                                                            bg: "#EAE6FF",

                                                        },
                                                        "Task": {
                                                            icon: "bi-card-checklist",
                                                            color: "#2563eb", // blue
                                                            bg: "#DEEBFF",

                                                        }
                                                    };
                                                    const ti = typeIconMap[task.taskType] || typeIconMap["Task"];

                                                    const assigneeName = task.assigneeFirstName
                                                        ? `${task.assigneeFirstName} ${task.assigneeLastName || ""}`.trim()
                                                        : null;
                                                    const assigneeInitials = task.assigneeFirstName
                                                        ? `${task.assigneeFirstName[0]}${task.assigneeLastName?.[0] || ""}`.toUpperCase()
                                                        : null;

                                                    return (
                                                        <div
                                                            key={task.id}
                                                            onMouseDown={(e) => {
                                                                e.preventDefault();
                                                                setShowSearchDropdown(false);
                                                                setSearchQuery("");

                                                                navigate(`/tasks?taskId=${task.id}`);
                                                            }}
                                                            style={{
                                                                display: "flex",
                                                                alignItems: "center",
                                                                gap: 12,
                                                                padding: "11px 16px",
                                                                cursor: "pointer",
                                                                borderBottom: idx < searchResults.length - 1 ? "1px solid #F1F3F8" : "none",
                                                                transition: "background 0.1s ease",
                                                            }}
                                                            onMouseEnter={e => e.currentTarget.style.background = "#F0F7FF"}
                                                            onMouseLeave={e => e.currentTarget.style.background = "transparent"}
                                                        >
                                                            {/* Task type icon */}
                                                            <div className="tp-task-icon" style={{
                                                                width: 32,
                                                                height: 32,
                                                                borderRadius: 8,
                                                                background: ti.bg,
                                                                color: ti.color,
                                                                display: "flex",
                                                                alignItems: "center",
                                                                justifyContent: "center"
                                                            }}>
                                                                <span className={`bi ${ti.icon}`}></span>
                                                            </div>

                                                            {/* Main content */}
                                                            <div style={{ flex: 1, minWidth: 0 }}>
                                                                {/* Row 1: code + status + project */}
                                                                <div style={{ display: "flex", alignItems: "center", gap: 6, marginBottom: 3, flexWrap: "wrap" }}>
                                                                    <span style={{
                                                                        fontFamily: "'JetBrains Mono', monospace",
                                                                        fontSize: 11, fontWeight: 700,
                                                                        color: "#0052CC", background: "#DEEBFF",
                                                                        padding: "1px 7px", borderRadius: 4, flexShrink: 0,
                                                                        letterSpacing: "0.02em",
                                                                    }}>
                                                                        {task.taskCode}
                                                                    </span>
                                                                    <span style={{
                                                                        fontSize: 10, fontWeight: 700, textTransform: "uppercase",
                                                                        letterSpacing: "0.05em",
                                                                        background: sc.bg, color: sc.color,
                                                                        padding: "2px 8px", borderRadius: 999, flexShrink: 0,
                                                                    }}>
                                                                        {sc.label}
                                                                    </span>
                                                                    {task.projectName && (
                                                                        <span style={{
                                                                            fontSize: 11, color: "#8993A4",
                                                                            display: "flex", alignItems: "center", gap: 3,
                                                                        }}>
                                                                            {/* <i className="bi bi-folder2" style={{ fontSize: 10 }}></i> */}
                                                                            {task.projectName}
                                                                        </span>
                                                                    )}
                                                                </div>

                                                                {/* Row 2: title */}
                                                                <div style={{
                                                                    fontSize: 13.5, fontWeight: 500, color: "#172B4D",
                                                                    whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis",
                                                                    lineHeight: 1.4,
                                                                }}
                                                                    dangerouslySetInnerHTML={{ __html: highlightText(task.title || "", searchQuery) }}
                                                                />

                                                                {/* Row 3: description snippet (only if match is in description) */}
                                                                {descSnippet && !titleMatch && !codeMatch && (
                                                                    <div style={{
                                                                        fontSize: 11.5, color: "#8993A4", marginTop: 2,
                                                                        whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis",
                                                                    }}
                                                                        dangerouslySetInnerHTML={{ __html: highlightText(descSnippet, searchQuery) }}
                                                                    />
                                                                )}
                                                            </div>

                                                            {/* Right side: assignee avatar */}
                                                            {assigneeName && (
                                                                <div title={assigneeName} style={{
                                                                    width: 26, height: 26, borderRadius: "50%",
                                                                    background: task.assigneePhotoPath
                                                                        ? "transparent"
                                                                        : `hsl(${(assigneeName.charCodeAt(0) * 47) % 360}, 60%, 50%)`,
                                                                    color: "#fff", fontSize: 10, fontWeight: 700,
                                                                    display: "flex", alignItems: "center", justifyContent: "center",
                                                                    flexShrink: 0, overflow: "hidden",
                                                                    border: "1.5px solid #fff",
                                                                    boxShadow: "0 0 0 1px #DFE1E6",
                                                                }}>
                                                                    {task.assigneePhotoPath
                                                                        ? <img src={`${API_BASE_URL}/uploads/${task.assigneePhotoPath}`} alt="" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                                                                        : assigneeInitials
                                                                    }
                                                                </div>
                                                            )}

                                                            {/* Arrow */}
                                                            {/* <i className="bi bi-chevron-right" style={{ color: "#C1C7D0", fontSize: 12, flexShrink: 0 }}></i> */}
                                                        </div>
                                                    );
                                                })}
                                            </div>

                                            {/* ── Footer ── */}
                                            {searchResults.length > 0 && (
                                                <div style={{
                                                    padding: "7px 14px",
                                                    background: "#F8FAFF",
                                                    borderTop: "1px solid #E8ECF4",
                                                    display: "flex", alignItems: "center", justifyContent: "space-between",
                                                }}>
                                                    {/* <div style={{ display: "flex", alignItems: "center", gap: 12, fontSize: 11, color: "#8993A4" }}>
                                                        <span style={{ display: "flex", alignItems: "center", gap: 5 }}>
                                                            <kbd style={{ background: "#fff", border: "1px solid #DFE1E6", borderRadius: 4, padding: "2px 6px", fontSize: 10, fontFamily: "inherit", lineHeight: 1.4 }}>↵</kbd>
                                                            open
                                                        </span>
                                                        <span style={{ display: "flex", alignItems: "center", gap: 5 }}>
                                                            <kbd style={{ background: "#fff", border: "1px solid #DFE1E6", borderRadius: 4, padding: "2px 6px", fontSize: 10, fontFamily: "inherit", lineHeight: 1.4 }}>Esc</kbd>
                                                            close
                                                        </span>
                                                    </div> */}
                                                    <span style={{ fontSize: 11, color: "#8993A4" }}>
                                                        Top {searchResults.length} result{searchResults.length !== 1 ? "s" : ""}
                                                    </span>
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </div>
                                <button
                                    className="tp-btn-primary"
                                    style={{ fontSize: 13, padding: "5px 14px" }}
                                    onClick={() => setShowCreateTask(true)}
                                >
                                    <i className="bi bi-plus-lg"></i> Create
                                </button>
                            </div>

                            {/* Right — bell */}
                            <div className="tp-topbar__right">
                                <button
                                    ref={bellRef}
                                    className="tp-topbar__bell"
                                    onClick={() => setShowNotifications(prev => !prev)}
                                >
                                    <i className="bi bi-bell"></i>
                                    {unreadCount > 0 && (
                                        <span className="tp-badge">{unreadCount > 10 ? "10+" : unreadCount}</span>
                                    )}
                                </button>
                            </div>
                        </div>

                        {/* 🔽 Dropdown */}
                        {showNotifications && (
                            <div
                                ref={notificationRef}
                                className="audit-dropdown jira-style"
                            >

                                {/* ===== HEADER ===== */}
                                <div className="audit-header">
                                    <span>Notifications</span>
                                    <span className="audit-count">
                                        {auditList.filter(isUnread).length}
                                    </span>
                                </div>

                                {/* <div className="audit-header">
                <span className="audit-title">Notifications</span>

                <div className="audit-header-actions">
                  <span className="audit-count">
                    {auditList.filter(isUnread).length}
                  </span>

                  {auditList.some(isUnread) && (
                    <button
                      className="mark-all-read"
                      onClick={async () => {
                        await markAllNotificationsAsRead();
                      }}
                    >
                      Mark all as read
                    </button>
                  )}
                </div>
              </div> */}

                                {/* ===== TODAY ===== */}
                                {grouped.today.length > 0 && (
                                    <>
                                        <div className="audit-section-label">Today</div>

                                        {grouped.today.map((a) => {
                                            const task = getTaskById(a.taskId);

                                            return (
                                                <div
                                                    key={a.auditId}
                                                    className={`audit-item ${isUnread(a) ? "unread" : ""}`}
                                                    onClick={async () => {
                                                        if (isUnread(a)) {
                                                            await markNotificationAsRead(a);
                                                        }

                                                        setShowNotifications(false);

                                                        const task = getTaskById(a.taskId);
                                                        if (task) openTask(task);
                                                    }}

                                                >
                                                    {/* Avatar */}
                                                    <div
                                                        className="audit-avatar"
                                                        style={{ backgroundColor: getAvatarColor(a.changedBy) }}
                                                    >
                                                        {getAuditInitials(a.changedBy)}
                                                    </div>

                                                    {/* Content */}
                                                    <div className="audit-content">
                                                        {/* Audit message */}
                                                        <div className="audit-message">
                                                            {a.type === "MENTION" ? (
                                                                <>
                                                                    <strong>{a.changedBy}</strong> mentioned you in a comment
                                                                    <div className="mention-preview">
                                                                        “{a.text?.slice(0, 80)}{a.text?.length > 80 ? "…" : ""}”
                                                                    </div>
                                                                </>
                                                            ) : (
                                                                formatAuditMessage(a)
                                                            )}
                                                        </div>

                                                        {/* Task info */}
                                                        {task && (
                                                            <div className="audit-task">
                                                                {/* Title */}
                                                                <div
                                                                    className="audit-task-title"
                                                                    title={task.title}
                                                                >
                                                                    {task.title?.length > 30
                                                                        ? `${task.title.slice(0, 30)}…`
                                                                        : task.title}
                                                                </div>


                                                                {/* Code • Status */}
                                                                <div className="audit-task-meta">
                                                                    <span className="task-code">{task.taskCode}</span>
                                                                    <span className="meta-dot">•</span>
                                                                    <span
                                                                        className={`task-status status-${task.status
                                                                            ?.toLowerCase()
                                                                            .replace(/\s+/g, "-")}`}
                                                                    >
                                                                        {task.status}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        )}
                                                        <div className="audit-meta">
                                                            <span className="audit-time">
                                                                {safeRelativeTime(a.timestamp)}
                                                            </span>
                                                        </div>
                                                    </div>

                                                    {/* Unread dot */}
                                                    {isUnread(a) && (
                                                        <div
                                                            className="audit-dot"
                                                            onClick={async (e) => {
                                                                e.stopPropagation();
                                                                await markNotificationAsRead(a);
                                                            }}
                                                        />
                                                    )}
                                                </div>
                                            );
                                        })}
                                    </>
                                )}

                                {/* ===== YESTERDAY ===== */}
                                {grouped.yesterday.length > 0 && (
                                    <>
                                        <div className="audit-section-label">Yesterday</div>

                                        {grouped.yesterday.map((a) => {
                                            const task = getTaskById(a.taskId);

                                            return (
                                                <div
                                                    key={a.auditId}
                                                    className={`audit-item ${isUnread(a) ? "unread" : ""}`}
                                                    onClick={async () => {
                                                        if (isUnread(a)) {
                                                            await markNotificationAsRead(a);
                                                        }

                                                        setShowNotifications(false);

                                                        const task = getTaskById(a.taskId);
                                                        if (task) openTask(task);
                                                    }}
                                                >
                                                    <div
                                                        className="audit-avatar"
                                                        style={{ backgroundColor: getAvatarColor(a.changedBy) }}
                                                    >
                                                        {getAuditInitials(a.changedBy)}
                                                    </div>

                                                    <div className="audit-content">


                                                        <div className="audit-message">
                                                            {a.type === "MENTION" ? (
                                                                <>
                                                                    <strong>{a.changedBy}</strong> mentioned you in a comment
                                                                    <div className="mention-preview">
                                                                        “{a.text?.slice(0, 80)}{a.text?.length > 80 ? "…" : ""}”
                                                                    </div>
                                                                </>
                                                            ) : (
                                                                formatAuditMessage(a)
                                                            )}
                                                        </div>
                                                        {task && (
                                                            <div className="audit-task">
                                                                {/* Title */}
                                                                <div
                                                                    className="audit-task-title"
                                                                    title={task.title}
                                                                >
                                                                    {task.title?.length > 30
                                                                        ? `${task.title.slice(0, 30)}…`
                                                                        : task.title}
                                                                </div>

                                                                {/* Code • Status */}
                                                                <div className="audit-task-meta">
                                                                    <span className="task-code">{task.taskCode}</span>
                                                                    <span className="meta-dot">•</span>
                                                                    <span
                                                                        className={`task-status status-${task.status
                                                                            ?.toLowerCase()
                                                                            .replace(/\s+/g, "-")}`}
                                                                    >
                                                                        {task.status}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        )}

                                                        <div className="audit-meta">
                                                            <span className="audit-time">
                                                                {safeRelativeTime(a.timestamp)}
                                                            </span>
                                                        </div>
                                                    </div>

                                                    {isUnread(a) && (
                                                        <div
                                                            className="audit-dot"
                                                            onClick={async (e) => {
                                                                e.stopPropagation();
                                                                await markNotificationAsRead(a);
                                                            }}
                                                        />
                                                    )}
                                                </div>
                                            );
                                        })}
                                    </>
                                )}

                                {/* ===== EARLIER ===== */}
                                {grouped.earlier.length > 0 && (
                                    <>
                                        <div className="audit-section-label">Earlier</div>

                                        {grouped.earlier.map((a) => {
                                            const task = getTaskById(a.taskId);

                                            return (
                                                <div
                                                    key={a.auditId}
                                                    className={`audit-item ${isUnread(a) ? "unread" : ""}`}
                                                    onClick={async () => {
                                                        if (isUnread(a)) {
                                                            await markNotificationAsRead(a);
                                                        }

                                                        setShowNotifications(false);

                                                        const task = getTaskById(a.taskId);
                                                        if (task) openTask(task);
                                                    }}
                                                >
                                                    <div
                                                        className="audit-avatar"
                                                        style={{ backgroundColor: getAvatarColor(a.changedBy) }}
                                                    >
                                                        {getAuditInitials(a.changedBy)}
                                                    </div>

                                                    <div className="audit-content">
                                                        <div className="audit-message">
                                                            {a.type === "MENTION" ? (
                                                                <>
                                                                    <strong>{a.changedBy}</strong> mentioned you in a comment
                                                                    <div className="mention-preview">
                                                                        “{a.text?.slice(0, 80)}{a.text?.length > 80 ? "…" : ""}”
                                                                    </div>
                                                                </>
                                                            ) : (
                                                                formatAuditMessage(a)
                                                            )}
                                                        </div>
                                                        {task && (
                                                            <div className="audit-task">
                                                                {/* Title */}
                                                                <div
                                                                    className="audit-task-title"
                                                                    title={task.title}
                                                                >
                                                                    {task.title?.length > 30
                                                                        ? `${task.title.slice(0, 30)}…`
                                                                        : task.title}
                                                                </div>

                                                                {/* Code • Status */}
                                                                <div className="audit-task-meta">
                                                                    <span className="task-code">{task.taskCode}</span>
                                                                    <span className="meta-dot">•</span>
                                                                    <span
                                                                        className={`task-status status-${task.status
                                                                            ?.toLowerCase()
                                                                            .replace(/\s+/g, "-")}`}
                                                                    >
                                                                        {task.status}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        )}

                                                        <div className="audit-meta">
                                                            <span className="audit-time">
                                                                {safeRelativeTime(a.timestamp)}
                                                            </span>
                                                        </div>
                                                    </div>

                                                    {isUnread(a) && (
                                                        <div
                                                            className="audit-dot"
                                                            onClick={async (e) => {
                                                                e.stopPropagation();
                                                                await markNotificationAsRead(a);
                                                            }}
                                                        />
                                                    )}
                                                </div>
                                            );
                                        })}
                                    </>
                                )}

                                {/* ===== EMPTY ===== */}
                                {auditList.length === 0 && (
                                    <div className="audit-empty">
                                        No recent activity
                                    </div>
                                )}
                            </div>
                        )}

                        {/* Create Task Popup Modal — rendered via Portal so it escapes tp-root stacking context */}
                        {showCreateTask && createPortal((
                            <>
                                {/* Backdrop */}
                                <div
                                    className="modal-backdrop fade show"
                                    onClick={() => { resetCreateTaskForm(); setShowCreateTask(false); }}
                                    style={{ cursor: "pointer" }}
                                />

                                {/* Modal */}
                                <div
                                    className="modal show fade d-block"
                                    tabIndex="-1"
                                    role="dialog"
                                    onClick={e => e.stopPropagation()}
                                >
                                    <div
                                        className="modal-dialog modal-dialog-centered"
                                        role="document"
                                        style={{ maxWidth: 960 }}
                                    >
                                        <div
                                            className="modal-content border-0 overflow-hidden"
                                            style={{ borderRadius: 20, boxShadow: "0 32px 80px rgba(0,0,0,.22)" }}
                                        >
                                            <form onSubmit={e => { e.preventDefault(); createTask(); }}>

                                                {/* ── Header ── */}
                                                <div style={{ background: "linear-gradient(135deg,#0052CC 0%,#2684FF 100%)", padding: "22px 28px 18px", position: "relative", overflow: "hidden" }}>
                                                    <div style={{ position: "absolute", top: -30, right: -30, width: 140, height: 140, borderRadius: "50%", background: "rgba(255,255,255,.07)" }} />
                                                    <div style={{ position: "absolute", bottom: -20, right: 80, width: 80, height: 80, borderRadius: "50%", background: "rgba(255,255,255,.05)" }} />
                                                    <div className="d-flex align-items-center justify-content-between" style={{ position: "relative", zIndex: 1 }}>
                                                        <div className="d-flex align-items-center gap-3">
                                                            <div style={{ width: 40, height: 40, borderRadius: 12, background: "rgba(255,255,255,.18)", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                                                <i className="bi bi-plus-lg" style={{ color: "#fff", fontSize: 18 }} />
                                                            </div>
                                                            <div>
                                                                <h5 style={{ color: "#fff", fontWeight: 700, margin: 0, fontSize: 17, letterSpacing: "-.02em" }}>
                                                                    Create {newTaskType || "Task"}
                                                                </h5>
                                                                <p style={{ color: "rgba(255,255,255,.7)", margin: 0, fontSize: 12.5 }}>
                                                                    {newTaskProject
                                                                        ? (projects.find(p => String(p.id) === String(newTaskProject))?.name || "Project") + " · Fill in the details below"
                                                                        : "Fill in the details to create a new item"}
                                                                </p>
                                                            </div>
                                                        </div>
                                                        <button
                                                            type="button"
                                                            onClick={() => { resetCreateTaskForm(); setShowCreateTask(false); }}
                                                            style={{ background: "rgba(255,255,255,.15)", border: "none", width: 32, height: 32, borderRadius: 8, display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", color: "#fff", fontSize: 16 }}
                                                        >
                                                            <i className="bi bi-x-lg" />
                                                        </button>
                                                    </div>
                                                </div>

                                                {/* ── Task Type Selector ── */}
                                                <div style={{ background: "#F4F5F7", borderBottom: "1px solid #E8EAF0", padding: "12px 28px", display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
                                                    <span style={{ fontSize: 11, fontWeight: 700, color: "#8993A4", textTransform: "uppercase", letterSpacing: ".07em", marginRight: 4 }}>Type:</span>
                                                    {[
                                                        { value: "Task", icon: "bi-card-checklist", color: "#2563EB" },
                                                        { value: "Bug", icon: "bi-bug-fill", color: "#DC2626" },
                                                        { value: "Feature", icon: "bi-lightning-charge-fill", color: "#7C3AED" },
                                                        { value: "Improvement", icon: "bi-arrow-up-right-circle", color: "#0D9488" },
                                                        { value: "Parent", icon: "bi-diagram-3-fill", color: "#EA580C" },
                                                    ].map(t => (
                                                        <button
                                                            key={t.value}
                                                            type="button"
                                                            onClick={() => setNewTaskType(t.value)}
                                                            style={{
                                                                display: "inline-flex", alignItems: "center", gap: 6,
                                                                padding: "5px 13px", borderRadius: 999, fontSize: 12.5, fontWeight: 600, cursor: "pointer",
                                                                border: newTaskType === t.value ? `1.5px solid ${t.color}` : "1.5px solid #DFE1E6",
                                                                background: newTaskType === t.value ? `${t.color}15` : "#fff",
                                                                color: newTaskType === t.value ? t.color : "#5E6C84",
                                                                boxShadow: newTaskType === t.value ? `0 0 0 3px ${t.color}18` : "none",
                                                                transition: "all .14s",
                                                            }}
                                                        >
                                                            <i className={`bi ${t.icon}`} style={{ fontSize: 12 }} />
                                                            {t.value}
                                                        </button>
                                                    ))}
                                                </div>

                                                {/* ── Body ── */}
                                                <div style={{ display: "grid", gridTemplateColumns: "1fr 300px", maxHeight: "calc(100vh - 280px)", overflow: "auto" }}>

                                                    {/* LEFT column */}
                                                    <div style={{ padding: "24px 24px 24px 28px", borderRight: "1px solid #F0F1F3" }}>

                                                        {/* Title */}
                                                        <div style={{ marginBottom: 20 }}>
                                                            <label style={ctLabelStyle}>Task Title <span style={{ color: "#EF4444" }}>*</span></label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                placeholder="What needs to be done?"
                                                                value={newTaskTitle}
                                                                onChange={e => setNewTaskTitle(e.target.value)}
                                                                required
                                                                style={ctInputStyle}
                                                            />
                                                        </div>

                                                        {/* Project + Team */}
                                                        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14, marginBottom: 20 }}>
                                                            <div style={{ display: "flex", flexDirection: "column" }}>
                                                                <label style={ctLabelStyle}>Project</label>

                                                                <div style={{ position: "relative" }}>
                                                                    <i className="bi bi-kanban-fill" style={ctIconStyle} />

                                                                    <button
                                                                        id="ct-project-trigger"
                                                                        type="button"
                                                                        onClick={() => {
                                                                            const el = document.getElementById("ct-project-panel");
                                                                            if (el) el.style.display = el.style.display === "block" ? "none" : "block";
                                                                        }}
                                                                        style={{
                                                                            ...ctInputStyle,
                                                                            paddingLeft: 34,
                                                                            display: "flex",
                                                                            justifyContent: "space-between",
                                                                            alignItems: "center",
                                                                            height: 38,
                                                                            cursor: "pointer"
                                                                        }}
                                                                    >
                                                                        <span style={{
                                                                            flex: 1,
                                                                            textAlign: "left",
                                                                            whiteSpace: "nowrap",
                                                                            overflow: "hidden",
                                                                            textOverflow: "ellipsis",
                                                                        }}>
                                                                            {projects.find(p => String(p.id) === String(newTaskProject))?.name || "Select project…"}
                                                                        </span>
                                                                    </button>

                                                                    <div
                                                                        id="ct-project-panel"
                                                                        style={{
                                                                            display: "none",
                                                                            position: "absolute",
                                                                            top: "calc(100% + 4px)",
                                                                            left: 0,
                                                                            right: 0,
                                                                            background: "#fff",
                                                                            border: "1.5px solid #DFE1E6",
                                                                            borderRadius: 10,
                                                                            boxShadow: "0 8px 28px rgba(0,0,0,.13)",
                                                                            zIndex: 1200
                                                                        }}
                                                                    >
                                                                        <div style={{ maxHeight: 220, overflowY: "auto" }}>
                                                                            {projects.map(p => {
                                                                                const selected = String(p.id) === String(newTaskProject);
                                                                                return (
                                                                                    <div
                                                                                        key={p.id}
                                                                                        onClick={() => {
                                                                                            setNewTaskProject(p.id);
                                                                                            document.getElementById("ct-project-panel").style.display = "none";
                                                                                        }}
                                                                                        style={{
                                                                                            display: "flex",
                                                                                            alignItems: "center",
                                                                                            gap: 8,
                                                                                            padding: "9px 12px",
                                                                                            cursor: "pointer",
                                                                                            background: selected ? "#EFF6FF" : "#fff"
                                                                                        }}
                                                                                    >
                                                                                        <i className="bi bi-kanban-fill me-2" />
                                                                                        <div
                                                                                            style={{
                                                                                                flex: 1,
                                                                                                whiteSpace: "nowrap",
                                                                                                overflow: "hidden",
                                                                                                textOverflow: "ellipsis",
                                                                                            }}
                                                                                            title={p.name}
                                                                                        >
                                                                                            {p.name}
                                                                                        </div>
                                                                                        {selected && <i className="bi bi-check2 float-end" />}
                                                                                    </div>
                                                                                );
                                                                            })}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div style={{ display: "flex", flexDirection: "column" }}>
                                                                <label style={ctLabelStyle}>Team</label>

                                                                <div style={{ position: "relative" }}>
                                                                    <i className="bi bi-people-fill" style={ctIconStyle} />

                                                                    <button
                                                                        id="ct-team-trigger"
                                                                        type="button"
                                                                        disabled={!newTaskProject}
                                                                        onClick={() => {
                                                                            const el = document.getElementById("ct-team-panel");
                                                                            if (el) el.style.display = el.style.display === "block" ? "none" : "block";
                                                                        }}
                                                                        style={{
                                                                            ...ctInputStyle,
                                                                            paddingLeft: 34,
                                                                            height: 38,
                                                                            display: "flex",
                                                                            justifyContent: "space-between",
                                                                            alignItems: "center",
                                                                            opacity: !newTaskProject ? 0.55 : 1
                                                                        }}
                                                                    >
                                                                        <span style={{
                                                                            flex: 1,
                                                                            textAlign: "left",
                                                                            whiteSpace: "nowrap",
                                                                            overflow: "hidden",
                                                                            textOverflow: "ellipsis",
                                                                        }}>
                                                                            {teams.find(t => String(t.id) === String(newTaskTeam))?.name || "Select team…"}
                                                                        </span>
                                                                    </button>

                                                                    <div id="ct-team-panel" style={dropdownStyle}>
                                                                        <div style={{ maxHeight: 220, overflowY: "auto" }}>
                                                                            {teams.map(t => {
                                                                                const selected = String(t.id) === String(newTaskTeam);
                                                                                return (
                                                                                    <div
                                                                                        key={t.id}
                                                                                        onClick={() => {
                                                                                            setNewTaskTeam(t.id);
                                                                                            document.getElementById("ct-team-panel").style.display = "none";
                                                                                        }}
                                                                                        style={{
                                                                                            padding: "9px 12px",
                                                                                            cursor: "pointer",
                                                                                            display: "flex",
                                                                                            alignItems: "center",
                                                                                            gap: 8,
                                                                                            background: selected ? "#EFF6FF" : "#fff"
                                                                                        }}
                                                                                    >
                                                                                        <div
                                                                                            style={{
                                                                                                flex: 1,
                                                                                                whiteSpace: "nowrap",
                                                                                                overflow: "hidden",
                                                                                                textOverflow: "ellipsis",
                                                                                            }}
                                                                                            title={t.name}
                                                                                        >
                                                                                            {t.name}
                                                                                        </div>
                                                                                        {selected && <i className="bi bi-check2 float-end" />}
                                                                                    </div>
                                                                                );
                                                                            })}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {/* External URL */}
                                                        <div>
                                                            <label style={ctLabelStyle}>External Task URL</label>
                                                            <div style={{ position: "relative", marginBottom: 20 }}>
                                                                <i className="bi bi-link" style={ctIconStyle} />
                                                                <input
                                                                    type="url"
                                                                    className="form-control"
                                                                    placeholder="https://example.com/ticket/123"
                                                                    value={newTaskExternalUrl}
                                                                    onChange={e => setNewTaskExternalUrl(e.target.value)}
                                                                    style={{ ...ctInputStyle, paddingLeft: 34 }}
                                                                />
                                                            </div>
                                                        </div>

                                                        {/* Description */}
                                                        <div style={{ marginBottom: 20 }}>
                                                            <label style={ctLabelStyle}>Description</label>
                                                            <NewDescriptionEditor
                                                                mentionableUsers={mentionableUsers}
                                                                placeholder="Describe this task…"
                                                                submitLabel={null}         // hide the submit button
                                                                showCancelBtn={false}      // hide cancel too
                                                                autoFocus={false}
                                                                onSubmit={() => { }}        // no-op (save happens on create)
                                                                onDraft={(html) => setNewTaskDescription(html)}  // live sync
                                                            />
                                                        </div>


                                                    </div>
                                                    {/* END LEFT column */}

                                                    {/* RIGHT column */}
                                                    <div style={{ padding: "24px 20px", background: "#FAFBFC", display: "flex", flexDirection: "column", gap: 18 }}>

                                                        {/* Assignee */}
                                                        <div>
                                                            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 6 }}>
                                                                <label style={{ ...ctLabelStyle, marginBottom: 0 }}>Assignee</label>
                                                                {newTaskReporter && (
                                                                    <button
                                                                        type="button"
                                                                        onClick={() => setNewTaskAssignee(newTaskReporter)}
                                                                        style={{ background: "none", border: "none", padding: 0, fontSize: 11.5, color: "#0052CC", fontWeight: 600, cursor: "pointer", textDecoration: "underline" }}
                                                                    >
                                                                        Assign to me
                                                                    </button>
                                                                )}
                                                            </div>
                                                            {/* Custom photo dropdown trigger */}
                                                            <div style={{ position: "relative" }}>
                                                                <button
                                                                    type="button"
                                                                    disabled={!newTaskProject}
                                                                    onClick={() => {
                                                                        if (!newTaskProject) return;
                                                                        const panel = document.getElementById("ct-asgn-panel");
                                                                        if (panel) panel.style.display = panel.style.display === "none" ? "block" : "none";
                                                                        setTimeout(() => { const s = document.getElementById("ct-asgn-srch"); if (s) s.focus(); }, 50);
                                                                    }}
                                                                    style={{ width: "100%", height: 38, borderRadius: 8, border: "1.5px solid #DFE1E6", background: !newTaskProject ? "#F4F5F7" : "#fff", display: "flex", alignItems: "center", gap: 9, padding: "0 10px", cursor: !newTaskProject ? "not-allowed" : "pointer", opacity: !newTaskProject ? 0.55 : 1 }}
                                                                >
                                                                    {projectEmployees.find(e => String(e.id) === String(newTaskAssignee)) ? (
                                                                        <>
                                                                            {projectEmployees.find(e => String(e.id) === String(newTaskAssignee)).photoPath ? (
                                                                                <img
                                                                                    src={`${API_BASE_URL}/uploads/${projectEmployees.find(e => String(e.id) === String(newTaskAssignee)).photoPath}`}
                                                                                    alt=""
                                                                                    style={{ width: 24, height: 24, borderRadius: "50%", objectFit: "cover", flexShrink: 0 }}
                                                                                    onError={ev => { ev.currentTarget.style.display = "none"; }}
                                                                                />
                                                                            ) : (
                                                                                <div style={{ width: 24, height: 24, borderRadius: "50%", background: "#6366F1", color: "#fff", fontSize: 9, fontWeight: 700, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                                                                                    {`${(projectEmployees.find(e => String(e.id) === String(newTaskAssignee))?.firstName || "")[0] || ""}${(projectEmployees.find(e => String(e.id) === String(newTaskAssignee))?.lastName || "")[0] || ""}`.toUpperCase()}
                                                                                </div>
                                                                            )}
                                                                            <span style={{ fontSize: 13.5, color: "#172B4D", fontWeight: 500, flex: 1, textAlign: "left" }}>
                                                                                {projectEmployees.find(e => String(e.id) === String(newTaskAssignee))?.firstName} {projectEmployees.find(e => String(e.id) === String(newTaskAssignee))?.lastName}
                                                                            </span>
                                                                        </>
                                                                    ) : (
                                                                        <>
                                                                            <i className="bi bi-person-fill" style={{ color: "#8993A4", fontSize: 14 }} />
                                                                            <span style={{ fontSize: 13.5, color: "#8993A4", flex: 1, textAlign: "left" }}>
                                                                                {newTaskProject ? "Select assignee…" : "Pick project first"}
                                                                            </span>
                                                                        </>
                                                                    )}
                                                                    <i className="bi bi-chevron-down" style={{ color: "#8993A4", fontSize: 11 }} />
                                                                </button>

                                                                {/* Dropdown panel */}
                                                                <div
                                                                    id="ct-asgn-panel"
                                                                    style={{ display: "none", position: "absolute", top: "calc(100% + 4px)", left: 0, right: 0, background: "#fff", borderRadius: 10, border: "1.5px solid #DFE1E6", boxShadow: "0 8px 28px rgba(0,0,0,.13)", zIndex: 1300, overflow: "hidden" }}
                                                                >
                                                                    {/* Search */}
                                                                    <div style={{ padding: "8px 10px", borderBottom: "1px solid #F0F1F3", background: "#fff" }}>
                                                                        <div style={{ position: "relative" }}>
                                                                            <i className="bi bi-search" style={{ position: "absolute", left: 9, top: "50%", transform: "translateY(-50%)", fontSize: 12, color: "#8993A4" }} />
                                                                            <input
                                                                                id="ct-asgn-srch"
                                                                                type="text"
                                                                                placeholder="Search people…"
                                                                                onChange={e => {
                                                                                    const q = e.target.value.toLowerCase();
                                                                                    document.querySelectorAll(".ct-asgn-opt").forEach(el => {
                                                                                        el.style.display = (el.dataset.name || "").toLowerCase().includes(q) ? "flex" : "none";
                                                                                    });
                                                                                }}
                                                                                style={{ width: "100%", height: 32, borderRadius: 6, border: "1px solid #DFE1E6", paddingLeft: 28, fontSize: 12.5, outline: "none", color: "#172B4D" }}
                                                                            />
                                                                        </div>
                                                                    </div>

                                                                    {/* Options */}
                                                                    <div style={{ overflowY: "auto", maxHeight: 210 }}>
                                                                        {/* Unassigned */}
                                                                        <div
                                                                            className="ct-asgn-opt"
                                                                            data-name="unassigned"
                                                                            onClick={() => {
                                                                                setNewTaskAssignee("");
                                                                                const p = document.getElementById("ct-asgn-panel"); if (p) p.style.display = "none";
                                                                                const s = document.getElementById("ct-asgn-srch"); if (s) s.value = "";
                                                                                document.querySelectorAll(".ct-asgn-opt").forEach(el => { el.style.display = "flex"; });
                                                                            }}
                                                                            style={{ display: "flex", alignItems: "center", gap: 10, padding: "8px 12px", cursor: "pointer", background: !newTaskAssignee ? "#EFF6FF" : "transparent" }}
                                                                            onMouseEnter={e => { if (newTaskAssignee) e.currentTarget.style.background = "#F8FAFC"; }}
                                                                            onMouseLeave={e => { e.currentTarget.style.background = !newTaskAssignee ? "#EFF6FF" : "transparent"; }}
                                                                        >
                                                                            <div style={{ width: 32, height: 32, borderRadius: "50%", background: "#F1F5F9", border: "1.5px dashed #CBD5E1", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                                                                                <i className="bi bi-person" style={{ fontSize: 14, color: "#94A3B8" }} />
                                                                            </div>
                                                                            <div style={{ flex: 1 }}>
                                                                                <div style={{ fontSize: 13, fontWeight: 600, color: "#475569" }}>Unassigned</div>
                                                                                <div style={{ fontSize: 11, color: "#94A3B8" }}>No assignee</div>
                                                                            </div>
                                                                            {!newTaskAssignee && <i className="bi bi-check2" style={{ color: "#0052CC", fontSize: 15 }} />}
                                                                        </div>

                                                                        {/* Employees */}
                                                                        {projectEmployees
                                                                            .slice()
                                                                            .sort((a, b) => `${a.firstName} ${a.lastName}`.localeCompare(`${b.firstName} ${b.lastName}`))
                                                                            .map(emp => {
                                                                                const isSelected = String(emp.id) === String(newTaskAssignee);
                                                                                const initials = `${(emp.firstName || "")[0] || ""}${(emp.lastName || "")[0] || ""}`.toUpperCase();
                                                                                const bgColors = ["#6366F1", "#0052CC", "#7C3AED", "#0D9488", "#EA580C", "#DC2626", "#059669", "#D946EF"];
                                                                                const bg = bgColors[(emp.id || 0) % bgColors.length];
                                                                                return (
                                                                                    <div
                                                                                        key={emp.id}
                                                                                        className="ct-asgn-opt"
                                                                                        data-name={`${emp.firstName} ${emp.lastName}`}
                                                                                        onClick={() => {
                                                                                            setNewTaskAssignee(String(emp.id));
                                                                                            const p = document.getElementById("ct-asgn-panel"); if (p) p.style.display = "none";
                                                                                            const s = document.getElementById("ct-asgn-srch"); if (s) s.value = "";
                                                                                            document.querySelectorAll(".ct-asgn-opt").forEach(el => { el.style.display = "flex"; });
                                                                                        }}
                                                                                        style={{ display: "flex", alignItems: "center", gap: 10, padding: "8px 12px", cursor: "pointer", background: isSelected ? "#EFF6FF" : "transparent", transition: "background .1s" }}
                                                                                        onMouseEnter={e => { if (!isSelected) e.currentTarget.style.background = "#F8FAFC"; }}
                                                                                        onMouseLeave={e => { e.currentTarget.style.background = isSelected ? "#EFF6FF" : "transparent"; }}
                                                                                    >
                                                                                        <div style={{ position: "relative", width: 32, height: 32, flexShrink: 0 }}>
                                                                                            {emp.photoPath && (
                                                                                                <img
                                                                                                    src={`${API_BASE_URL}/uploads/${emp.photoPath}`}
                                                                                                    alt={emp.firstName}
                                                                                                    style={{ width: 32, height: 32, borderRadius: "50%", objectFit: "cover", display: "block", border: isSelected ? "2px solid #0052CC" : "2px solid #E2E8F0", position: "absolute", top: 0, left: 0 }}
                                                                                                    onError={ev => { ev.currentTarget.style.display = "none"; if (ev.currentTarget.nextSibling) ev.currentTarget.nextSibling.style.display = "flex"; }}
                                                                                                />
                                                                                            )}
                                                                                            <div style={{ width: 32, height: 32, borderRadius: "50%", background: bg, color: "#fff", fontSize: 11, fontWeight: 700, display: emp.photoPath ? "none" : "flex", alignItems: "center", justifyContent: "center", border: isSelected ? "2px solid #0052CC" : "2px solid transparent" }}>
                                                                                                {initials}
                                                                                            </div>
                                                                                        </div>
                                                                                        <div style={{ flex: 1, minWidth: 0 }}>
                                                                                            <div style={{ fontSize: 13, fontWeight: 600, color: "#172B4D", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                                                                                                {emp.firstName} {emp.lastName}
                                                                                            </div>
                                                                                        </div>
                                                                                        {isSelected && <i className="bi bi-check2" style={{ color: "#0052CC", fontSize: 15, flexShrink: 0 }} />}
                                                                                    </div>
                                                                                );
                                                                            })}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {/* END Assignee */}

                                                        {/* Reporter */}
                                                        <div>
                                                            <label style={ctLabelStyle}>Reporter</label>
                                                            {(() => {
                                                                const rep = projectEmployees.find(e => String(e.id) === String(newTaskReporter));
                                                                if (!rep) {
                                                                    return (
                                                                        <div style={{ height: 38, borderRadius: 8, border: "1.5px solid #DFE1E6", background: "#F8F9FB", display: "flex", alignItems: "center", gap: 9, padding: "0 10px" }}>
                                                                            <i className="bi bi-person-check-fill" style={{ color: "#CBD5E1", fontSize: 14 }} />
                                                                            <span style={{ fontSize: 13.5, color: "#94A3B8" }}>{newTaskProject ? "Auto-set from project" : "Pick project first"}</span>
                                                                        </div>
                                                                    );
                                                                }
                                                                const repInitials = `${(rep.firstName || "")[0] || ""}${(rep.lastName || "")[0] || ""}`.toUpperCase();
                                                                const repColors = ["#6366F1", "#0052CC", "#7C3AED", "#0D9488", "#EA580C", "#DC2626", "#059669", "#D946EF"];
                                                                const repBg = repColors[(rep.id || 0) % repColors.length];
                                                                return (
                                                                    <div style={{ height: 38, borderRadius: 8, border: "1.5px solid #DFE1E6", background: "#F8F9FB", display: "flex", alignItems: "center", gap: 9, padding: "0 10px" }}>
                                                                        <div style={{ position: "relative", width: 24, height: 24, flexShrink: 0 }}>
                                                                            {rep.photoPath && (
                                                                                <img
                                                                                    src={`${API_BASE_URL}/uploads/${rep.photoPath}`}
                                                                                    alt={rep.firstName}
                                                                                    style={{ width: 24, height: 24, borderRadius: "50%", objectFit: "cover", display: "block", position: "absolute", top: 0, left: 0 }}
                                                                                    onError={ev => { ev.currentTarget.style.display = "none"; if (ev.currentTarget.nextSibling) ev.currentTarget.nextSibling.style.display = "flex"; }}
                                                                                />
                                                                            )}
                                                                            <div style={{ width: 24, height: 24, borderRadius: "50%", background: repBg, color: "#fff", fontSize: 9, fontWeight: 700, display: rep.photoPath ? "none" : "flex", alignItems: "center", justifyContent: "center" }}>
                                                                                {repInitials}
                                                                            </div>
                                                                        </div>
                                                                        <span style={{ fontSize: 13.5, color: "#42526E", fontWeight: 500, flex: 1 }}>{rep.firstName} {rep.lastName}</span>
                                                                        <span style={{ fontSize: 10, fontWeight: 700, padding: "2px 7px", borderRadius: 99, background: "#DCFCE7", color: "#166534" }}>You</span>
                                                                    </div>
                                                                );
                                                            })()}
                                                        </div>
                                                        {/* END Reporter */}

                                                        {/* Parent */}
                                                        <div>
                                                            <label style={ctLabelStyle}>Parent</label>
                                                            <div style={{ position: "relative" }}>

                                                                <i className="bi bi-diagram-3-fill" style={ctIconStyle} />

                                                                <button
                                                                    id="ct-parent-trigger"
                                                                    type="button"
                                                                    disabled={newTaskType === "Parent"}
                                                                    onClick={() => {
                                                                        const el = document.getElementById("ct-parent-panel");
                                                                        if (el) el.style.display = el.style.display === "block" ? "none" : "block";
                                                                    }}
                                                                    style={{
                                                                        ...ctInputStyle,
                                                                        paddingLeft: 34,
                                                                        height: 38,
                                                                        display: "flex",
                                                                        justifyContent: "space-between",
                                                                        alignItems: "center"
                                                                    }}
                                                                >
                                                                    <span
                                                                        style={{
                                                                            flex: 1,
                                                                            textAlign: "left",
                                                                            whiteSpace: "nowrap",
                                                                            overflow: "hidden",
                                                                            textOverflow: "ellipsis",
                                                                        }}
                                                                        title={parentTasks.find(t => String(t.id) === String(newTaskParent))?.title}
                                                                    >
                                                                        {parentTasks.find(t => String(t.id) === String(newTaskParent))?.title || "No parent"}
                                                                    </span>
                                                                    {/* <i className="bi bi-chevron-down" /> */}
                                                                </button>

                                                                <div id="ct-parent-panel" style={dropdownStyle}>
                                                                    <div style={{ maxHeight: 220, overflowY: "auto" }}>
                                                                        {parentTasks.map(t => {
                                                                            const selected = String(t.id) === String(newTaskParent);
                                                                            return (
                                                                                <div
                                                                                    key={t.id}
                                                                                    onClick={() => {
                                                                                        setNewTaskParent(t.id);
                                                                                        document.getElementById("ct-parent-panel").style.display = "none";
                                                                                    }}
                                                                                    style={{
                                                                                        padding: "9px 12px",
                                                                                        cursor: "pointer",
                                                                                        display: "flex",
                                                                                        alignItems: "center",
                                                                                        gap: 8,
                                                                                        background: selected ? "#EFF6FF" : "#fff"
                                                                                    }}
                                                                                >
                                                                                    <div
                                                                                        style={{
                                                                                            flex: 1,
                                                                                            whiteSpace: "nowrap",
                                                                                            overflow: "hidden",
                                                                                            textOverflow: "ellipsis",
                                                                                        }}
                                                                                        title={t.title}
                                                                                    >
                                                                                        {t.title}
                                                                                    </div>
                                                                                    {selected && <i className="bi bi-check2 float-end" />}
                                                                                </div>
                                                                            );
                                                                        })}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {/* Priority */}
                                                        <div>
                                                            <label style={ctLabelStyle}>Priority</label>
                                                            <div style={{ display: "flex", gap: 6 }}>
                                                                {[
                                                                    { value: "LOW", icon: "bi-arrow-down-circle-fill", color: "#22C55E", label: "Low" },
                                                                    { value: "MEDIUM", icon: "bi-dash-circle-fill", color: "#F59E0B", label: "Med" },
                                                                    { value: "HIGH", icon: "bi-exclamation-circle-fill", color: "#EF4444", label: "High" },
                                                                ].map(p => (
                                                                    <button
                                                                        key={p.value}
                                                                        type="button"
                                                                        onClick={() => setNewTaskPriority(p.value)}
                                                                        style={{ flex: 1, padding: "7px 4px", borderRadius: 8, cursor: "pointer", transition: "all .13s", display: "flex", flexDirection: "column", alignItems: "center", gap: 3, fontSize: 11.5, fontWeight: 700, border: newTaskPriority === p.value ? `2px solid ${p.color}` : "2px solid #DFE1E6", background: newTaskPriority === p.value ? `${p.color}12` : "#fff", color: newTaskPriority === p.value ? p.color : "#8993A4" }}
                                                                    >
                                                                        <i className={`bi ${p.icon}`} style={{ fontSize: 15 }} />
                                                                        {p.label}
                                                                    </button>
                                                                ))}
                                                            </div>
                                                        </div>

                                                        {/* Due Date */}
                                                        <div>
                                                            <label style={ctLabelStyle}>Due Date</label>
                                                            <div style={{ position: "relative" }}>
                                                                <i className="bi bi-calendar-event-fill" style={{ ...ctIconStyle, color: "#0052CC" }} />
                                                                <input
                                                                    type="date"
                                                                    className="form-control"
                                                                    value={newTaskDueDate}
                                                                    min={new Date().toISOString().split("T")[0]}
                                                                    onChange={e => setNewTaskDueDate(e.target.value)}
                                                                    style={{ ...ctInputStyle, paddingLeft: 34 }}
                                                                />
                                                            </div>
                                                        </div>



                                                        {/* Estimated Hours */}
                                                        <div>
                                                            <label style={ctLabelStyle}>Estimated Hours</label>
                                                            <div style={{ position: "relative" }}>
                                                                <i className="bi bi-clock-fill" style={{ ...ctIconStyle, color: "#8B5CF6" }} />
                                                                <input
                                                                    type="number"
                                                                    className="form-control"
                                                                    placeholder="0"
                                                                    min="0"
                                                                    value={newTaskEstimatedTime}
                                                                    onChange={e => setNewTaskEstimatedTime(e.target.value)}
                                                                    style={{ ...ctInputStyle, paddingLeft: 34 }}
                                                                />
                                                            </div>
                                                        </div>

                                                        {/* Preview card */}
                                                        {(newTaskTitle || newTaskProject) && (
                                                            <div style={{ marginTop: "auto", padding: "12px 14px", borderRadius: 10, background: "linear-gradient(135deg,#EFF6FF,#F5F3FF)", border: "1px solid #BFDBFE" }}>
                                                                <p style={{ fontSize: 10, fontWeight: 700, color: "#6366F1", textTransform: "uppercase", letterSpacing: ".07em", margin: "0 0 6px" }}>Preview</p>
                                                                {newTaskTitle && (
                                                                    <p style={{ fontSize: 12.5, fontWeight: 600, color: "#172B4D", margin: "0 0 4px", lineHeight: 1.4 }}>
                                                                        {newTaskTitle.length > 50 ? newTaskTitle.slice(0, 50) + "…" : newTaskTitle}
                                                                    </p>
                                                                )}
                                                                <div style={{ display: "flex", flexWrap: "wrap", gap: 6, marginTop: 4 }}>
                                                                    {newTaskType && (
                                                                        <span style={{ fontSize: 10.5, fontWeight: 600, background: "#EDE9FE", color: "#6D28D9", padding: "2px 8px", borderRadius: 99 }}>
                                                                            {newTaskType}
                                                                        </span>
                                                                    )}
                                                                    {newTaskPriority && (
                                                                        <span style={{ fontSize: 10.5, fontWeight: 600, padding: "2px 8px", borderRadius: 99, background: newTaskPriority === "HIGH" ? "#FEE2E2" : newTaskPriority === "MEDIUM" ? "#FEF3C7" : "#DCFCE7", color: newTaskPriority === "HIGH" ? "#B91C1C" : newTaskPriority === "MEDIUM" ? "#92400E" : "#166534" }}>
                                                                            {newTaskPriority}
                                                                        </span>
                                                                    )}
                                                                    {newTaskDueDate && (
                                                                        <span style={{ fontSize: 10.5, fontWeight: 500, color: "#64748B" }}>
                                                                            {"📅 " + new Date(newTaskDueDate).toLocaleDateString("en-GB")}
                                                                        </span>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        )}

                                                    </div>
                                                    {/* END RIGHT column */}

                                                </div>
                                                {/* END Body grid */}

                                                {/* ── Footer ── */}
                                                <div style={{ padding: "14px 28px", borderTop: "1px solid #F0F1F3", background: "#FAFBFC", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                                    <span style={{ fontSize: 12, color: "#8993A4" }}>
                                                        <i className="bi bi-info-circle me-1" />
                                                        Fields marked <span style={{ color: "#EF4444" }}>*</span> are required
                                                    </span>
                                                    <div style={{ display: "flex", gap: 10 }}>
                                                        <button
                                                            type="button"
                                                            onClick={createTask}
                                                            disabled={isCreating || !newTaskTitle?.trim()}
                                                            style={{ padding: "8px 28px", borderRadius: 8, border: "none", background: (isCreating || !newTaskTitle?.trim()) ? "#A5B4FC" : "linear-gradient(135deg,#0052CC,#2684FF)", color: "#fff", fontSize: 13.5, fontWeight: 700, cursor: (isCreating || !newTaskTitle?.trim()) ? "not-allowed" : "pointer", display: "flex", alignItems: "center", gap: 8, boxShadow: (isCreating || !newTaskTitle?.trim()) ? "none" : "0 4px 14px rgba(0,82,204,.35)" }}
                                                        >
                                                            {isCreating ? (
                                                                <>
                                                                    <span className="spinner-border spinner-border-sm" style={{ width: 14, height: 14, borderWidth: 2 }} />
                                                                    Creating…
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <i className="bi bi-check2-circle" />
                                                                    Create {newTaskType || "Task"}
                                                                </>
                                                            )}
                                                        </button>
                                                        <button
                                                            type="button"
                                                            disabled={isCreating}
                                                            onClick={() => { resetCreateTaskForm(); setShowCreateTask(false); }}
                                                            style={{ padding: "8px 20px", borderRadius: 8, border: "1.5px solid #DFE1E6", background: "#fff", color: "#5E6C84", fontSize: 13.5, fontWeight: 600, cursor: "pointer" }}
                                                        >
                                                            Cancel
                                                        </button>

                                                    </div>
                                                </div>

                                            </form>
                                        </div>
                                    </div>
                                </div>

                                <style>{`
      @keyframes ctModalIn {
        from { opacity:0; transform:translateY(-16px) scale(.97); }
        to   { opacity:1; transform:translateY(0) scale(1); }
      }
      @keyframes ctDropIn {
        from { opacity:0; transform:translateY(-6px); }
        to   { opacity:1; transform:translateY(0); }
      }
      #ct-asgn-panel[style*="block"] { animation: ctDropIn .14s ease both; }
    `}</style>

                            </>
                        ), document.body)}







                        {/* ══ TASK BODY (breadcrumb + columns) ══ */}
                        <div className="tp-task-body">

                            {activeTask ? (
                                <>
                                    {/* breadcrumb */}
                                    <div className="tp-breadcrumb">
                                        {/* <span className="tp-breadcrumb__current" style={{ cursor: "pointer" }} onClick={() => setActiveTask(null)}>← Back</span> */}
                                        <span className="tp-breadcrumb__sep"><i className="bi bi-chevron-right" style={{ fontSize: 9 }}></i></span>
                                        <span className="tp-breadcrumb__current">{activeTask?.project?.name || "Project"}</span>
                                        <span className="tp-breadcrumb__sep"><i className="bi bi-chevron-right" style={{ fontSize: 9 }}></i></span>
                                        <span className="tp-breadcrumb__current">{activeTask?.taskCode}</span>
                                    </div>

                                    {/* ── two-column row ── */}
                                    <div className="tp-task-columns">
                                        {/* LEFT: Main Task Content */}
                                        <div className="tp-task-main">


                                            <div className="tp-section-card tp-task-header" style={{ paddingBottom: "15px" }}>
                                                <div style={{ width: "100%" }}>
                                                    {/* Task key + project row */}
                                                    <div className="tp-task-key-row">
                                                        <span className="tp-task-key">{activeTask?.taskCode}</span>
                                                        {/* <span className="tp-task-sep">·</span>
                                                        <span className="tp-task-project">{activeTask?.project?.name}</span> */}
                                                    </div>
                                                    {/* ✅ Title Section */}
                                                    <div className="task-title-section task-section mb-3">
                                                        {editField === "title" ? (
                                                            <div>
                                                                <textarea
                                                                    type="text"
                                                                    className="form-control mb-2"
                                                                    value={editedTask.title || ""}
                                                                    onChange={(e) =>
                                                                        setEditedTask({ ...editedTask, title: e.target.value })
                                                                    }
                                                                    autoFocus
                                                                    rows={2}
                                                                    style={{
                                                                        fontSize: "1.0rem", fontWeight: "500", width: "100%", minHeight: "42px",
                                                                        lineHeight: "1.5",
                                                                        color: "#111827",
                                                                        letterSpacing: "-0.01em",
                                                                        resize: "none", overflow: "hidden",
                                                                    }}
                                                                    onInput={(e) => {
                                                                        e.target.style.height = "auto";
                                                                        e.target.style.height = e.target.scrollHeight + "px";
                                                                    }}

                                                                    onBlur={() => {
                                                                        if (activeTask && editedTask.title?.trim()) {
                                                                            updateTaskField(activeTask.id, "title", editedTask.title);
                                                                        }
                                                                        setEditField(null);
                                                                    }}
                                                                />

                                                                <div className="d-flex gap-2">
                                                                    <button
                                                                        className="btn btn-sm btn-primary"
                                                                        onClick={() => {
                                                                            if (activeTask && editedTask.title?.trim()) {
                                                                                updateTaskField(activeTask.id, "title", editedTask.title);
                                                                            }
                                                                            setEditField(null);
                                                                        }}
                                                                    >
                                                                        Save
                                                                    </button>

                                                                    <button
                                                                        className="btn btn-sm btn-outline-secondary"
                                                                        onClick={() => {
                                                                            setEditedTask(activeTask);
                                                                            setEditField(null);
                                                                        }}
                                                                    >
                                                                        Cancel
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        ) : (
                                                            <h5
                                                                className="mb-0 task-title-text"
                                                                style={{
                                                                    fontSize: "1.0rem",
                                                                    fontWeight: "500",
                                                                    lineHeight: "1.5",
                                                                    color: "#111827",
                                                                    letterSpacing: "-0.01em",
                                                                }}
                                                                onClick={() => {
                                                                    if (activeTask) {
                                                                        setEditedTask({ ...activeTask });
                                                                        setEditField("title");
                                                                    }
                                                                }}
                                                                title="Click to edit title"
                                                            >
                                                                {activeTask?.title ? (
                                                                    activeTask.title
                                                                ) : (
                                                                    <span className="text-muted fst-italic">
                                                                        Click to add title...
                                                                    </span>
                                                                )}
                                                            </h5>
                                                        )}
                                                    </div>

                                                </div>


                                            </div>

                                            <div className="tp-section-card mb-3">
                                                <div className="tp-section-card__head">
                                                    <span className="tp-section-card__title">Description</span>
                                                    {editField !== "description" && (
                                                        <button className="tp-section-card__action" onClick={handleDescriptionClick}>
                                                            {/* <i className="bi bi-pencil"></i> Edit */}
                                                        </button>
                                                    )}
                                                </div>

                                                {editField === "description" ? (
                                                    <NewCommentEditor
                                                        initialHtml={activeTask?.description || ""}
                                                        mentionableUsers={mentionableUsers}
                                                        placeholder="Add a description…"
                                                        submitLabel="Save"
                                                        showCancelBtn={true}
                                                        autoFocus={true}
                                                        onSubmit={async ({ html }) => {
                                                            await updateTaskField(activeTask.id, "description", html);
                                                            setEditField(null);
                                                        }}
                                                        onCancel={() => {
                                                            setEditedTask({ ...activeTask });
                                                            setEditField(null);
                                                        }}
                                                    />
                                                ) : (
                                                    <div
                                                        className="tp-desc-text"
                                                        onClick={handleDescriptionClick}
                                                        dangerouslySetInnerHTML={{
                                                            __html: activeTask?.description || '<span class="text-muted fst-italic">Click to add description...</span>'
                                                        }}
                                                    />
                                                )}

                                            </div>


                                            <div className="tp-section-card mb-3">
                                                <div className="tp-section-card__head">
                                                    <span className="tp-section-card__title">External Task URL</span>
                                                </div>

                                                {editField === "externalUrl" ? (
                                                    <div className="mt-2">
                                                        <input
                                                            type="url"
                                                            className="form-control"
                                                            placeholder="https://balsuite.com"
                                                            value={editedTask?.externalUrl || ""}
                                                            onChange={(e) =>
                                                                setEditedTask({ ...editedTask, externalUrl: e.target.value })
                                                            }
                                                            autoFocus
                                                        />

                                                        <div className="mt-2 d-flex gap-2">
                                                            <button
                                                                type="button"
                                                                className="btn btn-sm btn-primary"
                                                                onClick={async () => {
                                                                    try {
                                                                        await updateTaskField(
                                                                            activeTask.id,
                                                                            "externalUrl",
                                                                            editedTask.externalUrl
                                                                        );
                                                                    } catch (err) {
                                                                        console.error("Save failed", err);
                                                                    } finally {
                                                                        setEditField(null);
                                                                    }
                                                                }}
                                                            >
                                                                Save
                                                            </button>

                                                            <button
                                                                type="button"
                                                                className="btn btn-sm btn-outline-secondary"
                                                                onClick={() => {
                                                                    setEditedTask({ ...activeTask });
                                                                    setEditField(null);
                                                                }}
                                                            >
                                                                Cancel
                                                            </button>
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <div
                                                        className="task-section__body"
                                                        onClick={() => {
                                                            setEditedTask({ ...activeTask });
                                                            setEditField("externalUrl");
                                                        }}
                                                        style={{ cursor: "pointer" }}
                                                    >
                                                        {activeTask?.externalUrl ? (
                                                            <a
                                                                href={activeTask.externalUrl}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                onClick={(e) => e.stopPropagation()}
                                                                className="text-primary text-decoration-underline"
                                                            >
                                                                {activeTask.externalUrl}
                                                            </a>
                                                        ) : (
                                                            <span className="text-muted fst-italic">
                                                                Click to add external task link…
                                                            </span>
                                                        )}
                                                    </div>
                                                )}
                                            </div>


                                            {/* Worklogs Section */}
                                            <div className="tp-section-card tp-section--worklogs">
                                                <div className="tp-section-card__body">





                                                    <div className="row">
                                                        {/* LEFT: Log Form + Worklogs */}
                                                        <div className="col-md-12">
                                                            {showLogForm && createPortal((
                                                                <>
                                                                    {/* Dimmed overlay that closes modal on click */}
                                                                    <div
                                                                        className="modal-backdrop fade show"
                                                                        onClick={() => {
                                                                            resetLogForm();
                                                                            setShowLogForm(false);
                                                                        }}

                                                                        style={{ cursor: "pointer" }}
                                                                    ></div>

                                                                    {/* Modal */}
                                                                    <div
                                                                        className="modal show fade d-block"
                                                                        tabIndex="-1"
                                                                        role="dialog"
                                                                        onClick={(e) => e.stopPropagation()} // prevent clicks inside modal from closing it
                                                                    >
                                                                        <div className="modal-dialog modal-md modal-dialog-centered" role="document">
                                                                            <div className="modal-content">
                                                                                <form
                                                                                    onSubmit={(e) => {
                                                                                        e.preventDefault();
                                                                                        saveWorklog();
                                                                                    }}
                                                                                >
                                                                                    {/* Header */}
                                                                                    <div className="modal-header border-bottom bg-light">
                                                                                        <h5 className="modal-title fw-semibold">
                                                                                            <i className="bi bi-clock me-2 text-primary"></i> Log Time
                                                                                        </h5>
                                                                                        <button
                                                                                            type="button"
                                                                                            className="btn-close"
                                                                                            onClick={() => {
                                                                                                resetLogForm();
                                                                                                setShowLogForm(false);
                                                                                            }}
                                                                                        ></button>

                                                                                    </div>

                                                                                    {/* Body */}
                                                                                    <div className="modal-body">

                                                                                        {/* ✅ Task at top */}
                                                                                        <div className="mb-3 ">
                                                                                            <label className="form-label fw-semibold small text-muted " style={{ width: "450px", textAlign: "left" }}>Task</label>
                                                                                            <div className="input-group">
                                                                                                <span className="input-group-text bg-white">
                                                                                                    <i className="bi bi-clipboard"></i>
                                                                                                </span>
                                                                                                <input
                                                                                                    type="text"
                                                                                                    className="form-control"
                                                                                                    value={activeTask?.title || ""}
                                                                                                    readOnly
                                                                                                />
                                                                                            </div>
                                                                                        </div>

                                                                                        {/* Date + Duration */}
                                                                                        <div className="row g-3 mb-3">
                                                                                            <div className="col-6">
                                                                                                <label className="form-label fw-semibold small text-muted">Date</label>
                                                                                                <input
                                                                                                    type="date"
                                                                                                    className="form-control"
                                                                                                    value={logDate}
                                                                                                    onChange={(e) => {
                                                                                                        setLogDate(e.target.value);
                                                                                                        setSelectedDate(new Date(e.target.value));
                                                                                                    }}
                                                                                                    required
                                                                                                />
                                                                                            </div>
                                                                                            <div className="col-6">
                                                                                                <label className="form-label fw-semibold small text-muted">Duration</label>

                                                                                                <div className="input-group">
                                                                                                    <input
                                                                                                        type="text"
                                                                                                        className="form-control"
                                                                                                        placeholder=""
                                                                                                        value={logHoursRaw}
                                                                                                        onChange={(e) => handleDurationChange(e.target.value)}
                                                                                                        onBlur={handleDurationBlur}
                                                                                                        onFocus={handleDurationFocus}
                                                                                                        required
                                                                                                    />
                                                                                                    {/* <span className="input-group-text">h</span> */}
                                                                                                </div>
                                                                                                <small className="text-muted">
                                                                                                    Maximum allowed: 24 hours per day
                                                                                                </small>


                                                                                            </div>


                                                                                        </div>

                                                                                        {/* Billing Type */}
                                                                                        <div className="mb-3">
                                                                                            {/* <label className="form-label fw-semibold small text-muted" style={{ width: "450px", textAlign: "left" }}>Billing Type</label> */}
                                                                                            <div className="d-flex gap-4 mt-1">
                                                                                                <div className="form-check">
                                                                                                    <input
                                                                                                        className="form-check-input"
                                                                                                        type="radio"
                                                                                                        name="billingType"
                                                                                                        id="billable"
                                                                                                        value="billable"
                                                                                                        checked={billingType === "billable"}
                                                                                                        onChange={(e) => setBillingType(e.target.value)}
                                                                                                    />
                                                                                                    <label className="form-check-label" htmlFor="billable">
                                                                                                        Billable
                                                                                                    </label>
                                                                                                </div>
                                                                                                <div className="form-check">
                                                                                                    <input
                                                                                                        className="form-check-input"
                                                                                                        type="radio"
                                                                                                        name="billingType"
                                                                                                        id="nonBillable"
                                                                                                        value="non-billable"
                                                                                                        checked={billingType === "non-billable"}
                                                                                                        onChange={(e) => setBillingType(e.target.value)}
                                                                                                    />
                                                                                                    <label className="form-check-label" htmlFor="nonBillable">
                                                                                                        Non-Billable
                                                                                                    </label>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>

                                                                                        {/* Description */}
                                                                                        <div className="mb-3">
                                                                                            <label className="form-label fw-semibold small text-muted" style={{ width: "450px", textAlign: "left" }}>Description</label>
                                                                                            <textarea
                                                                                                className="form-control"
                                                                                                rows="3"
                                                                                                placeholder="What did you work on?"
                                                                                                value={logDescription}
                                                                                                onChange={(e) => setLogDescription(e.target.value)}
                                                                                                required
                                                                                            ></textarea>
                                                                                        </div>
                                                                                    </div>

                                                                                    {/* Footer */}
                                                                                    <div className="modal-footer border-top">
                                                                                        {/* <div className="form-check me-auto">
                                                                                                    <input
                                                                                                    className="form-check-input"
                                                                                                    type="checkbox"
                                                                                                    id="logAnother"
                                                                                                    checked={logAnother}
                                                                                                    onChange={(e) => setLogAnother(e.target.checked)}
                                                                                                    />
                                                                                                    <label className="form-check-label small" htmlFor="logAnother">
                                                                                                    Log another
                                                                                                    </label>
                                                                                                </div> */}
                                                                                        <button type="submit" className="btn btn-primary">
                                                                                            Save
                                                                                        </button>
                                                                                        <button
                                                                                            type="button"
                                                                                            className="btn btn-light btn-sm"
                                                                                            onClick={() => {
                                                                                                resetLogForm();
                                                                                                setShowLogForm(false);
                                                                                            }}
                                                                                        >
                                                                                            Cancel
                                                                                        </button>

                                                                                    </div>
                                                                                </form>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </>
                                                            ), document.body)}


                                                            {/* Attachment Gallery – show ONLY if attachments exist */}
                                                            {taskAttachments.length > 0 && (
                                                                <div className="card shadow-none border-0 mt-3">
                                                                    <div className="card-body">
                                                                        <h6 className="fw-semibold mb-3 text-start">
                                                                            Attachments ({taskAttachments.length})
                                                                        </h6>

                                                                        <div className="d-flex flex-wrap gap-3">
                                                                            {(showAllAttachments ? taskAttachments : taskAttachments.slice(0, 4)).map((file, index) => {
                                                                                const isImage = file.name?.match(/\.(jpeg|jpg|png|gif|bmp|webp)$/i);
                                                                                const fileUrl = getDataUrl(file);

                                                                                return (
                                                                                    <div
                                                                                        key={index}
                                                                                        className="position-relative border rounded shadow-sm bg-white"
                                                                                        style={{
                                                                                            width: "130px",
                                                                                            height: "130px",
                                                                                            overflow: "hidden",
                                                                                            cursor: "pointer",
                                                                                            transition: "transform 0.2s ease",
                                                                                        }}
                                                                                        onClick={() => {
                                                                                            if (isImage) {
                                                                                                const images = taskAttachments
                                                                                                    .filter((f) => f.name?.match(/\.(jpeg|jpg|png|gif|bmp|webp)$/i))
                                                                                                    .map((f) => getDataUrl(f));

                                                                                                setPreviewImages(images);
                                                                                                setCurrentImageIndex(images.indexOf(fileUrl));
                                                                                            } else {
                                                                                                downloadFileAsBlob(file);
                                                                                            }
                                                                                        }}
                                                                                    >
                                                                                        {isImage ? (
                                                                                            <img
                                                                                                src={fileUrl}
                                                                                                alt={file.name}
                                                                                                className="w-100 h-100"
                                                                                                style={{ objectFit: "cover" }}
                                                                                            />
                                                                                        ) : (
                                                                                            <div className="d-flex align-items-center justify-content-center h-100 text-secondary bg-light">
                                                                                                <i className="bi bi-file-earmark-text fs-1"></i>
                                                                                            </div>
                                                                                        )}

                                                                                        <div
                                                                                            className="position-absolute bottom-0 w-100 bg-dark bg-opacity-50 text-white text-truncate small px-1 py-1"
                                                                                            title={file.name}
                                                                                        >
                                                                                            {file.name}
                                                                                        </div>
                                                                                    </div>
                                                                                );
                                                                            })}
                                                                        </div>

                                                                        {taskAttachments.length > 4 && (
                                                                            <div className="mt-3">
                                                                                <button
                                                                                    className="btn btn-sm "
                                                                                    onClick={() => setShowAllAttachments(!showAllAttachments)}
                                                                                >
                                                                                    {showAllAttachments ? "Show Less" : "Show More"}
                                                                                </button>
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            )}

                                                            <div className="d-flex align-items-center mb-3" style={{ gap: "10px" }}>
                                                                <h5 className="fw-bold mb-0"> Worklogs</h5>
                                                                <button
                                                                    className="btn btn-sm btn-primary mb-0"
                                                                    onClick={() => setShowLogForm(!showLogForm)}
                                                                >
                                                                    Log Time
                                                                </button>
                                                            </div>


                                                            {/* 🔍 Image Preview Modal */}
                                                            {previewImages.length > 0 && (
                                                                <div
                                                                    className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
                                                                    style={{ background: "rgba(0,0,0,0.8)", zIndex: 1050 }}
                                                                    onClick={() => setPreviewImages([])}
                                                                >
                                                                    <div className="position-relative" onClick={(e) => e.stopPropagation()}>
                                                                        <img
                                                                            src={previewImages[currentImageIndex]}
                                                                            alt="Preview"
                                                                            style={{ maxHeight: "80vh", maxWidth: "80vw", borderRadius: "8px" }}
                                                                        />

                                                                        {/* Previous */}
                                                                        {currentImageIndex > 0 && (
                                                                            <button
                                                                                className="btn btn-dark position-absolute top-50 start-0 translate-middle-y"
                                                                                style={{ opacity: 0.7 }}
                                                                                onClick={() => setCurrentImageIndex(currentImageIndex - 1)}
                                                                            >
                                                                                ‹
                                                                            </button>
                                                                        )}

                                                                        {/* Next */}
                                                                        {currentImageIndex < previewImages.length - 1 && (
                                                                            <button
                                                                                className="btn btn-dark position-absolute top-50 end-0 translate-middle-y"
                                                                                style={{ opacity: 0.7 }}
                                                                                onClick={() => setCurrentImageIndex(currentImageIndex + 1)}
                                                                            >
                                                                                ›
                                                                            </button>
                                                                        )}

                                                                        {/* Close */}
                                                                        <button
                                                                            className="btn btn-danger position-absolute top-0 end-0 m-3"
                                                                            onClick={() => setPreviewImages([])}
                                                                        >
                                                                            ✕
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            )}



                                                            {/* Worklog list (no filters, no pagination) */}
                                                            {/* For user Worklog list */}
                                                            {effectiveRole === "ROLE_USER" && (
                                                                <>
                                                                    {filteredLogs.length > 0 ? (
                                                                        <div
                                                                            className="worklog-list-scroll"
                                                                            style={{
                                                                                maxHeight: "320px",
                                                                                overflowY: "auto",
                                                                                border: "1px solid #e5e7eb",
                                                                                borderRadius: "10px",
                                                                                background: "#fff",
                                                                            }}
                                                                        >
                                                                            <ul className="list-unstyled m-0 p-2">
                                                                                {filteredLogs.map((log) => (
                                                                                    <li
                                                                                        key={log.id}
                                                                                        className="worklog-item mb-2"
                                                                                        style={{
                                                                                            padding: "12px 14px",
                                                                                            borderRadius: "8px",
                                                                                            border: "1px solid #f1f5f9",
                                                                                            background: "#fafafa",
                                                                                            transition: "background 0.15s ease, box-shadow 0.15s ease",
                                                                                        }}
                                                                                    >
                                                                                        <div className="d-flex justify-content-between align-items-start gap-3">
                                                                                            {/* Left content */}
                                                                                            <div className="flex-grow-1">
                                                                                                <div
                                                                                                    className="fw-medium text-dark"
                                                                                                    style={{ fontSize: "14px" }}
                                                                                                >
                                                                                                    {log.description || "No description provided"}
                                                                                                </div>

                                                                                                <div
                                                                                                    className="text-muted mt-1"
                                                                                                    style={{ fontSize: "12px" }}
                                                                                                >
                                                                                                    {new Date(log.date).toLocaleDateString("en-GB")} ·{" "}
                                                                                                    <span
                                                                                                        className={
                                                                                                            log.billingType === "billable"
                                                                                                                ? "text-success"
                                                                                                                : "text-danger"
                                                                                                        }
                                                                                                    >
                                                                                                        {log.billingType === "billable"
                                                                                                            ? "Billable"
                                                                                                            : "Non-Billable"}
                                                                                                    </span>
                                                                                                </div>
                                                                                            </div>

                                                                                            {/* Right actions */}
                                                                                            <div className="d-flex align-items-center gap-2">
                                                                                                <span
                                                                                                    className="badge bg-light text-dark fw-semibold"
                                                                                                    style={{ fontSize: "12px" }}
                                                                                                >
                                                                                                    {formatH(log.hours)}
                                                                                                </span>

                                                                                                {/* Edit */}
                                                                                                <button
                                                                                                    className="btn btn-sm btn-light border"
                                                                                                    title="Edit worklog"
                                                                                                    onClick={() => editWorklog(log)}
                                                                                                >
                                                                                                    <i className="bi bi-pencil"></i>
                                                                                                </button>

                                                                                                {/* Delete */}
                                                                                                <button
                                                                                                    className="btn btn-sm btn-light border text-dark"
                                                                                                    title="Delete worklog"
                                                                                                    onClick={() => deleteWorklog(log.id)}
                                                                                                >
                                                                                                    <i className="bi bi-trash"></i>
                                                                                                </button>
                                                                                            </div>
                                                                                        </div>
                                                                                    </li>
                                                                                ))}
                                                                            </ul>
                                                                        </div>
                                                                    ) : (
                                                                        <div
                                                                            className="text-center text-muted mt-4"
                                                                            style={{ fontSize: "14px" }}
                                                                        >
                                                                            <i className="bi bi-clock-history fs-4 d-block mb-2"></i>
                                                                            No worklogs available
                                                                        </div>
                                                                    )}
                                                                </>
                                                            )}



                                                            {/* For Admin Worklog list */}
                                                            {effectiveRole === "ROLE_ADMIN" && (
                                                                <>
                                                                    {filteredTaskLogs.length > 0 ? (
                                                                        <div className="worklog-card">
                                                                            <div className="worklog-table-wrapper">
                                                                                {/* Header */}
                                                                                <div className="worklog-header">
                                                                                    <span>Date</span>
                                                                                    <span>Employee</span>
                                                                                    <span>Description</span>
                                                                                    <span className="text-center">Billing</span>
                                                                                    <span className="text-center">Logged Hours</span>
                                                                                    <span className="text-end">Actions</span>
                                                                                </div>

                                                                                {/* Rows */}
                                                                                {filteredTaskLogs.map((log) => (
                                                                                    <div key={log.id} className="worklog-row">
                                                                                        <span className="date-text">
                                                                                            {new Date(log.date).toLocaleDateString("en-GB", {
                                                                                                day: "2-digit",
                                                                                                month: "short",
                                                                                                year: "numeric",
                                                                                            })}
                                                                                        </span>

                                                                                        <span className="employee-cell">
                                                                                            <img
                                                                                                src={
                                                                                                    log.employeePhotoPath
                                                                                                        ? `${API_BASE_URL}/uploads/${log.employeePhotoPath}`
                                                                                                        : "/default-avatar.png"
                                                                                                }
                                                                                                alt={log.employeeName}
                                                                                                className="employee-avatar"
                                                                                                onError={(e) => {
                                                                                                    e.currentTarget.onerror = null;
                                                                                                    e.currentTarget.src = "/default-avatar.png";
                                                                                                }}
                                                                                            />
                                                                                            <span className="employee-text">{log.employeeName}</span>
                                                                                        </span>



                                                                                        <span
                                                                                            className="worklog-desc"
                                                                                            title={log.description || ""}
                                                                                        >
                                                                                            {log.description || "—"}
                                                                                        </span>

                                                                                        <span
                                                                                            className={`billing-pill ${log.billingType === "billable" ? "billable" : "non-billable"
                                                                                                }`}
                                                                                        >
                                                                                            {log.billingType === "billable" ? "Billable" : "Non-Billable"}
                                                                                        </span>



                                                                                        <span className="hours-pill">{formatH(log.hours)}</span>

                                                                                        {/* Actions */}
                                                                                        <span className="worklog-actions">
                                                                                            {/* Edit */}
                                                                                            <span
                                                                                                className="action-icon edit"
                                                                                                title="Edit"
                                                                                                onClick={() => editWorklog(log)}
                                                                                            >
                                                                                                <i className="bi bi-pencil"></i>
                                                                                            </span>

                                                                                            {/* Delete */}
                                                                                            <span
                                                                                                className="action-icon delete"
                                                                                                title="Delete"
                                                                                                onClick={() => deleteWorklog(log.id)}
                                                                                            >
                                                                                                <i className="bi bi-trash"></i>
                                                                                            </span>
                                                                                        </span>

                                                                                    </div>
                                                                                ))}
                                                                            </div>
                                                                        </div>
                                                                    ) : (
                                                                        <p className="text-muted mt-3">No worklogs available.</p>
                                                                    )}
                                                                </>
                                                            )}


                                                            {/* For Manager Worklog list */}
                                                            {effectiveRole === "ROLE_MANAGER" && (
                                                                <>
                                                                    {filteredTasksLogs.length > 0 ? (
                                                                        <div className="worklog-card">
                                                                            <div className="worklog-table-wrapper">
                                                                                {/* Header */}
                                                                                <div className="worklog-header">
                                                                                    <span>Date</span>
                                                                                    <span>Employee</span>
                                                                                    <span>Description</span>
                                                                                    <span className="text-center">Billing</span>
                                                                                    <span className="text-center">Logged Hours</span>
                                                                                    <span className="text-end">Actions</span>
                                                                                </div>

                                                                                {/* Rows */}
                                                                                {filteredTasksLogs.map((log) => {

                                                                                    const isOwnWorklog =
                                                                                        Number(log?.employeeId) === loggedEmployeeId ||
                                                                                        Number(log?.employee?.id) === loggedEmployeeId;

                                                                                    return (
                                                                                        <div key={log.id} className="worklog-row">
                                                                                            <span className="date-text">
                                                                                                {new Date(log.date).toLocaleDateString("en-GB", {
                                                                                                    day: "2-digit",
                                                                                                    month: "short",
                                                                                                    year: "numeric",
                                                                                                })}
                                                                                            </span>

                                                                                            <span className="employee-cell">
                                                                                                <img
                                                                                                    src={
                                                                                                        log.employeePhotoPath
                                                                                                            ? `${API_BASE_URL}/uploads/${log.employeePhotoPath}`
                                                                                                            : "/default-avatar.png"
                                                                                                    }
                                                                                                    alt={log.employeeName}
                                                                                                    className="employee-avatar"
                                                                                                    onError={(e) => {
                                                                                                        e.currentTarget.onerror = null;
                                                                                                        e.currentTarget.src = "/default-avatar.png";
                                                                                                    }}
                                                                                                />
                                                                                                <span className="employee-text">{log.employeeName}</span>
                                                                                            </span>



                                                                                            <span
                                                                                                className="worklog-desc"
                                                                                                title={log.description || ""}
                                                                                            >
                                                                                                {log.description || "—"}
                                                                                            </span>

                                                                                            <span
                                                                                                className={`billing-pill ${log.billingType === "billable" ? "billable" : "non-billable"
                                                                                                    }`}
                                                                                            >
                                                                                                {log.billingType === "billable" ? "Billable" : "Non-Billable"}
                                                                                            </span>



                                                                                            <span className="hours-pill">{formatH(log.hours)}</span>

                                                                                            {/* Actions */}
                                                                                            <span className="worklog-actions">
                                                                                                {isOwnWorklog && (
                                                                                                    <>
                                                                                                        {/* Edit */}
                                                                                                        <span
                                                                                                            className="action-icon edit"
                                                                                                            title="Edit"
                                                                                                            onClick={() => editWorklog(log)}
                                                                                                        >
                                                                                                            <i className="bi bi-pencil"></i>
                                                                                                        </span>

                                                                                                        {/* Delete */}
                                                                                                        <span
                                                                                                            className="action-icon delete"
                                                                                                            title="Delete"
                                                                                                            onClick={() => deleteWorklog(log.id)}
                                                                                                        >
                                                                                                            <i className="bi bi-trash"></i>
                                                                                                        </span>
                                                                                                    </>
                                                                                                )}
                                                                                            </span>


                                                                                        </div>
                                                                                    )
                                                                                })}
                                                                            </div>
                                                                        </div>
                                                                    ) : (
                                                                        <p className="text-muted mt-3">No worklogs available.</p>
                                                                    )}
                                                                </>
                                                            )}


                                                        </div>
                                                    </div>
                                                </div>
                                            </div>



                                            {/* New Comment — improved UI */}
                                            <div className="task-section task-section--comments">
                                                <h6 style={{ fontSize: 13, fontWeight: 700, color: "#64748b", textTransform: "uppercase", letterSpacing: ".07em", marginBottom: 10 }}>
                                                    New Comment
                                                </h6>
                                                <NewCommentEditor
                                                    mentionableUsers={mentionableUsers}
                                                    placeholder="Add a comment… type @ to mention someone"
                                                    autoFocus={false}
                                                    submitLabel="Save"
                                                    onSubmit={async ({ html, text, attachments: editorAttachments }) => {
                                                        if (isCommentSubmitting) return;
                                                        if (!text || !activeTask) return;

                                                        setIsCommentSubmitting(true);

                                                        const payload = {
                                                            text,
                                                            html,
                                                            mentions: mentions.map((m) => m.id),
                                                            attachments: editorAttachments,
                                                        };

                                                        try {
                                                            const res = await fetch(
                                                                `${API_BASE_URL}/api/tasks/${activeTask.id}/comments`,
                                                                {
                                                                    method: "POST",
                                                                    headers: {
                                                                        Authorization: "Bearer " + token,
                                                                        "Content-Type": "application/json",
                                                                    },
                                                                    body: JSON.stringify(payload),
                                                                }
                                                            );

                                                            if (!res.ok) return;

                                                            const newComment = await res.json();
                                                            setComments((prev) => [newComment, ...(prev || [])]);

                                                            const draftKey = `comment_draft_task_${activeTask.id}`;
                                                            localStorage.removeItem(draftKey);
                                                        } catch (err) {
                                                            console.error("Error saving comment:", err);
                                                        } finally {
                                                            setIsCommentSubmitting(false);
                                                        }
                                                    }}
                                                    onCancel={() => {
                                                        setAttachments([]);
                                                        setMentions([]);
                                                    }}
                                                />
                                            </div>


                                            {/* 💬 Comments Section (upgraded) */}
                                            {/* <div className="mt-4 col-md-12 "></div> */}
                                            <div className="mt-4 col-task-details-scroll-12 ">
                                                <div
                                                    className="d-flex align-items-center mb-3"
                                                    style={{
                                                        borderBottom: "1px solid #e5e7eb",
                                                        gap: 20,
                                                    }}
                                                >
                                                    <button
                                                        type="button"
                                                        onClick={() => setActiveCommentTab("comments")}
                                                        style={{
                                                            background: "none",
                                                            border: "none",
                                                            padding: "6px 0",
                                                            fontSize: 14,
                                                            fontWeight: activeCommentTab === "comments" ? 600 : 400,
                                                            color: activeCommentTab === "comments" ? "#172b4d" : "#6b7280",
                                                            borderBottom:
                                                                activeCommentTab === "comments"
                                                                    ? "2px solid #0052cc"
                                                                    : "2px solid transparent",
                                                            cursor: "pointer",
                                                        }}
                                                    >
                                                        Comments
                                                    </button>

                                                    <button
                                                        type="button"
                                                        onClick={() => setActiveCommentTab("history")}
                                                        style={{
                                                            background: "none",
                                                            border: "none",
                                                            padding: "6px 0",
                                                            fontSize: 14,
                                                            fontWeight: activeCommentTab === "history" ? 600 : 400,
                                                            color: activeCommentTab === "history" ? "#172b4d" : "#6b7280",
                                                            borderBottom:
                                                                activeCommentTab === "history"
                                                                    ? "2px solid #0052cc"
                                                                    : "2px solid transparent",
                                                            cursor: "pointer",
                                                        }}
                                                    >
                                                        History
                                                    </button>
                                                    {hasTeamworkAccess() && (
                                                        <div
                                                            style={{
                                                                marginLeft: "auto",
                                                                display: "flex",
                                                                alignItems: "center",
                                                                gap: "12px",
                                                            }}
                                                        >
                                                            {lastCommentDate && (
                                                                <div
                                                                    style={{
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        gap: "6px",
                                                                        padding: "5px 10px",
                                                                        borderRadius: "6px",
                                                                        background: "#f5f5f5",
                                                                        border: "1px solid #e8e8e8",
                                                                    }}
                                                                >
                                                                    <svg
                                                                        width="13"
                                                                        height="13"
                                                                        viewBox="0 0 24 24"
                                                                        fill="none"
                                                                        stroke="#888"
                                                                        strokeWidth="2"
                                                                        strokeLinecap="round"
                                                                        strokeLinejoin="round"
                                                                    >
                                                                        <circle cx="12" cy="12" r="10" />
                                                                        <polyline points="12 6 12 12 16 14" />
                                                                    </svg>
                                                                    <span style={{ fontSize: "12px", color: "#666", fontWeight: 500 }}>
                                                                        Last Modified:
                                                                    </span>
                                                                    <span style={{ fontSize: "12px", color: "#333", fontWeight: 600 }}>
                                                                        {lastCommentDate}
                                                                    </span>
                                                                </div>
                                                            )}

                                                            <button
                                                                onClick={handleGetComments}
                                                                disabled={isFetchingComments}
                                                                style={{
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    gap: "7px",
                                                                    padding: "7px 16px",
                                                                    borderRadius: "7px",
                                                                    border: "none",
                                                                    background: isFetchingComments
                                                                        ? "#a5b4fc"
                                                                        : "linear-gradient(135deg, #6366f1, #4f46e5)",
                                                                    color: "#fff",
                                                                    fontSize: "13px",
                                                                    fontWeight: 600,
                                                                    cursor: isFetchingComments ? "not-allowed" : "pointer",
                                                                    boxShadow: isFetchingComments
                                                                        ? "none"
                                                                        : "0 2px 8px rgba(99,102,241,0.35)",
                                                                    transition: "all 0.2s ease",
                                                                    letterSpacing: "0.01em",
                                                                }}
                                                                onMouseEnter={(e) => {
                                                                    if (!isFetchingComments) {
                                                                        e.currentTarget.style.transform = "translateY(-1px)";
                                                                        e.currentTarget.style.boxShadow = "0 4px 14px rgba(99,102,241,0.45)";
                                                                    }
                                                                }}
                                                                onMouseLeave={(e) => {
                                                                    e.currentTarget.style.transform = "translateY(0)";
                                                                    e.currentTarget.style.boxShadow = "0 2px 8px rgba(99,102,241,0.35)";
                                                                }}
                                                            >
                                                                {isFetchingComments ? (
                                                                    <>
                                                                        <svg
                                                                            width="13"
                                                                            height="13"
                                                                            viewBox="0 0 24 24"
                                                                            fill="none"
                                                                            stroke="currentColor"
                                                                            strokeWidth="2.5"
                                                                            strokeLinecap="round"
                                                                            style={{
                                                                                animation: "spin 0.8s linear infinite",
                                                                            }}
                                                                        >
                                                                            <path d="M21 12a9 9 0 1 1-6.219-8.56" />
                                                                        </svg>
                                                                        Fetching...
                                                                    </>
                                                                ) : (
                                                                    <>
                                                                        <svg
                                                                            width="13"
                                                                            height="13"
                                                                            viewBox="0 0 24 24"
                                                                            fill="none"
                                                                            stroke="currentColor"
                                                                            strokeWidth="2.5"
                                                                            strokeLinecap="round"
                                                                            strokeLinejoin="round"
                                                                        >
                                                                            <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
                                                                        </svg>
                                                                        Get Comments
                                                                    </>
                                                                )}
                                                            </button>

                                                            {/* Spin keyframe — add once to a global <style> or your CSS file */}
                                                            <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
                                                        </div>
                                                    )}
                                                </div>




                                                <div
                                                    className="comments-container p-2"
                                                    style={{
                                                        maxHeight: "none",
                                                        // overflowY: "auto",
                                                        overflowY: "visible",
                                                        paddingRight: "8px",
                                                        border: "1px solid #eee",
                                                        borderRadius: "10px",
                                                        background: "#fbfcfd",
                                                    }}
                                                >

                                                    {/*  COMMENTS VIEW  */}
                                                    {activeCommentTab === "comments" && (
                                                        <>
                                                            {commentsLoading ? (
                                                                <div className="text-center p-3">
                                                                    <div className="spinner-border text-primary" role="status"></div>
                                                                </div>
                                                            ) : comments.length > 0 ? (
                                                                <>
                                                                    <div className="d-flex flex-column gap-3">
                                                                        {comments.map((c) => {
                                                                            // normalize attachments (if stored as JSON string)
                                                                            let attachmentsArray = [];
                                                                            try {
                                                                                attachmentsArray = typeof c.attachments === "string" ? JSON.parse(c.attachments) : c.attachments || [];
                                                                            } catch (err) {
                                                                                console.error("Invalid attachments JSON", err);
                                                                                attachmentsArray = c.attachments || [];
                                                                            }

                                                                            const commentReplies = c.replies || [];

                                                                            const isOwnComment =
                                                                                c.author &&
                                                                                loggedUserName &&
                                                                                c.author.trim().toLowerCase() === loggedUserName.trim().toLowerCase();


                                                                            // friendly timestamp (fallback to toLocaleString if format fails)
                                                                            // Convert given date string → IST Date object
                                                                            // Cutoff: the date you switched server timezone to Asia/Kolkata
                                                                            // Set this to the approximate date/time you made the server change
                                                                            const SERVER_TZ_CUTOFF = new Date("2025-07-01T00:00:00Z"); // ← adjust this date

                                                                            const smartParseDate = (dateString) => {
                                                                                if (!dateString) return null;
                                                                                const d = new Date(dateString);
                                                                                if (isNaN(d.getTime())) return null;

                                                                                // Old comments (stored in UTC) → need manual IST conversion
                                                                                // New comments (stored in IST) → already correct, just parse directly
                                                                                if (d < SERVER_TZ_CUTOFF) {
                                                                                    const istOffset = 330; // minutes
                                                                                    return new Date(d.getTime() + istOffset * 60 * 1000);
                                                                                }

                                                                                // New comments: server already stores IST, so just return as-is
                                                                                return d;
                                                                            };

                                                                            let ts = "";
                                                                            try {
                                                                                const parsed = smartParseDate(c.createdAt);
                                                                                ts = parsed ? format(parsed, "dd MMM yyyy, hh:mm a") : "";
                                                                            } catch (err) {
                                                                                ts = c.createdAt
                                                                                    ? new Date(c.createdAt).toLocaleString("en-IN", {
                                                                                        timeZone: "Asia/Kolkata",
                                                                                    })
                                                                                    : "";
                                                                            }

                                                                            const isEdited =
                                                                                (c.updatedAt &&
                                                                                    c.createdAt &&
                                                                                    new Date(c.updatedAt).getTime() !== new Date(c.createdAt).getTime()) ||
                                                                                Boolean(c.edited);

                                                                            return (
                                                                                <div
                                                                                    key={c.id}
                                                                                    className="p-3 rounded-3"
                                                                                    style={{
                                                                                        background: "#ffffff",
                                                                                        position: "relative",
                                                                                        display: "flex",
                                                                                        gap: "14px",
                                                                                        alignItems: "flex-start",
                                                                                        boxShadow: "0 4px 10px rgba(15, 23, 42, 0.04)",
                                                                                        borderLeft: "3px solid rgba(13,110,253,0.14)",
                                                                                    }}
                                                                                >
                                                                                    {/* Avatar */}
                                                                                    {/* <div
                                                                                            className="rounded-circle flex-shrink-0 overflow-hidden"
                                                                                            style={{
                                                                                                width: 30,
                                                                                                height: 30,
                                                                                                background: "#e9ecef",
                                                                                                borderRadius: "50%",
                                                                                            }}
                                                                                            title={c.author}
                                                                                            >
                                                                                            {c.photoPath ? (
                                                                                                <img
                                                                                                src={`${API_BASE_URL}/uploads/${c.photoPath}`}
                                                                                                alt={c.author}
                                                                                                style={{
                                                                                                    width: "100%",
                                                                                                    height: "100%",
                                                                                                    objectFit: "cover"
                                                                                                }}
                                                                                                onError={(e) => {
                                                                                                    e.target.onerror = null;
                                                                                                    e.target.src = "/default-avatar.png";
                                                                                                }}
                                                                                                />
                                                                                            ) : (
                                                                                                <div
                                                                                                className="d-flex justify-content-center align-items-center"
                                                                                                style={{
                                                                                                    width: "100%",
                                                                                                    height: "100%",
                                                                                                    background: "#0d6efd",
                                                                                                    color: "#fff",
                                                                                                    fontWeight: "bold",
                                                                                                    fontSize: 14,
                                                                                                }}
                                                                                                >
                                                                                                {c.author ? c.author.charAt(0).toUpperCase() : "U"}
                                                                                                </div>
                                                                                            )}
                                                                                            </div> */}

                                                                                    <div
                                                                                        className="rounded-circle flex-shrink-0 d-flex justify-content-center align-items-center"
                                                                                        title={c.author}
                                                                                        style={{
                                                                                            width: 30,
                                                                                            height: 30,
                                                                                            background: getAvatarColor(c.author),
                                                                                            color: "#fff",
                                                                                            fontWeight: "normal",
                                                                                            fontSize: 14,
                                                                                            borderRadius: "50%",
                                                                                            userSelect: "none",
                                                                                        }}
                                                                                    >
                                                                                        {c.author
                                                                                            ? c.author
                                                                                                .trim()
                                                                                                .split(/\s+/)
                                                                                                .map(w => w.charAt(0).toUpperCase())
                                                                                                .slice(0, 2)
                                                                                                .join("")
                                                                                            : "U"}

                                                                                    </div>


                                                                                    {/* Content */}
                                                                                    <div className="flex-grow-1 d-flex flex-column" style={{ minWidth: 0 }}>
                                                                                        <div className="d-flex justify-content-between align-items-start mb-1">
                                                                                            <div>
                                                                                                <strong style={{ fontSize: 15 }}>{c.author || "Unknown"}</strong>
                                                                                                <div style={{ fontSize: 12, color: "#6c757d", marginTop: 2 }}>
                                                                                                    {ts} {isEdited && <span className="badge bg-light text-muted ms-2" style={{ fontSize: 11 }}>edited</span>}
                                                                                                </div>
                                                                                            </div>

                                                                                            <button
                                                                                                type="button"
                                                                                                className="btn btn-sm "
                                                                                                title="Copy comment"
                                                                                                onClick={async () => {
                                                                                                    try {
                                                                                                        const html = c.html || "";
                                                                                                        const text = c.text || "";

                                                                                                        if (navigator.clipboard && window.ClipboardItem) {
                                                                                                            const htmlBlob = new Blob([html], { type: "text/html" });
                                                                                                            const textBlob = new Blob([text], { type: "text/plain" });

                                                                                                            await navigator.clipboard.write([
                                                                                                                new ClipboardItem({
                                                                                                                    "text/html": htmlBlob,
                                                                                                                    "text/plain": textBlob,
                                                                                                                }),
                                                                                                            ]);
                                                                                                        } else {
                                                                                                            await navigator.clipboard.writeText(text);
                                                                                                        }

                                                                                                        // ✅ Change icon to tick
                                                                                                        setCopiedUI(c.id);
                                                                                                        setTimeout(() => setCopiedUI(null), 2000);
                                                                                                    } catch (err) {
                                                                                                        console.error("Copy failed:", err);
                                                                                                    }
                                                                                                }}
                                                                                                aria-label="Copy comment"
                                                                                                style={{
                                                                                                    width: 36,
                                                                                                    height: 36,
                                                                                                    padding: 0,
                                                                                                    display: "inline-flex",
                                                                                                    alignItems: "center",
                                                                                                    justifyContent: "center",
                                                                                                    borderRadius: 8,
                                                                                                }}
                                                                                            >
                                                                                                {/* ✅ Toggle icon */}
                                                                                                <i
                                                                                                    className={
                                                                                                        copiedUI === c.id
                                                                                                            ? "bi bi-check-lg text-success"
                                                                                                            : "bi bi-files"
                                                                                                    }
                                                                                                    style={{ fontSize: 14 }}
                                                                                                ></i>
                                                                                            </button>

                                                                                        </div>




                                                                                        {/* Edit mode */}
                                                                                        {editingCommentId === c.id ? (
                                                                                            <NewCommentEditor
                                                                                                initialHtml={c.html || c.text || ""}
                                                                                                mentionableUsers={mentionableUsers}
                                                                                                submitLabel="Save"
                                                                                                showCancelBtn={true}
                                                                                                autoFocus={true}
                                                                                                onSubmit={addComment}
                                                                                                onCancel={() => {
                                                                                                    setEditingCommentId(null);
                                                                                                    setEditContent("");
                                                                                                }}
                                                                                            />
                                                                                        ) : (
                                                                                            <div>
                                                                                                {/* inside your comment render */}
                                                                                                <div
                                                                                                    className="comment-body mt-2"
                                                                                                    dangerouslySetInnerHTML={{
                                                                                                        __html: `
                                                                                                                    <style>
                                                                                                                        .comment-body img {
                                                                                                                        max-width: 100%;
                                                                                                                        height: auto;
                                                                                                                        display: block;
                                                                                                                        }
                                                                                                                    </style>
                                                                                                                    ${c.html}
                                                                                                                    `
                                                                                                    }}
                                                                                                    style={{
                                                                                                        fontSize: 14,
                                                                                                        lineHeight: "1.4",
                                                                                                        cursor: "default",
                                                                                                        overflowWrap: "break-word",
                                                                                                        wordBreak: "break-word",
                                                                                                        whiteSpace: "normal",
                                                                                                    }}
                                                                                                    onClick={(e) => handleCommentImageClick(e, c)}
                                                                                                ></div>




                                                                                                {/* Attachments grid */}
                                                                                                {attachmentsArray.length > 0 && (
                                                                                                    <div className="d-flex flex-wrap gap-2 mb-2">

                                                                                                        {attachmentsArray
                                                                                                            .filter((file) => !/\.(jpe?g|png|gif|bmp|webp)$/i.test(file.name || "")) // 🚫 remove images
                                                                                                            .map((file, idx) => (
                                                                                                                <a
                                                                                                                    key={idx}
                                                                                                                    onClick={() => downloadFileAsBlob(file)}
                                                                                                                    className="badge bg-white text-dark d-inline-flex align-items-center"
                                                                                                                    style={{
                                                                                                                        fontSize: 13,
                                                                                                                        padding: "8px 10px",
                                                                                                                        borderRadius: 10,
                                                                                                                        border: "1px solid #f0f0f0",
                                                                                                                        boxShadow: "0 2px 6px rgba(0,0,0,0.03)",
                                                                                                                        cursor: "pointer",
                                                                                                                        textDecoration: "none",
                                                                                                                    }}
                                                                                                                    title={file.name}
                                                                                                                >
                                                                                                                    📎 {file.name}
                                                                                                                </a>
                                                                                                            ))}
                                                                                                    </div>
                                                                                                )}

                                                                                            </div>
                                                                                        )}


                                                                                        {/* Reply input — drop this in where you render comment replies */}
                                                                                        {replyToCommentId === c.id && (
                                                                                            <div className="card shadow-sm border-0 task-sections task-sections--comments reply-card">
                                                                                                <div className="card-body col-md-12 p-3">

                                                                                                    {/* Toolbar */}
                                                                                                    <div
                                                                                                        className="d-flex gap-2 flex-wrap align-items-center mb-2"
                                                                                                        style={{ borderBottom: "1px solid #eee", paddingBottom: "8px" }}
                                                                                                    >
                                                                                                        <div className="d-flex gap-1" style={{ alignItems: "center" }}>
                                                                                                            <button type="button" className="btn btn-sm btn-outline-secondary" title="Bold (Ctrl+B)" onClick={() => document.execCommand("bold")}><b>B</b></button>
                                                                                                            <button type="button" className="btn btn-sm btn-outline-secondary" title="Italic (Ctrl+I)" onClick={() => document.execCommand("italic")}><i>I</i></button>
                                                                                                            <button type="button" className="btn btn-sm btn-outline-secondary" title="Underline (Ctrl+U)" onClick={() => document.execCommand("underline")}><u>U</u></button>
                                                                                                            <button
                                                                                                                type="button"
                                                                                                                className="btn btn-sm btn-outline-secondary"
                                                                                                                title="Numbered List"
                                                                                                                onClick={() => document.execCommand("insertOrderedList")}
                                                                                                            >
                                                                                                                <i className="bi bi-list-ol"></i>
                                                                                                            </button>

                                                                                                            <div style={{ position: "relative" }}>
                                                                                                                <button
                                                                                                                    type="button"
                                                                                                                    className="btn btn-sm btn-outline-secondary"
                                                                                                                    title="Text Color"
                                                                                                                    onClick={() => document.getElementById("colorPickerInput").click()}
                                                                                                                >
                                                                                                                    <i className="bi bi-palette"></i>
                                                                                                                </button>

                                                                                                                <input
                                                                                                                    type="color"
                                                                                                                    id="colorPickerInput"
                                                                                                                    style={{ visibility: "hidden", position: "absolute" }}
                                                                                                                    onChange={(e) => document.execCommand("foreColor", false, e.target.value)}
                                                                                                                />
                                                                                                            </div>


                                                                                                            <div style={{ position: "relative" }}>
                                                                                                                <button
                                                                                                                    type="button"
                                                                                                                    className="btn btn-sm btn-outline-secondary"
                                                                                                                    title="Highlight Color"
                                                                                                                    onClick={() => document.getElementById("highlightPickerInput").click()}
                                                                                                                >
                                                                                                                    <i className="bi bi-highlighter"></i>
                                                                                                                </button>

                                                                                                                <input
                                                                                                                    type="color"
                                                                                                                    id="highlightPickerInput"
                                                                                                                    style={{ visibility: "hidden", position: "absolute" }}
                                                                                                                    onChange={(e) =>
                                                                                                                        document.execCommand("hiliteColor", false, e.target.value)
                                                                                                                    }
                                                                                                                />
                                                                                                            </div>
                                                                                                            <button type="button" className="btn btn-sm btn-outline-secondary" title="Insert link" onClick={() => { const url = prompt("Enter link URL:"); if (url) document.execCommand("createLink", false, url); }}>🔗</button>
                                                                                                            <label className="btn btn-sm btn-outline-secondary mb-0" style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
                                                                                                                📎 Attach
                                                                                                                <input type="file" multiple onChange={(ev) => {
                                                                                                                    const files = Array.from(ev.target.files || []);
                                                                                                                    // convert or directly store files as you need
                                                                                                                    setReplyAttachments(prev => [...(prev || []), ...files.map(f => ({ name: f.name, file: f }))]);
                                                                                                                }} hidden />
                                                                                                            </label>
                                                                                                        </div>
                                                                                                    </div>

                                                                                                    {/* Editor + bottom row */}
                                                                                                    <div style={{ display: "flex", flexDirection: "column", position: "relative", border: "1px solid #e6e9ee", borderRadius: "8px", background: "#fff", minHeight: "120px", padding: "8px" }}>


                                                                                                        {/* Editable area */}
                                                                                                        <div
                                                                                                            ref={replyEditorRef}
                                                                                                            className="mb-2 reply-input"
                                                                                                            contentEditable
                                                                                                            suppressContentEditableWarning
                                                                                                            onInput={handleReplyEditorInput}
                                                                                                            onKeyUp={saveCaret}
                                                                                                            onKeyDown={(e) => {
                                                                                                                if ((e.ctrlKey || e.metaKey) && e.key === "Enter") {
                                                                                                                    e.preventDefault();
                                                                                                                    // call your submit handler
                                                                                                                    if (typeof submitReply === "function") submitReply(c.id);
                                                                                                                }
                                                                                                            }}
                                                                                                            onClick={saveCaret}
                                                                                                            onPaste={handleReplyPaste}
                                                                                                            style={{
                                                                                                                minHeight: "80px",
                                                                                                                outline: "none",
                                                                                                                textAlign: "left",
                                                                                                                fontSize: "14px",
                                                                                                                lineHeight: "1.6",
                                                                                                                fontFamily: 'system-ui, -apple-system, "Segoe UI", Roboto, sans-serif',
                                                                                                                overflowY: "auto",
                                                                                                                whiteSpace: "pre-wrap",
                                                                                                                wordWrap: "break-word",
                                                                                                                padding: "6px",
                                                                                                            }}
                                                                                                            role="textbox"
                                                                                                            aria-label="Reply editor"
                                                                                                        ></div>

                                                                                                        {/* Placeholder (rendered AFTER contentEditable so CSS selector is simple) */}
                                                                                                        <div
                                                                                                            className="reply-placeholder"
                                                                                                            onClick={() => replyEditorRef.current && replyEditorRef.current.focus()}
                                                                                                            style={{ position: "absolute", left: 12, top: 12, pointerEvents: "none", color: "#6c757d", fontSize: 14 }}
                                                                                                        >
                                                                                                            reply...
                                                                                                        </div>

                                                                                                        {/* Mention chips / attachments row */}
                                                                                                        <div className="d-flex gap-2 align-items-center" style={{ paddingTop: "6px", borderTop: "1px solid #f1f3f5", marginTop: "6px", background: "#fafbfc", borderBottomLeftRadius: 8, borderBottomRightRadius: 8, paddingBottom: 8 }}>
                                                                                                            {/* <div className="d-flex gap-2 overflow-auto" style={{ flex: 1 }}>
                                                                                                                    {mentionableUsers.slice(0, 10).map((u) => {
                                                                                                                    const photoUrl = u.photoPath ? `${API_BASE_URL}/uploads/${u.photoPath}` : null;
                                                                                                                    return (
                                                                                                                        <div key={u.id} className="d-flex align-items-center px-2 py-1 rounded" style={{ background: "#eef2ff", cursor: "pointer", whiteSpace: "nowrap" }} onClick={() => {
                                                                                                                        
                                                                                                                        if (!replyEditorRef.current) return;
                                                                                                                        const mention = `@${u.firstName} ${u.lastName} `;
                                                                                                                        document.execCommand("insertText", false, mention);
                                                                                                                        handleReplyEditorInput();
                                                                                                                        }}>
                                                                                                                        <div className="rounded-circle me-2 d-flex justify-content-center align-items-center" style={{ width: 26, height: 26, overflow: "hidden", flexShrink: 0, background: photoUrl ? "transparent" : "#0d6efd", color: "#fff", fontWeight: 700, fontSize: 12 }}>
                                                                                                                            {photoUrl ? <img src={photoUrl} alt={`${u.firstName} ${u.lastName}`} style={{ width: "100%", height: "100%", objectFit: "cover" }} onError={(e) => { e.currentTarget.onerror = null; e.currentTarget.src = "/images/avatar-placeholder.png"; }} /> : u.firstName.charAt(0).toUpperCase()}
                                                                                                                        </div>
                                                                                                                        <span style={{ fontSize: 13, fontWeight: 500 }}>{u.firstName} {u.lastName}</span>
                                                                                                                        </div>
                                                                                                                    );
                                                                                                                    })}
                                                                                                                </div> */}

                                                                                                            {/* Attachments preview */}
                                                                                                            <div className="d-flex align-items-center">
                                                                                                                {replyAttachments && replyAttachments.length > 0 && (
                                                                                                                    <div className="me-2">
                                                                                                                        {replyAttachments.map((f, i) => (
                                                                                                                            <span key={i} className="badge bg-white text-dark me-1 d-inline-flex align-items-center" style={{ fontSize: "13px", padding: "6px 8px", border: "1px solid #e6e9ee", borderRadius: "12px", background: "#fff" }}>
                                                                                                                                📎 {f.name}
                                                                                                                                <button className="btn btn-sm btn-link text-danger p-0 ms-2" onClick={() => {
                                                                                                                                    const copy = [...replyAttachments];
                                                                                                                                    copy.splice(i, 1);
                                                                                                                                    setReplyAttachments(copy);
                                                                                                                                }} style={{ fontSize: "12px" }} type="button">✕</button>
                                                                                                                            </span>
                                                                                                                        ))}
                                                                                                                    </div>
                                                                                                                )}


                                                                                                            </div>
                                                                                                        </div>

                                                                                                        {/* Mention suggestions popup (optional if you have showSuggestions/filteredUsers logic) */}
                                                                                                        {replyShowSuggestions && filteredUsers.length > 0 && replyEditorRef.current && (
                                                                                                            <div className="position-absolute" style={{ zIndex: 1000, top: (replyEditorRef.current?.offsetTop || 0) + (replyEditorRef.current?.offsetHeight || 0) + 6, left: replyEditorRef.current?.offsetLeft || 0 }}>
                                                                                                                <div className="shadow-lg border bg-white rounded-3 overflow-hidden" style={{ width: "320px", maxHeight: "260px", overflowY: "auto", boxShadow: "0 6px 20px rgba(0,0,0,0.12)" }}>
                                                                                                                    {filteredUsers.map((u, i) => (
                                                                                                                        <button key={u.id} type="button" onClick={() => insertMentionAtCaret(u)}

                                                                                                                            className="d-flex align-items-center w-100 px-3 py-2 border-0 text-start bg-transparent" style={{ cursor: "pointer", transition: "all 0.12s ease-in-out", borderBottom: i < filteredUsers.length - 1 ? "1px solid #f0f0f0" : "none" }}>
                                                                                                                            <div className="rounded-circle d-flex justify-content-center align-items-center me-3" style={{ width: 36, height: 36, overflow: "hidden", flexShrink: 0, background: "#0d6efd", color: "#fff", fontWeight: 600, fontSize: 15 }}>
                                                                                                                                {u.firstName.charAt(0).toUpperCase()}
                                                                                                                            </div>
                                                                                                                            <div className="flex-grow-1">
                                                                                                                                <div style={{ fontSize: 14, fontWeight: 600, color: "#212529" }}>{u.firstName} {u.lastName}</div>
                                                                                                                            </div>
                                                                                                                        </button>
                                                                                                                    ))}
                                                                                                                </div>
                                                                                                            </div>
                                                                                                        )}

                                                                                                    </div>

                                                                                                    {/* Actions — visible only when editor has content or attachments */}
                                                                                                    {replyToCommentId === c.id && (
                                                                                                        <div className="d-flex justify-content-end gap-2 mt-3">
                                                                                                            <button
                                                                                                                className="btn btn-outline-secondary btn-sm"
                                                                                                                onClick={() => {
                                                                                                                    setReplyToCommentId(null);
                                                                                                                    setReplyAttachments([]);
                                                                                                                    if (replyEditorRef.current) {
                                                                                                                        replyEditorRef.current.innerHTML = "";
                                                                                                                        replyEditorRef.current.setAttribute("data-filled", "false");
                                                                                                                    }
                                                                                                                }}
                                                                                                            >
                                                                                                                Cancel
                                                                                                            </button>

                                                                                                            <button
                                                                                                                className="btn btn-primary btn-sm"
                                                                                                                onClick={() => submitReply(c.id)}
                                                                                                            >
                                                                                                                save
                                                                                                            </button>
                                                                                                        </div>
                                                                                                    )}


                                                                                                </div>
                                                                                            </div>
                                                                                        )}

                                                                                        {/* --- Icon action row: Reply / Edit / Delete (moved BELOW content) --- */}
                                                                                        {editingCommentId !== c.id && (
                                                                                            <div
                                                                                                className="d-flex align-items-center gap-2 mt-2 pt-2"
                                                                                                style={{
                                                                                                    borderTop: "1px solid #eef2f6",
                                                                                                    marginTop: 8,
                                                                                                    paddingTop: 8,
                                                                                                    justifyContent: "flex-start",
                                                                                                }}
                                                                                            >
                                                                                                {/* Reply icon */}
                                                                                                {/* <button
                                                                                                    type="button"
                                                                                                    className="btn btn-sm btn-light"
                                                                                                    title="Reply"
                                                                                                    onClick={() => {
                                                                                                        setReplyToCommentId(c.id);
                                                                                                        setReplyContent("");
                                                                                                        // optional: scroll into view
                                                                                                        // document.getElementById(`comment-${c.id}`)?.scrollIntoView({ behavior: 'smooth', block: 'center' });
                                                                                                    }}
                                                                                                    aria-label="Reply"
                                                                                                    style={{
                                                                                                        width: 36,
                                                                                                        height: 36,
                                                                                                        padding: 0,
                                                                                                        display: "inline-flex",
                                                                                                        alignItems: "center",
                                                                                                        justifyContent: "center",
                                                                                                        borderRadius: 8,
                                                                                                    }}
                                                                                                    >
                                                                                                    <i className="bi bi-chat-left-text-fill" style={{ fontSize: 12 }}></i>
                                                                                                    </button> */}



                                                                                                {/* Edit icon */}
                                                                                                {isOwnComment && (
                                                                                                    <button
                                                                                                        type="button"
                                                                                                        className="btn btn-sm btn-light"
                                                                                                        title="Edit"
                                                                                                        // Replace the existing onClick for the Edit button with this
                                                                                                        onClick={() => {
                                                                                                            setEditingCommentId(c.id);
                                                                                                            setEditContent(c.text || "");

                                                                                                            // Normalize attachments coming from server which may be:
                                                                                                            // - already an array (parsed)
                                                                                                            // - or a JSON string (e.g. "[{...}]")
                                                                                                            let incoming = [];
                                                                                                            try {
                                                                                                                if (Array.isArray(c.attachments)) {
                                                                                                                    incoming = c.attachments;
                                                                                                                } else if (typeof c.attachments === "string" && c.attachments.trim()) {
                                                                                                                    incoming = JSON.parse(c.attachments);
                                                                                                                } else {
                                                                                                                    incoming = [];
                                                                                                                }
                                                                                                            } catch (err) {
                                                                                                                console.warn("Failed to parse comment.attachments, falling back to empty", err);
                                                                                                                incoming = [];
                                                                                                            }

                                                                                                            // Normalize to a consistent shape your edit UI expects: { id?, name?, url?, base64?, file? }
                                                                                                            const normalized = (incoming || []).map((a) => {
                                                                                                                if (!a) return null;
                                                                                                                // if the server already returned a url or id (existing attachment)
                                                                                                                if (a.url || a.id) {
                                                                                                                    return {
                                                                                                                        id: a.id || null,
                                                                                                                        name: a.name || (a.url ? a.url.split("/").pop() : "attachment"),
                                                                                                                        url: a.url || null,
                                                                                                                    };
                                                                                                                }
                                                                                                                // if server returned base64 inline
                                                                                                                if (a.base64) {
                                                                                                                    return {
                                                                                                                        id: a.id || null,
                                                                                                                        name: a.name || "attachment",
                                                                                                                        base64: a.base64,
                                                                                                                    };
                                                                                                                }
                                                                                                                // fallback: copy whatever fields exist
                                                                                                                return {
                                                                                                                    id: a.id || null,
                                                                                                                    name: a.name || a.fileName || "attachment",
                                                                                                                    url: a.url || null,
                                                                                                                    base64: a.base64 || null,
                                                                                                                };
                                                                                                            }).filter(Boolean);

                                                                                                            // THIS IS THE KEY: populate editAttachments (edit UI reads this)
                                                                                                            setEditAttachments(normalized);

                                                                                                            // Put the comment text into the contentEditable and focus
                                                                                                            // helper: move caret to end of contentEditable
                                                                                                            function moveCaretToEnd(el) {
                                                                                                                el = el || editRef.current;
                                                                                                                if (!el) return;
                                                                                                                el.focus();
                                                                                                                if (typeof window.getSelection !== "undefined"
                                                                                                                    && typeof document.createRange !== "undefined") {
                                                                                                                    const range = document.createRange();
                                                                                                                    range.selectNodeContents(el);
                                                                                                                    range.collapse(false);
                                                                                                                    const sel = window.getSelection();
                                                                                                                    sel.removeAllRanges();
                                                                                                                    sel.addRange(range);
                                                                                                                } else if (document.body.createTextRange) { // IE fallback
                                                                                                                    const textRange = document.body.createTextRange();
                                                                                                                    textRange.moveToElementText(el);
                                                                                                                    textRange.collapse(false);
                                                                                                                    textRange.select();
                                                                                                                }
                                                                                                            }

                                                                                                            setTimeout(() => {
                                                                                                                if (!editRef.current) return;
                                                                                                                // Prefer server-side HTML if provided
                                                                                                                const serverHtml = c.html || ""; // `c.html` should contain your saved innerHTML (with <img src="data:...">)
                                                                                                                if (serverHtml && serverHtml.trim()) {
                                                                                                                    // Put the raw HTML into editor (preserves images and formatting)
                                                                                                                    editRef.current.innerHTML = serverHtml;
                                                                                                                    editRef.current.setAttribute("data-filled", "true");
                                                                                                                } else if (c.text) {
                                                                                                                    // If only plain text is available, set textContent (not innerText) to avoid layout quirks
                                                                                                                    editRef.current.textContent = c.text;
                                                                                                                    editRef.current.setAttribute("data-filled", "true");

                                                                                                                    // If there are editAttachments with base64 images but serverHtml didn't include them,
                                                                                                                    // we append them after the text so user still sees attachments.
                                                                                                                    if (Array.isArray(normalized) && normalized.length) {
                                                                                                                        normalized.forEach((att) => {
                                                                                                                            if (att.base64 && /^data:image\/(png|jpe?g|gif|webp);base64,/.test(att.base64)) {
                                                                                                                                const img = document.createElement("img");
                                                                                                                                img.src = att.base64;
                                                                                                                                img.alt = att.name || "attachment";
                                                                                                                                img.style.maxWidth = "300px";
                                                                                                                                img.style.maxHeight = "180px";
                                                                                                                                img.style.display = "block";
                                                                                                                                img.style.marginTop = "8px";
                                                                                                                                editRef.current.appendChild(img);
                                                                                                                            } else if (att.url && /\.(jpe?g|png|gif|webp|bmp)$/i.test(att.name || att.url)) {
                                                                                                                                const img = document.createElement("img");
                                                                                                                                img.src = att.url;
                                                                                                                                img.alt = att.name || "attachment";
                                                                                                                                img.style.maxWidth = "300px";
                                                                                                                                img.style.maxHeight = "180px";
                                                                                                                                img.style.display = "block";
                                                                                                                                img.style.marginTop = "8px";
                                                                                                                                editRef.current.appendChild(img);
                                                                                                                            } else if (att.url || att.name) {
                                                                                                                                // render file badge for non-images
                                                                                                                                const span = document.createElement("a");
                                                                                                                                span.href = att.url || "#";
                                                                                                                                span.textContent = "📎 " + (att.name || att.url.split("/").pop());
                                                                                                                                span.target = "_blank";
                                                                                                                                span.rel = "noreferrer";
                                                                                                                                span.style.display = "inline-block";
                                                                                                                                span.style.margin = "6px 0";
                                                                                                                                editRef.current.appendChild(span);
                                                                                                                            }
                                                                                                                        });
                                                                                                                    }
                                                                                                                } else {
                                                                                                                    editRef.current.innerHTML = "";
                                                                                                                    editRef.current.setAttribute("data-filled", "false");
                                                                                                                }

                                                                                                                // move caret to end and focus
                                                                                                                moveCaretToEnd(editRef.current);
                                                                                                            }, 120);

                                                                                                        }}



                                                                                                        aria-label="Edit"
                                                                                                        style={{
                                                                                                            width: 36,
                                                                                                            height: 36,
                                                                                                            padding: 0,
                                                                                                            display: "inline-flex",
                                                                                                            alignItems: "center",
                                                                                                            justifyContent: "center",
                                                                                                            borderRadius: 8,
                                                                                                        }}
                                                                                                    >
                                                                                                        <i className="bi bi-pencil" style={{ fontSize: 11 }}></i>
                                                                                                    </button>
                                                                                                )}
                                                                                                {/* Delete icon (owner only) */}
                                                                                                {isOwnComment && (
                                                                                                    <button
                                                                                                        type="button"
                                                                                                        className="btn btn-sm btn-light "
                                                                                                        title="Delete"
                                                                                                        onClick={() => deleteComment(c.id)}
                                                                                                        aria-label="Delete"
                                                                                                        style={{
                                                                                                            width: 36,
                                                                                                            height: 36,
                                                                                                            padding: 0,
                                                                                                            display: "inline-flex",
                                                                                                            alignItems: "center",
                                                                                                            justifyContent: "center",
                                                                                                            borderRadius: 8,
                                                                                                        }}
                                                                                                    >
                                                                                                        <i className="bi bi-trash" style={{ fontSize: 11 }}></i>
                                                                                                    </button>
                                                                                                )}
                                                                                            </div>
                                                                                        )}

                                                                                        {/* Replies */}
                                                                                        {c.replies && c.replies.length > 0 && (
                                                                                            <div className="ms-4 mt-3 d-flex flex-column gap-2">
                                                                                                {c.replies.map((r) => {
                                                                                                    const atts = parseAttachmentsField(r);
                                                                                                    const isEditing = editingReplyId === r.id;

                                                                                                    const isOwnReply =
                                                                                                        r.author &&
                                                                                                        loggedUserName &&
                                                                                                        r.author.trim().toLowerCase() === loggedUserName.trim().toLowerCase();

                                                                                                    return (
                                                                                                        <div key={r.id} className="p-2 rounded-2" style={{ background: "rgba(255, 255, 255, 1)", border: "1px solid #f1f3f5" }}>
                                                                                                            <div className="d-flex align-items-start justify-content-between">
                                                                                                                <div style={{ fontSize: 13, fontWeight: 600 }}>{r.author}</div>


                                                                                                                {/* Show action buttons only for owner of the reply */}
                                                                                                                {isOwnReply && (
                                                                                                                    <div className="d-flex gap-1">
                                                                                                                        {isEditing ? (
                                                                                                                            <>
                                                                                                                                <button
                                                                                                                                    className="btn btn-sm btn-outline-secondary"
                                                                                                                                    onClick={() => cancelEditReply()}
                                                                                                                                >
                                                                                                                                    Cancel
                                                                                                                                </button>

                                                                                                                                <button
                                                                                                                                    className="btn btn-sm btn-primary"
                                                                                                                                    onClick={() => saveReplyEdit(r.id, c.id)}
                                                                                                                                >
                                                                                                                                    Save
                                                                                                                                </button>
                                                                                                                            </>
                                                                                                                        ) : (
                                                                                                                            <>
                                                                                                                                {/* <button
                                                                                                                                    className="btn btn-sm btn-light"
                                                                                                                                    title="Edit reply"
                                                                                                                                    onClick={() => startEditReply(r)}
                                                                                                                                    >
                                                                                                                                    <i className="bi bi-pencil-fill" style={{ fontSize: 11 }}></i>
                                                                                                                                    </button> */}

                                                                                                                                <button
                                                                                                                                    className="btn btn-sm btn-light text-danger"
                                                                                                                                    title="Delete reply"
                                                                                                                                    onClick={() => deleteReply(r.id, c.id)}
                                                                                                                                >
                                                                                                                                    <i className="bi bi-trash-fill" style={{ fontSize: 11 }}></i>
                                                                                                                                </button>
                                                                                                                            </>
                                                                                                                        )}
                                                                                                                    </div>
                                                                                                                )}



                                                                                                            </div>

                                                                                                            {/* content or editor */}
                                                                                                            {!isEditing ? (
                                                                                                                <div
                                                                                                                    style={{
                                                                                                                        fontSize: 13,
                                                                                                                        whiteSpace: "pre-wrap",
                                                                                                                        overflowWrap: "anywhere",
                                                                                                                        wordBreak: "break-word",
                                                                                                                        maxWidth: "100%",
                                                                                                                        marginTop: 6,
                                                                                                                        lineHeight: 1.4,
                                                                                                                    }}
                                                                                                                >
                                                                                                                    {r.text}
                                                                                                                </div>

                                                                                                            ) : (
                                                                                                                <div style={{ marginTop: 6 }}>
                                                                                                                    <div
                                                                                                                        ref={replyEditRef}
                                                                                                                        contentEditable
                                                                                                                        suppressContentEditableWarning
                                                                                                                        onInput={() => {
                                                                                                                            setReplyEditContent(replyEditRef.current?.innerHTML || "");
                                                                                                                        }}
                                                                                                                        style={{
                                                                                                                            minHeight: "80px",
                                                                                                                            outline: "none",
                                                                                                                            textAlign: "left",
                                                                                                                            fontSize: "14px",
                                                                                                                            lineHeight: "1.6",
                                                                                                                            fontFamily: 'system-ui, -apple-system, "Segoe UI", Roboto, sans-serif',
                                                                                                                            overflowY: "auto",
                                                                                                                            whiteSpace: "pre-wrap",
                                                                                                                            wordWrap: "break-word",
                                                                                                                            padding: "6px",
                                                                                                                            border: "1px solid #e6e9ee",
                                                                                                                            borderRadius: 8,
                                                                                                                            background: "#fff"
                                                                                                                        }}
                                                                                                                    />
                                                                                                                    {/* attachments editor for reply edit */}
                                                                                                                    <div className="d-flex gap-2 align-items-center mt-2">
                                                                                                                        <label className="btn btn-sm btn-outline-secondary mb-0" style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
                                                                                                                            📎 Attach
                                                                                                                            <input type="file" multiple onChange={(ev) => {
                                                                                                                                const files = Array.from(ev.target.files || []);
                                                                                                                                const list = files.map((f) => ({ file: f, name: f.name }));
                                                                                                                                setReplyEditAttachments(prev => [...(prev || []), ...list]);
                                                                                                                                ev.target.value = null;
                                                                                                                            }} hidden />
                                                                                                                        </label>

                                                                                                                        {/* preview existing/new attachments */}
                                                                                                                        <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                                                                                                                            {(replyEditAttachments || []).map((a, idx) => (
                                                                                                                                <div key={idx} className="badge bg-white text-dark d-inline-flex align-items-center" style={{ padding: "6px 8px", border: "1px solid #e6e9ee", borderRadius: 12 }}>
                                                                                                                                    {a.name}
                                                                                                                                    <button className="btn btn-sm btn-link text-danger p-0 ms-2" type="button" onClick={() => {
                                                                                                                                        setReplyEditAttachments(prev => prev.filter((_, i) => i !== idx));
                                                                                                                                    }}>✕</button>
                                                                                                                                </div>
                                                                                                                            ))}
                                                                                                                        </div>
                                                                                                                    </div>
                                                                                                                </div>
                                                                                                            )}

                                                                                                            {/* attachments display for non-edit mode */}
                                                                                                            {!isEditing && atts.length > 0 && (
                                                                                                                <div className="mt-2" style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                                                                                                                    {atts.map((a, i) => (
                                                                                                                        <div key={i} style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                                                                                                            {a.isImage && a.href ? (
                                                                                                                                <img src={a.href} alt={a.name} style={{ maxWidth: 220, maxHeight: 140, borderRadius: 8, objectFit: "contain", border: "1px solid #ececec" }} />
                                                                                                                            ) : (
                                                                                                                                <a href={a.href || "#"} download={a.href ? a.name : undefined} target={a.href ? "_blank" : undefined} rel={a.href ? "noreferrer" : undefined} className="d-inline-flex align-items-center" style={{ textDecoration: "none", color: "#0d6efd", fontSize: 13 }}>
                                                                                                                                    📎 {a.name}
                                                                                                                                </a>
                                                                                                                            )}
                                                                                                                            {!a.href && <div style={{ fontSize: 13, color: "#6c757d" }}>{a.name}</div>}
                                                                                                                        </div>
                                                                                                                    ))}
                                                                                                                </div>
                                                                                                            )}
                                                                                                        </div>
                                                                                                    );
                                                                                                })}
                                                                                            </div>
                                                                                        )}





                                                                                    </div>
                                                                                </div>
                                                                            );
                                                                        })}
                                                                    </div>

                                                                    {/* Load More button */}
                                                                    <div className="mt-3 pb-2 text-center">
                                                                        {hasMoreComments && (
                                                                            <button
                                                                                className="btn btn-sm btn-outline-secondary px-4"
                                                                                disabled={isLoadingMore}
                                                                                onClick={() => {
                                                                                    fetchComments(activeTask.id, commentPage + 1, true);
                                                                                }}
                                                                            >
                                                                                {isLoadingMore ? (
                                                                                    <>
                                                                                        <span
                                                                                            className="spinner-border spinner-border-sm me-2"
                                                                                            role="status"
                                                                                        />
                                                                                        Loading...
                                                                                    </>
                                                                                ) : (
                                                                                    <>
                                                                                        <i className="bi bi-chevron-down me-1"></i>
                                                                                        Load more comments
                                                                                    </>
                                                                                )}
                                                                            </button>
                                                                        )}
                                                                    </div>
                                                                </>

                                                            ) : (
                                                                <p className="text-muted p-2">No comments yet.</p>

                                                            )}

                                                        </>
                                                    )}

                                                    {activeCommentTab === "history" && (
                                                        <div
                                                            className="p-2"
                                                            style={{
                                                                position: "relative",
                                                                paddingLeft: 24,
                                                            }}
                                                        >
                                                            {/* Vertical timeline line */}
                                                            <div
                                                                style={{
                                                                    position: "absolute",
                                                                    top: 0,
                                                                    bottom: 0,
                                                                    left: 12,
                                                                    width: 2,
                                                                    background: "#e5e7eb",
                                                                }}
                                                            />

                                                            {auditList.length === 0 ? (
                                                                <div className="text-muted text-center">No history available</div>
                                                            ) : (
                                                                auditList.map((a) => {
                                                                    // let timeText = "Unknown time";
                                                                    // try {
                                                                    //   const d = parseAuditDate(a.changedAt);
                                                                    //   if (d) timeText = formatDistanceToNow(d) + " ago";
                                                                    // } catch { }

                                                                    return (
                                                                        <div
                                                                            key={a.auditId || a.id}
                                                                            className="d-flex gap-3 py-2"
                                                                            style={{ position: "relative" }}
                                                                        >
                                                                            {/* Timeline dot */}
                                                                            <div
                                                                                style={{
                                                                                    width: 10,
                                                                                    height: 10,
                                                                                    borderRadius: "50%",
                                                                                    background: "#0052cc", // Jira blue
                                                                                    marginTop: 6,
                                                                                    flexShrink: 0,
                                                                                    position: "relative",
                                                                                    zIndex: 1,
                                                                                }}
                                                                            />

                                                                            {/* Content */}
                                                                            <div className="flex-grow-1">
                                                                                {/* Top row */}
                                                                                <div
                                                                                    className="d-flex flex-wrap align-items-center gap-2"
                                                                                    style={{ fontSize: 13 }}
                                                                                >
                                                                                    <span style={{ fontWeight: 500, color: "#172b4d" }}>
                                                                                        {a.changedBy || "System"}
                                                                                    </span>

                                                                                    <span style={{ color: "#6b778c" }}>
                                                                                        changed
                                                                                    </span>

                                                                                    <span
                                                                                        className="badge"
                                                                                        style={{
                                                                                            background: "#ebecf0",
                                                                                            color: "#172b4d",
                                                                                            fontSize: 11,
                                                                                            fontWeight: 500,
                                                                                        }}
                                                                                    >
                                                                                        {FIELD_LABELS[a.fieldName] || a.fieldName}

                                                                                    </span>

                                                                                    <span style={{ color: "#6b778c" }}>
                                                                                        {(() => {
                                                                                            const d = new Date(a.changedAt);
                                                                                            if (d < SERVER_TZ_CUTOFF) {
                                                                                                return new Date(d.getTime() + 330 * 60 * 1000)
                                                                                                    .toLocaleString("en-GB", {
                                                                                                        day: "2-digit", month: "2-digit", year: "2-digit",
                                                                                                        hour: "2-digit", minute: "2-digit", hour12: false,
                                                                                                    }).replace(",", "");
                                                                                            }
                                                                                            return d.toLocaleString("en-GB", {
                                                                                                day: "2-digit", month: "2-digit", year: "2-digit",
                                                                                                hour: "2-digit", minute: "2-digit", hour12: false,
                                                                                            }).replace(",", "");
                                                                                        })()}

                                                                                    </span>

                                                                                </div>

                                                                                {/* Change values */}
                                                                                <div
                                                                                    style={{
                                                                                        fontSize: 13,
                                                                                        color: "#172b4d",
                                                                                        marginTop: 2,
                                                                                    }}
                                                                                >
                                                                                    <span style={{ color: "#a8071a" }}>
                                                                                        {a.fieldName === "description"
                                                                                            ? stripHtml(a.oldValue).slice(0, 80) || "—"
                                                                                            : a.oldValue || "—"}
                                                                                    </span>{" "}
                                                                                    →{" "}
                                                                                    <span style={{ color: "#237804" }}>
                                                                                        {a.fieldName === "description"
                                                                                            ? stripHtml(a.newValue).slice(0, 80) || "—"
                                                                                            : a.newValue || "—"}
                                                                                    </span>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    );
                                                                })
                                                            )}
                                                        </div>
                                                    )}

                                                    {/* Image lightbox / preview (unchanged functionality) */}
                                                    {previewImages.length > 0 &&
                                                        createPortal(
                                                            <div
                                                                className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
                                                                style={{
                                                                    background: "rgba(0,0,0,0.72)",
                                                                    zIndex: 999999   // 🔥 very high
                                                                }}
                                                                onClick={() => setPreviewImages([])}
                                                            >

                                                                {/* ❌ STOP OVERLAY CLICK */}
                                                                <div onClick={(e) => e.stopPropagation()}>

                                                                    <img
                                                                        src={previewImages[currentImageIndex]}
                                                                        alt="Preview"
                                                                        style={{
                                                                            maxHeight: "80vh",
                                                                            maxWidth: "80vw",
                                                                            borderRadius: 8,
                                                                            display: "block"
                                                                        }}
                                                                    />

                                                                </div>

                                                                {/* CLOSE */}
                                                                <button
                                                                    className="btn btn-danger position-fixed top-0 end-0 m-3"
                                                                    style={{ zIndex: 1000000 }}
                                                                    onClick={() => setPreviewImages([])}
                                                                >
                                                                    ✕
                                                                </button>

                                                                {/* PREV */}
                                                                {currentImageIndex > 0 && (
                                                                    <button
                                                                        className="btn btn-dark position-fixed top-50 start-0 translate-middle-y ms-3"
                                                                        style={{ zIndex: 1000000 }}
                                                                        onClick={(e) => {
                                                                            e.stopPropagation();
                                                                            setCurrentImageIndex(i => i - 1);
                                                                        }}
                                                                    >
                                                                        ‹
                                                                    </button>
                                                                )}

                                                                {/* NEXT */}
                                                                {currentImageIndex < previewImages.length - 1 && (
                                                                    <button
                                                                        className="btn btn-dark position-fixed top-50 end-0 translate-middle-y me-3"
                                                                        style={{ zIndex: 1000000 }}
                                                                        onClick={(e) => {
                                                                            e.stopPropagation();
                                                                            setCurrentImageIndex(i => i + 1);
                                                                        }}
                                                                    >
                                                                        ›
                                                                    </button>
                                                                )}

                                                            </div>,
                                                            document.body   // 🔥 THIS IS THE KEY FIX
                                                        )
                                                    }

                                                </div>
                                            </div>


                                        </div>

                                        {/* ✅ RIGHT: Sidebar Info */}
                                        <aside className="tp-rsidebar">
                                            <div className="tp-rs__section">
                                                {/* Details section head */}
                                                <div className="tp-rs__section-head">
                                                    <span className="tp-rs__section-title">Details</span>
                                                    {/* Status */}
                                                    <div>
                                                        {editField === "status" ? (
                                                            <select
                                                                className="form-select form-select-sm"
                                                                value={activeTask.status}
                                                                onChange={(e) => {
                                                                    const newStatus = e.target.value;
                                                                    applyLocalTaskUpdate({ status: newStatus });
                                                                    updateTaskField(activeTask.id, "status", newStatus);
                                                                    setEditField(null);
                                                                }}
                                                                autoFocus
                                                            >
                                                                <option value="PENDING">To Do</option>
                                                                <option value="IN_PROGRESS">In Progress</option>
                                                                <option value="READY TO REVIEW"> Ready To Review</option>
                                                                <option value="READY TO TEST">Ready To Test</option>
                                                                <option value="IN TESTING">In Testing</option>
                                                                <option value="READY TO UPDATE">Ready To Update</option>
                                                                <option value="WAITING FOR CUSTOMER">Waiting For Customer</option>
                                                                <option value="COMPLETED">Completed</option>
                                                                <option value="CANCELLED">Cancelled</option>
                                                            </select>
                                                        ) : (
                                                            <span
                                                                className="badge"
                                                                style={{
                                                                    ...getStatusBadge(activeTask?.status),
                                                                    cursor: "pointer",
                                                                }}
                                                                onClick={() => setEditField("status")}
                                                            >
                                                                {activeTask?.status === "PENDING"
                                                                    ? "TO DO"
                                                                    : activeTask?.status?.replaceAll("_", " ") || "N/A"}
                                                            </span>



                                                        )}
                                                    </div>
                                                </div>

                                                {/* 🧩 Details Table */}
                                                <div className="table-responsive ">
                                                    <table className="table table-borderless align-middle mb-0">
                                                        <tbody>
                                                            {/* Task ID */}
                                                            <tr>
                                                                <th className="fw-semibold " style={{ width: "45%" }}> Task ID</th>
                                                                <td className="fw-normal text-start ">{activeTask.taskCode || ""}</td>
                                                            </tr>

                                                            {/* Project */}
                                                            {/* <tr>
                                                                    <th className="fw-semibold">Project</th>
                                                                    <td className="fw-normal text-start">
                                                                        {editField === "project" ? (
                                                                        <select
                                                                            className="form-select form-select-sm"
                                                                            value={activeTask.project?.id || ""}
                                                                            onChange={(e) => {
                                                                            const selectedId = e.target.value;
                                                                            setEditedTask({
                                                                                ...activeTask,
                                                                                project: projects.find((p) => p.id === Number(selectedId)),
                                                                            });
                                                                            updateTaskField(activeTask.id, "projectId", selectedId);
                                                                            setEditField(null);
                                                                            }}
                                                                            onBlur={() => setEditField(null)}
                                                                            autoFocus
                                                                        >
                                                                            <option value="">Select Project</option>
                                                                            {projects.map((p) => (
                                                                            <option key={p.id} value={p.id}>
                                                                                {p.name}
                                                                            </option>
                                                                            ))}
                                                                        </select>
                                                                        ) : (
                                                                        <span
                                                                            className="fw-normal text-start"
                                                                            style={{ cursor: "pointer" }}
                                                                            onClick={() => setEditField("project")}
                                                                        >
                                                                            {activeTask.project ? activeTask.project.name : "—"}
                                                                        </span>
                                                                        )}
                                                                    </td>
                                                                    </tr> */}

                                                            <tr>
                                                                <th className="fw-semibold">Project</th>
                                                                <td className="fw-normal text-start">
                                                                    <span >
                                                                        {activeTask?.project?.name || "—"}
                                                                    </span>
                                                                </td>
                                                            </tr>


                                                            {/* Due Date */}
                                                            <tr>
                                                                <th className="fw-semibold"> Due Date</th>
                                                                <td className="fw-normal text-start ">
                                                                    {editField === "dueDate" ? (
                                                                        <input
                                                                            type="date"
                                                                            className="form-control form-control-sm"
                                                                            // Controlled from editedTask with a safe fallback
                                                                            value={
                                                                                editedTask?.dueDate
                                                                                    ? new Date(editedTask.dueDate).toISOString().split("T")[0]
                                                                                    : ""
                                                                            }
                                                                            onChange={(e) =>
                                                                                setEditedTask(prev => ({ ...(prev || activeTask || {}), dueDate: e.target.value }))
                                                                            }
                                                                            onBlur={() => {
                                                                                // guard against activeTask being cleared before blur fires
                                                                                if (!activeTask) {
                                                                                    setEditField(null);
                                                                                    return;
                                                                                }

                                                                                // safe read with fallback
                                                                                const newDate = editedTask?.dueDate ?? "";
                                                                                const activeDate = activeTask?.dueDate
                                                                                    ? new Date(activeTask.dueDate).toISOString().split("T")[0]
                                                                                    : "";

                                                                                // only call update if the date actually changed
                                                                                if (newDate !== activeDate) {
                                                                                    updateTaskField(activeTask.id, "dueDate", newDate);
                                                                                }

                                                                                setEditField(null);
                                                                            }}
                                                                            autoFocus
                                                                        />
                                                                    ) : (
                                                                        <span
                                                                            style={{ cursor: "pointer" }}
                                                                            onClick={() => {
                                                                                // initialize editedTask when entering edit mode
                                                                                setEditedTask(activeTask ? { ...activeTask } : {});
                                                                                setEditField("dueDate");
                                                                            }}
                                                                        >
                                                                            {activeTask?.dueDate
                                                                                ? new Date(activeTask.dueDate).toLocaleDateString("en-GB")
                                                                                : "—"}
                                                                        </span>
                                                                    )}
                                                                </td>
                                                            </tr>


                                                            {/* Priority */}
                                                            <tr>
                                                                <th className="fw-semibold"> Priority</th>
                                                                <td className="fw-normal text-start ">
                                                                    {editField === "priority" ? (
                                                                        <select
                                                                            className="form-select form-select-sm"
                                                                            value={activeTask.priority || ""}
                                                                            onChange={(e) => {
                                                                                const priority = e.target.value;

                                                                                applyLocalTaskUpdate({ priority });
                                                                                updateTaskField(activeTask.id, "priority", priority);

                                                                                setEditField(null);
                                                                            }}
                                                                        >

                                                                            <option value="LOW">Low</option>
                                                                            <option value="MEDIUM">Medium</option>
                                                                            <option value="HIGH">High</option>
                                                                        </select>
                                                                    ) : (
                                                                        <span
                                                                            className={`badge ${normalize(activeTask.priority) === "high"
                                                                                ? "bg-danger"
                                                                                : normalize(activeTask.priority) === "medium"
                                                                                    ? "bg-warning text-dark"
                                                                                    : normalize(activeTask.priority) === "low"
                                                                                        ? "bg-secondary"
                                                                                        : "bg-secondary"
                                                                                }`}
                                                                            style={{ cursor: "pointer" }}
                                                                            onClick={() => setEditField("priority")}
                                                                        >
                                                                            {activeTask.priority || "Not set"}
                                                                        </span>

                                                                    )}
                                                                </td>
                                                            </tr>

                                                            {/* Task Type */}
                                                            <tr>
                                                                <th className="fw-semibold">Task Type</th>
                                                                <td className="fw-normal text-start">
                                                                    {editField === "taskType" ? (
                                                                        <select
                                                                            ref={selectRef}
                                                                            className="form-select form-select-sm"
                                                                            value={activeTask?.taskType ?? ""}
                                                                            onChange={(e) => {
                                                                                const newTaskType = e.target.value;

                                                                                //  instant UI update
                                                                                applyLocalTaskUpdate({ taskType: newTaskType });

                                                                                //  instant backend update
                                                                                updateTaskField(activeTask.id, "taskType", newTaskType);

                                                                                //  close edit immediately
                                                                                setEditField(null);
                                                                            }}
                                                                            autoFocus
                                                                        >
                                                                            <option value="">Select</option>
                                                                            <option value="Task">Task</option>
                                                                            <option value="Bug">Bug</option>
                                                                            <option value="Feature">Feature</option>
                                                                            <option value="Improvement">Improvement</option>
                                                                            {/* <option value="Research">Research</option>
                                                                                    <option value="Documentation">Documentation</option> */}
                                                                        </select>

                                                                    ) : (
                                                                        <span
                                                                            onClick={() => {
                                                                                // initialize editedTask if activeTask exists, then open editor
                                                                                if (activeTask) setEditedTask({ ...activeTask });
                                                                                setEditField("taskType");
                                                                            }}
                                                                            style={{ cursor: "pointer" }}
                                                                        >
                                                                            {activeTask?.taskType || "Click to select"}
                                                                        </span>
                                                                    )}
                                                                </td>
                                                            </tr>

                                                            {/* Parent Task */}
                                                            <tr>
                                                                <th className="fw-semibold">Parent</th>
                                                                <td className="fw-normal text-start">
                                                                    {editField === "parent" ? (
                                                                        <select
                                                                            className="form-select form-select-sm"
                                                                            value={editingParentId}
                                                                            autoFocus
                                                                            onChange={async (e) => {
                                                                                const val = e.target.value;
                                                                                const newParentId = val === "" ? null : Number(val);

                                                                                const resolvedParent =
                                                                                    newParentId == null
                                                                                        ? null
                                                                                        : parentTasks.find(p => p.id === newParentId) ?? { id: newParentId };

                                                                                // 🔥 update UI AFTER backend success
                                                                                try {
                                                                                    await updateTaskField(activeTask.id, "parentId", newParentId);

                                                                                    applyLocalTaskUpdate({
                                                                                        parent: resolvedParent
                                                                                    });

                                                                                } catch (err) {
                                                                                    console.error("Failed to update parent:", err);
                                                                                }

                                                                                setEditField(null);
                                                                            }}
                                                                        >
                                                                            <option value="">No Parent</option>

                                                                            {parentTasks
                                                                                .filter(p => p.id !== activeTask?.id)
                                                                                .filter(p => p.status !== "COMPLETED")
                                                                                .map(p => (
                                                                                    <option key={p.id} value={String(p.id)}>
                                                                                        {p.title}
                                                                                    </option>
                                                                                ))}

                                                                        </select>
                                                                    ) : (
                                                                        <span
                                                                            style={{ cursor: "pointer" }}
                                                                            onClick={() => {
                                                                                if (!activeTask) return;

                                                                                // ✅ initialize local select value
                                                                                setEditingParentId(
                                                                                    activeTask.parent?.id ? String(activeTask.parent.id) : ""
                                                                                );

                                                                                setEditField("parent");
                                                                            }}
                                                                        >
                                                                            {activeTask?.parent
                                                                                ? `${activeTask.parent.title}`
                                                                                : "Click to select"}
                                                                        </span>
                                                                    )}
                                                                </td>
                                                            </tr>





                                                            <tr>
                                                                <th className="fw-semibold">Team</th>
                                                                <td className="fw-normal text-start">
                                                                    {editField === "team" ? (
                                                                        <select
                                                                            className="form-select form-select-sm"
                                                                            value={activeTask?.team?.id ?? ""}
                                                                            disabled={!teams.length}
                                                                            autoFocus
                                                                            onChange={(e) => {
                                                                                const val = e.target.value;
                                                                                const teamId = val === "" ? null : Number(val);

                                                                                const selectedTeam =
                                                                                    teamId == null
                                                                                        ? null
                                                                                        : teams.find(t => t.id === teamId) || null;

                                                                                applyLocalTaskUpdate({ team: selectedTeam });
                                                                                updateTaskField(activeTask.id, "teamId", teamId);
                                                                                setEditField(null);
                                                                            }}
                                                                        >
                                                                            <option value="">
                                                                                {teams.length ? "Select Team" : "Loading teams..."}
                                                                            </option>

                                                                            {teams.map(team => (
                                                                                <option key={team.id} value={String(team.id)}>
                                                                                    {team.name}
                                                                                </option>
                                                                            ))}
                                                                        </select>
                                                                    ) : (
                                                                        <span
                                                                            style={{ cursor: "pointer" }}
                                                                            onClick={() => {
                                                                                if (!activeTask?.project?.id) return;
                                                                                setEditedTask({ ...activeTask });
                                                                                setEditField("team");
                                                                                fetchTeamsForProject(activeTask.project.id); // 🔥 key fix
                                                                            }}
                                                                        >
                                                                            {activeTask?.team ? activeTask.team.name : "Click to select"}
                                                                        </span>
                                                                    )}
                                                                </td>
                                                            </tr>




                                                            {/* Estimated Time */}
                                                            <tr>
                                                                <th className="fw-semibold">Estimated Time</th>
                                                                <td className="fw-normal text-start">
                                                                    {editField === "estimatedTime" ? (
                                                                        <input
                                                                            type="number"
                                                                            className="form-control form-control-sm"
                                                                            value={editedTask.estimatedTime || ""}
                                                                            onChange={(e) =>
                                                                                setEditedTask({ ...editedTask, estimatedTime: e.target.value })
                                                                            }
                                                                            onBlur={() => {
                                                                                updateTaskField(activeTask.id, "estimatedTime", editedTask.estimatedTime);
                                                                                setEditField(null);
                                                                            }}
                                                                            autoFocus
                                                                        />
                                                                    ) : (
                                                                        <span
                                                                            style={{ cursor: "pointer" }}
                                                                            onClick={() => {
                                                                                setEditedTask({ ...activeTask });
                                                                                setEditField("estimatedTime");
                                                                            }}
                                                                        >
                                                                            {activeTask.estimatedTime || 0} hr
                                                                        </span>
                                                                    )}
                                                                </td>
                                                            </tr>

                                                            {/* Total Logged Time */}
                                                            {/* <tr>
                                                                <th className="fw-semibold"> Total Time</th>
                                                                <td className="fw-normal text-start ">{activeTask.totalTime || 0} hr</td>
                                                                </tr> */}

                                                            {/* Assignee */}
                                                            <tr>
                                                                <th className="fw-semibold">Assignee</th>
                                                                <td>
                                                                    {editField === "assignee" ? (
                                                                        <select
                                                                            className="form-select form-select-sm"
                                                                            value={
                                                                                activeTask.assignedTo
                                                                                    ? String(activeTask.assignedTo.id)
                                                                                    : "UNASSIGNED"
                                                                            }
                                                                            onChange={(e) => {
                                                                                const value = e.target.value;

                                                                                //decode value
                                                                                const empId =
                                                                                    value === "UNASSIGNED" ? null : Number(value);

                                                                                const emp =
                                                                                    empId == null
                                                                                        ? null
                                                                                        : projectEmployees.find(x => x.id === empId) || null;

                                                                                //instant UI update
                                                                                applyLocalTaskUpdate({ assignedTo: emp });

                                                                                //backend update
                                                                                updateTaskField(activeTask.id, "employeeId", empId);

                                                                                setEditField(null);
                                                                            }}
                                                                        >
                                                                            {/* Placeholder (not selectable) */}
                                                                            <option value="" disabled>
                                                                                {activeTask.project ? "Select Assignee" : "Select project first"}
                                                                            </option>

                                                                            {/* Unassigned option */}
                                                                            <option value="UNASSIGNED">Unassigned</option>

                                                                            {/* Employees */}
                                                                            {projectEmployees.map(emp => (
                                                                                <option key={emp.id} value={String(emp.id)}>
                                                                                    {emp.firstName} {emp.lastName}
                                                                                </option>
                                                                            ))}
                                                                        </select>
                                                                    ) : activeTask.assignedTo ? (
                                                                        <div
                                                                            className="d-flex align-items-center gap-2"
                                                                            style={{ cursor: "pointer" }}
                                                                            onClick={() => setEditField("assignee")}
                                                                        >
                                                                            <img
                                                                                src={
                                                                                    activeTask.assignedTo.photoPath
                                                                                        ? `/uploads/${activeTask.assignedTo.photoPath}`
                                                                                        : "/default-avatar.png"
                                                                                }
                                                                                alt="Assignee"
                                                                                className="rounded-circle border border-2 border-white"
                                                                                style={{ width: "26px", height: "26px", objectFit: "cover" }}
                                                                            />
                                                                            <span className="fw-normal">
                                                                                {activeTask.assignedTo.firstName}{" "}
                                                                                {activeTask.assignedTo.lastName}
                                                                            </span>
                                                                        </div>
                                                                    ) : (
                                                                        <span
                                                                            style={{ cursor: "pointer", color: "#6c757d" }}
                                                                            onClick={() => setEditField("assignee")}
                                                                        >
                                                                            Unassigned
                                                                        </span>
                                                                    )}
                                                                </td>
                                                            </tr>


                                                            {/* Reporter */}
                                                            <tr>
                                                                <th className="fw-semibold"> Reporter</th>
                                                                <td>
                                                                    {activeTask.reporter ? (
                                                                        <div className="d-flex align-items-center gap-2">
                                                                            <img
                                                                                src={
                                                                                    activeTask.reporter.photoPath
                                                                                        ? `/uploads/${activeTask.reporter.photoPath}`
                                                                                        : "/default-avatar.png"
                                                                                }
                                                                                alt="Reporter"
                                                                                className="rounded-circle border border-2 border-white"
                                                                                style={{ width: "26px", height: "26px", objectFit: "cover" }}
                                                                            />
                                                                            <span className="fw-normal text-start">
                                                                                {activeTask.reporter.firstName} {activeTask.reporter.lastName}
                                                                            </span>
                                                                        </div>
                                                                    ) : (
                                                                        <span className="fw-normal text-start ">Unassigned</span>
                                                                    )}
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                            {/* TimeStack card — COLLAPSIBLE */}
                                            <div className="tp-rs__section mt-2">
                                                <div
                                                    className="tp-rs__section-head"
                                                    onClick={() => setTimeStackOpen(prev => !prev)}
                                                    style={{ cursor: "pointer" }}
                                                >
                                                    <span className="tp-rs__section-title">TimeStack</span>
                                                    <i className={`bi ${timeStackOpen ? "bi-chevron-up" : "bi-chevron-down"} tp-rs__chevron`} />
                                                </div>
                                                <div
                                                    className="tp-rs__section-body"
                                                    style={{ display: timeStackOpen ? "block" : "none" }}
                                                >
                                                    <div className="tp-rs__time-row">
                                                        <span className="tp-rs__time-label">Estimated</span>
                                                        <span className="tp-rs__time-val">{activeTask?.estimatedTime ? `${estimatedHrs}h` : "—"}</span>
                                                    </div>
                                                    <div className="tp-rs__time-row">
                                                        <span className="tp-rs__time-label">Remaining</span>
                                                        <span className="tp-rs__time-val">{activeTask?.estimatedTime ? `${remainingHrs}h` : "—"}</span>
                                                    </div>
                                                    <div className="tp-rs__time-row">
                                                        <span className="tp-rs__time-label">Logged</span>
                                                        <span className="tp-rs__time-val">{loggedHrs > 0 ? `${loggedHrs}h` : "0h"}</span>
                                                    </div>
                                                    <div className="tp-rs__time-row">
                                                        <span className="tp-rs__time-label">Total</span>
                                                        <span className="tp-rs__time-val">
                                                            {taskTotalHrs == null ? "—" : taskTotalHrs > 0 ? `${taskTotalHrs}h` : "0h"}
                                                        </span>
                                                    </div>
                                                    {estimatedHrs > 0 && (
                                                        <div className="tp-rs__progress-bar" style={{ marginTop: 10 }}>
                                                            <div
                                                                className="tp-rs__progress-fill"
                                                                style={{ width: `${Math.min(100, (loggedHrs / estimatedHrs) * 100)}%` }}
                                                            />
                                                        </div>
                                                    )}

                                                    {/* 🔥 Employee-wise logs */}
                                                    {employeeLogs.length > 0 && (
                                                        <div style={{ marginTop: 12 }}>
                                                            <div style={{
                                                                fontSize: 11,
                                                                fontWeight: 700,
                                                                color: "#6B778C",
                                                                marginBottom: 6
                                                            }}>
                                                                Logged by
                                                            </div>

                                                            {employeeLogs.map(emp => (
                                                                <div key={emp.id} style={{
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    justifyContent: "space-between",
                                                                    marginBottom: 6
                                                                }}>
                                                                    {/* Left */}
                                                                    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                                                        <div style={{
                                                                            width: 22,
                                                                            height: 22,
                                                                            borderRadius: "50%",
                                                                            overflow: "hidden",
                                                                            background: "#DFE1E6",
                                                                            display: "flex",
                                                                            alignItems: "center",
                                                                            justifyContent: "center",
                                                                            fontSize: 10,
                                                                            fontWeight: 600,
                                                                            color: "#fff"
                                                                        }}>
                                                                            {emp.photo ? (
                                                                                <img
                                                                                    src={`${API_BASE_URL}/uploads/${emp.photo}`}
                                                                                    alt=""
                                                                                    style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                                                                />
                                                                            ) : (
                                                                                emp.name?.[0] || "U"
                                                                            )}
                                                                        </div>

                                                                        <span style={{ fontSize: 12, color: "#172B4D" }}>
                                                                            {emp.name}
                                                                        </span>
                                                                    </div>

                                                                    {/* Right */}
                                                                    <span style={{
                                                                        fontSize: 12,
                                                                        fontWeight: 600,
                                                                        color: "#0052CC"
                                                                    }}>
                                                                        {emp.hours.toFixed(1)}h
                                                                    </span>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                            {/* END TimeStack */}

                                        </aside>
                                        {/* END tp-rsidebar */}

                                    </div>
                                    {/* END tp-task-columns */}
                                </>
                            ) : (
                                <div className="text-center mt-5">
                                    <div style={{ fontSize: "42px" }}>⚠️</div>
                                    <h5 className="mt-3">Task unavailable</h5>
                                    <p className="text-muted mb-3">
                                        The task could not be found or you don't have access.
                                    </p>
                                    <button
                                        className="btn btn-primary btn-sm"
                                        onClick={handleBoardNavigation}
                                    >
                                        Go back to board
                                    </button>
                                </div>
                            )}
                        </div>
                        {/* END tp-task-body */}

                    </main>
                    {/* END tp-main-content */}

                </div>
                {/* END tp-shell */}
            </div>
            {/* END tp-root */}




            {showLinkEditor && (
                <div
                    style={{
                        position: "fixed",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        background: "#ffffff",
                        padding: "16px",
                        borderRadius: "12px",
                        boxShadow: "0 15px 40px rgba(0,0,0,0.25)",
                        zIndex: 9999,
                        width: "340px",
                        fontFamily:
                            'system-ui, -apple-system, "Segoe UI", Roboto, sans-serif',
                    }}
                >
                    <div style={{ marginBottom: 12 }}>
                        <strong style={{ fontSize: 15 }}>Edit link</strong>
                    </div>

                    <div style={{ marginBottom: 10 }}>
                        <label style={{ fontSize: 12, color: "#555" }}>Text</label>
                        <input
                            value={linkText}
                            onChange={(e) => setLinkText(e.target.value)}
                            placeholder="Link text"
                            style={{
                                width: "100%",
                                padding: "8px 10px",
                                borderRadius: "8px",
                                border: "1px solid #ddd",
                                outline: "none",
                                fontSize: "14px",
                            }}
                        />
                    </div>

                    <div style={{ marginBottom: 14 }}>
                        <label style={{ fontSize: 12, color: "#555" }}>URL</label>
                        <input
                            value={linkHref}
                            onChange={(e) => setLinkHref(e.target.value)}
                            placeholder="https://example.com"
                            style={{
                                width: "100%",
                                padding: "8px 10px",
                                borderRadius: "8px",
                                border: "1px solid #ddd",
                                outline: "none",
                                fontSize: "14px",
                            }}
                        />
                    </div>

                    <div
                        style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            gap: 8,
                        }}
                    >
                        <button
                            onClick={() => setShowLinkEditor(false)}
                            style={{
                                padding: "6px 12px",
                                borderRadius: "6px",
                                border: "1px solid #ddd",
                                background: "#f5f5f5",
                                cursor: "pointer",
                            }}
                        >
                            Cancel
                        </button>

                        <button
                            onClick={applyLinkEdit}
                            style={{
                                padding: "6px 14px",
                                borderRadius: "6px",
                                border: "none",
                                background: "#4f46e5",
                                color: "#fff",
                                cursor: "pointer",
                            }}
                        >
                            Save
                        </button>
                    </div>
                </div>
            )}





            {/* ═══ EMOJI PICKER PORTAL — single instance, used by all 4 emoji buttons ═══ */}
            {showEmojiPortal && activeEmojiHandler && createPortal(
                <div
                    ref={emojiPickerRef}
                    style={{
                        position: "fixed",
                        top: emojiPopupPos.top,
                        left: emojiPopupPos.left,
                        zIndex: 99999,
                    }}
                >
                    <EmojiPicker
                        onEmojiClick={(emojiData) => {
                            activeEmojiHandler(emojiData);
                            setShowEmojiPortal(false);
                        }}
                    />
                </div>,
                document.body
            )}

            {/* ═══ MENTION POPUP — rendered via Portal to document.body ═══
                This completely escapes tp-root's overflow:hidden and any
                transform/fixed containing blocks in the component tree.      */}
            {showSuggestions && filteredUsers.length > 0 && createPortal(
                <div
                    style={{
                        position: "fixed",
                        top: mentionPopupPos.top,
                        left: mentionPopupPos.left,
                        zIndex: 99999,
                        background: "#fff",
                        border: "1px solid #DFE1E6",
                        borderRadius: "8px",
                        width: editorRef.current
                            ? Math.min(editorRef.current.getBoundingClientRect().width, 340)
                            : 300,
                        maxHeight: "260px",
                        overflowY: "auto",
                        boxShadow: "0 8px 24px rgba(9,30,66,0.18)",
                    }}
                >
                    {filteredUsers.map((u, i) => {
                        const photoUrl = u.photoPath ? `${API_BASE_URL}/uploads/${u.photoPath}` : null;
                        const isActive = i === activeMentionIndex;
                        return (
                            <button
                                key={u.id}
                                type="button"
                                onMouseEnter={() => setActiveMentionIndex(i)}
                                onMouseDown={(e) => {
                                    e.preventDefault();
                                    addMention(u);
                                    setShowSuggestions(false);
                                }}
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    width: "100%",
                                    padding: "8px 14px",
                                    border: "none",
                                    borderBottom: i < filteredUsers.length - 1 ? "1px solid #f0f0f0" : "none",
                                    background: isActive ? "#EEF2FF" : "transparent",
                                    cursor: "pointer",
                                    textAlign: "left",
                                    gap: "10px",
                                }}
                            >
                                <div style={{
                                    width: 34, height: 34, borderRadius: "50%",
                                    overflow: "hidden", flexShrink: 0,
                                    background: photoUrl ? "transparent" : "linear-gradient(135deg,#0d6efd,#5a9eff)",
                                    display: "flex", alignItems: "center", justifyContent: "center",
                                    fontWeight: 600, fontSize: 14, color: "#fff",
                                }}>
                                    {photoUrl
                                        ? <img src={photoUrl} alt="" style={{ width: "100%", height: "100%", objectFit: "cover" }} onError={e => { e.currentTarget.onerror = null; e.currentTarget.src = "/images/avatar-placeholder.png"; }} />
                                        : u.firstName.charAt(0).toUpperCase()
                                    }
                                </div>
                                <div style={{ fontSize: 14, fontWeight: 500, color: "#172B4D" }}>
                                    {u.firstName} {u.lastName}
                                </div>
                            </button>
                        );
                    })}
                </div>,
                document.body
            )}



        </>
    );
};



export default Tasks;